export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
}

export interface IAcceptPoliciesInput {
  platform: Scalars['String']['input'];
  /** Client idempotency key. */
  requestId?: InputMaybe<Scalars['String']['input']>;
  /** Version ids exactly as displayed. */
  versionIds: Array<Scalars['ID']['input']>;
}

/** Accuracy issues that guests can report */
export enum AccuracyDefectEnum {
  DifferentCar = 'DIFFERENT_CAR',
  FeaturesMissing = 'FEATURES_MISSING',
  Others = 'OTHERS',
  PhotosInaccurate = 'PHOTOS_INACCURATE',
  ShowedUpLate = 'SHOWED_UP_LATE'
}

export interface IAccuracyRating {
  __typename?: 'AccuracyRating';
  improve?: Maybe<Array<AccuracyDefectEnum>>;
  score: Scalars['Int']['output'];
}

export interface IAccuracyRatingInput {
  improve?: InputMaybe<Array<AccuracyDefectEnum>>;
  score: Scalars['Int']['input'];
}

export interface IAddAdminNotesInput {
  claimId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
}

export interface IAddCarToSellingInput {
  carId: Scalars['String']['input'];
  dealerId: Scalars['String']['input'];
  listedSalePrice?: InputMaybe<Scalars['Float']['input']>;
}

export interface IAddDriverInput {
  bookingId: Scalars['String']['input'];
  driverEmail: Scalars['String']['input'];
}

/** Result of requesting an additional driver for a booking */
export enum AddDriverOutcome {
  Added = 'ADDED',
  DriverAlreadyAdded = 'DRIVER_ALREADY_ADDED',
  DriverDlExpired = 'DRIVER_DL_EXPIRED',
  DriverDlPending = 'DRIVER_DL_PENDING',
  DriverDlRejected = 'DRIVER_DL_REJECTED',
  DriverNeedsDlVerification = 'DRIVER_NEEDS_DL_VERIFICATION',
  InvitationSent = 'INVITATION_SENT'
}

export interface IAddDriverToBookingResult {
  __typename?: 'AddDriverToBookingResult';
  booking?: Maybe<IBooking>;
  driver?: Maybe<IUser>;
  invitationId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  outcome: AddDriverOutcome;
}

export interface IAddFavoriteInput {
  carId: Scalars['String']['input'];
}

export interface IAddOnChoiceInput {
  code: Scalars['String']['input'];
  quantity?: Scalars['Int']['input'];
}

export enum AddOnStatus {
  Approved = 'APPROVED',
  AutoApproved = 'AUTO_APPROVED',
  Expired = 'EXPIRED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export interface IAdditionalDriver {
  __typename?: 'AdditionalDriver';
  createdAt: Scalars['DateTime']['output'];
  driverId: Scalars['ID']['output'];
}

export interface IAdditionalDriverAcceptance {
  __typename?: 'AdditionalDriverAcceptance';
  accepted: Scalars['Boolean']['output'];
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  driverId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface IAdminPolicyDocument {
  __typename?: 'AdminPolicyDocument';
  current?: Maybe<IPolicyVersion>;
  /** The default this brand falls back to, when it has no version of its own. */
  defaultVersion?: Maybe<IPolicyVersion>;
  draft?: Maybe<IPolicyVersion>;
  kind: PolicyKind;
  ownedByBrand: Scalars['Boolean']['output'];
  scope: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface IAdminRelistCarInput {
  carId: Scalars['ID']['input'];
  /** Every campaign on the hold, or RECALL_RELIST_INCOMPLETE */
  clearedCampaignNumbers: Array<Scalars['String']['input']>;
  /** Keys from createPresignedUrlForRecallEvidence; at least one for an OPEN_RECALL hold */
  evidenceKeys: Array<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}

export interface IAirportSearchResults {
  __typename?: 'AirportSearchResults';
  airportContext?: Maybe<ILocation>;
  atAirportCars: Array<ICarWithPricing>;
  isAirportSearch: Scalars['Boolean']['output'];
  offAirportCars: Array<ICarWithPricingAndDistance>;
}

export interface IAllowedLocation {
  __typename?: 'AllowedLocation';
  fee: Scalars['Float']['output'];
  fromLocation: ILocation;
  fromLocationId: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  toLocation: ILocation;
  toLocationId: Scalars['Float']['output'];
}

export interface IAllowedLocationInput {
  fee: Scalars['Float']['input'];
  fromLocationId: Scalars['Int']['input'];
  isActive?: Scalars['Boolean']['input'];
  toLocationId: Scalars['Int']['input'];
}

export interface IAllowedToDriveTrip {
  __typename?: 'AllowedToDriveTrip';
  addedAsDriverAt?: Maybe<Scalars['DateTime']['output']>;
  agreementAccepted: Scalars['Boolean']['output'];
  agreementVersionId?: Maybe<Scalars['ID']['output']>;
  carMake?: Maybe<Scalars['String']['output']>;
  carModel?: Maybe<Scalars['String']['output']>;
  carYear?: Maybe<Scalars['Int']['output']>;
  endAt: Scalars['DateTime']['output'];
  lastFiveVin?: Maybe<Scalars['String']['output']>;
  mainDriverName?: Maybe<Scalars['String']['output']>;
  pickupCity?: Maybe<Scalars['String']['output']>;
  plateNumber?: Maybe<Scalars['String']['output']>;
  returnCity?: Maybe<Scalars['String']['output']>;
  startAt: Scalars['DateTime']['output'];
  tripId: Scalars['ID']['output'];
}

export interface IAmountPaidToPublicOfficials {
  __typename?: 'AmountPaidToPublicOfficials';
  caTireFee?: Maybe<Scalars['Float']['output']>;
  others?: Maybe<Array<IOtherWithDescription>>;
  registerNTransferFee?: Maybe<Scalars['Float']['output']>;
  totalOfficialFee?: Maybe<Scalars['Float']['output']>;
  vehicleLicenseFee?: Maybe<Scalars['Float']['output']>;
}

export interface IAmountPaidToPublicOfficialsInput {
  caTireFee?: InputMaybe<Scalars['Float']['input']>;
  others?: InputMaybe<Array<IOtherWithDescriptionInput>>;
  registerNTransferFee?: InputMaybe<Scalars['Float']['input']>;
  totalOfficialFee?: InputMaybe<Scalars['Float']['input']>;
  vehicleLicenseFee?: InputMaybe<Scalars['Float']['input']>;
}

export interface IAppFeatureDefinition {
  __typename?: 'AppFeatureDefinition';
  defaultEnabled: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  group: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
}

export interface IAppFeatureMatrix {
  __typename?: 'AppFeatureMatrix';
  brands: Array<IBrandAppFeatureRow>;
  features: Array<IAppFeatureDefinition>;
}

export interface IAppFeatures {
  __typename?: 'AppFeatures';
  environmentSwitch: Scalars['Boolean']['output'];
  fontPicker: Scalars['Boolean']['output'];
  themePicker: Scalars['Boolean']['output'];
}

/** Whether coupon applies by date or trip */
export enum ApplyByDateOrTripEnum {
  Day = 'DAY',
  Trip = 'TRIP'
}

/** Which price the coupon applies to */
export enum ApplyToPriceOfEnum {
  DailyPrice = 'DAILY_PRICE',
  TotalPrice = 'TOTAL_PRICE'
}

export interface IApproximateLocation {
  __typename?: 'ApproximateLocation';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  radiusMeters: Scalars['Int']['output'];
}

export interface IAuthResponse {
  __typename?: 'AuthResponse';
  accessToken: Scalars['String']['output'];
  authProvider?: Maybe<Scalars['String']['output']>;
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  sessionRefreshMode?: Maybe<Scalars['String']['output']>;
  user: IUser;
}

export interface IAutocompletePrediction {
  __typename?: 'AutocompletePrediction';
  description: Scalars['String']['output'];
  mainText: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  secondaryText: Scalars['String']['output'];
}

export interface IAvailabilityPeriodInput {
  endAt: Scalars['Float']['input'];
  startAt: Scalars['Float']['input'];
}

export interface IAvailabilityResponse {
  __typename?: 'AvailabilityResponse';
  isAvailable: Scalars['Boolean']['output'];
}

export interface IBackgroundCheckInput {
  completedAt: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  fileKey: Scalars['String']['input'];
  vendor: Scalars['String']['input'];
}

export interface IBackgroundCheckView {
  __typename?: 'BackgroundCheckView';
  completedAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  vendor: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
}

export interface IBookedTimeSlot {
  __typename?: 'BookedTimeSlot';
  endAt: Scalars['Float']['output'];
  startAt: Scalars['Float']['output'];
}

export interface IBooking {
  __typename?: 'Booking';
  /** Trip guest, host, the brand's admins and the platform owner. */
  acceptedPolicies: Array<IPolicyAcceptanceRecord>;
  activities?: Maybe<Array<IBookingActivity>>;
  actualReturnAt?: Maybe<Scalars['DateTime']['output']>;
  /** Same viewers (FR-036). */
  additionalDriverAcceptances: Array<IAdditionalDriverAcceptance>;
  additionalDriverDetails: Array<IUser>;
  additionalDrivers?: Maybe<Array<IAdditionalDriver>>;
  /** Same viewers. Sequence 1 is the confirmation accepted at checkout; later rows are amendments (FR-030 to FR-041). */
  agreementRecords: Array<IRentalAgreementRecord>;
  appliedExtraMileage?: Maybe<Scalars['Int']['output']>;
  brandSite?: Maybe<Scalars['String']['output']>;
  canStartTripField?: Maybe<Scalars['Boolean']['output']>;
  canSubmitDlVerificationField?: Maybe<Scalars['Boolean']['output']>;
  cancellationPolicySnapshot?: Maybe<StayCancellationPolicy>;
  cancellationReason?: Maybe<CancellationReason>;
  cancellationRules?: Maybe<IBookingCancellationRules>;
  cancelledInitiatedAt?: Maybe<Scalars['DateTime']['output']>;
  car?: Maybe<ICar>;
  carId: Scalars['String']['output'];
  computedExtraMileage?: Maybe<Scalars['Int']['output']>;
  consecutiveExtensionDeclines: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultPaymentMethodId?: Maybe<Scalars['String']['output']>;
  deletedTripEndImages?: Maybe<Array<IBookingImage>>;
  deletedTripStartImages?: Maybe<Array<IBookingImage>>;
  dlPhoto?: Maybe<Scalars['String']['output']>;
  /** The guest's pickup licence photo, a link valid for 15 minutes (guest, host, admins). */
  dlPhotoUrl?: Maybe<Scalars['String']['output']>;
  dlRejectionReason?: Maybe<Scalars['String']['output']>;
  dlSelfieDeletedAt?: Maybe<Scalars['DateTime']['output']>;
  dlSelfiePhoto?: Maybe<Scalars['String']['output']>;
  /** The guest's pickup selfie, a link valid for 15 minutes; null once deleted after 30 days. */
  dlSelfiePhotoUrl?: Maybe<Scalars['String']['output']>;
  dlSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  dlVerificationStatus?: Maybe<DlVerificationStatus>;
  dlVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  endAt: Scalars['Float']['output'];
  extensionBlocked: Scalars['Boolean']['output'];
  extraMileageChargeAmount?: Maybe<Scalars['Float']['output']>;
  extraMileageChargedAt?: Maybe<Scalars['DateTime']['output']>;
  extraMileageInvoiceId?: Maybe<Scalars['String']['output']>;
  firstPriorityHostCalcExMileage?: Maybe<Scalars['Int']['output']>;
  governingAgreement?: Maybe<IGoverningAgreement>;
  guest?: Maybe<IUser>;
  guestCheckinAt?: Maybe<Scalars['DateTime']['output']>;
  guestCheckoutAt?: Maybe<Scalars['DateTime']['output']>;
  guestCounts?: Maybe<IGuestCounts>;
  guestDisplayName?: Maybe<Scalars['String']['output']>;
  guestFinishedCheckin?: Maybe<Scalars['Boolean']['output']>;
  guestFinishedCheckout?: Maybe<Scalars['Boolean']['output']>;
  guestId: Scalars['String']['output'];
  guestInstructions?: Maybe<Scalars['String']['output']>;
  handoverJob?: Maybe<IHandoverJobSummary>;
  handoverServicesSite?: Maybe<Scalars['String']['output']>;
  host?: Maybe<IUser>;
  hostCheckinAt?: Maybe<Scalars['DateTime']['output']>;
  hostCheckoutAt?: Maybe<Scalars['DateTime']['output']>;
  hostDisplayName?: Maybe<Scalars['String']['output']>;
  hostFinishedCheckin?: Maybe<Scalars['Boolean']['output']>;
  hostFinishedCheckout?: Maybe<Scalars['Boolean']['output']>;
  hostId: Scalars['String']['output'];
  hostRespondedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoices: Array<IInvoice>;
  isCancellationPenaltyApplied: Scalars['Boolean']['output'];
  isCancellationPenaltyWaivedByHost: Scalars['Boolean']['output'];
  isReviewed: Scalars['Boolean']['output'];
  isShortenTripPenaltyWaivedByHost: Scalars['Boolean']['output'];
  lateReturnHours?: Maybe<Scalars['Int']['output']>;
  maximumRentalDays?: Maybe<Scalars['Int']['output']>;
  minimumRentalDays?: Maybe<Scalars['Int']['output']>;
  originalCar?: Maybe<ICar>;
  originalCarId?: Maybe<Scalars['String']['output']>;
  outstandingPostTripInvoices: Array<IInvoice>;
  paymentSummary?: Maybe<IPaymentSummary>;
  paymentVerified?: Maybe<Scalars['Boolean']['output']>;
  pickupLocation?: Maybe<ILocation>;
  pickupLocationId: Scalars['Float']['output'];
  postTripFuelLevel?: Maybe<Scalars['Int']['output']>;
  postTripMileage?: Maybe<Scalars['Int']['output']>;
  preTripFuelLevel?: Maybe<Scalars['Int']['output']>;
  preTripMileage?: Maybe<Scalars['Int']['output']>;
  productType: ProductType;
  protectionPlan?: Maybe<ProtectionPlanEnum>;
  protectionPlanEntity?: Maybe<IProtectionPlan>;
  protectionPlanId?: Maybe<Scalars['String']['output']>;
  protectionPlanSnapshot?: Maybe<IProtectionPlanSnapshot>;
  receipt: IReceipt;
  referralCommission?: Maybe<IReferralCommission>;
  referringBrandSite?: Maybe<Scalars['String']['output']>;
  rentalType: RentalTypeEnum;
  requestExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  requestMessage?: Maybe<Scalars['String']['output']>;
  returnLocation?: Maybe<ILocation>;
  returnLocationId: Scalars['Float']['output'];
  securityDepositAmount?: Maybe<Scalars['Float']['output']>;
  securityDepositAutoReleaseScheduled?: Maybe<Scalars['Boolean']['output']>;
  securityDepositCardType?: Maybe<Scalars['String']['output']>;
  securityDepositHeldUntil?: Maybe<Scalars['DateTime']['output']>;
  securityDepositHoldReason?: Maybe<Scalars['String']['output']>;
  securityDepositHoldRequested?: Maybe<Scalars['Boolean']['output']>;
  securityDepositPaymentIntentId?: Maybe<Scalars['String']['output']>;
  securityDepositPaymentMethodId?: Maybe<Scalars['String']['output']>;
  securityDepositReleaseReason?: Maybe<Scalars['String']['output']>;
  securityDepositStatus?: Maybe<SecurityDepositStatus>;
  serviceJob?: Maybe<IServiceJobInfo>;
  shortId?: Maybe<Scalars['String']['output']>;
  startAt: Scalars['Float']['output'];
  status: BookingStatus;
  stayInstructionsAvailableAt?: Maybe<Scalars['DateTime']['output']>;
  swapApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  swapCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  swapHistory?: Maybe<Array<ICarSwap>>;
  swapNote?: Maybe<Scalars['String']['output']>;
  swapRejectedAt?: Maybe<Scalars['DateTime']['output']>;
  swapRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  swapRequestedBy?: Maybe<Scalars['String']['output']>;
  swapRequestedCar?: Maybe<ICar>;
  swapRequestedCarId?: Maybe<Scalars['String']['output']>;
  swapResponseDeadline?: Maybe<Scalars['DateTime']['output']>;
  swapStartTime?: Maybe<Scalars['Float']['output']>;
  swapStatus?: Maybe<CarSwapStatus>;
  taxLabel: Scalars['String']['output'];
  tripEndImages?: Maybe<Array<IBookingImage>>;
  tripStartImages?: Maybe<Array<IBookingImage>>;
  updatedAt: Scalars['DateTime']['output'];
}

export interface IBookingActivity {
  __typename?: 'BookingActivity';
  activityType: BookingActivityType;
  amount?: Maybe<Scalars['Float']['output']>;
  booking: IBooking;
  bookingId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiatedBy: Scalars['String']['output'];
  initiatedByUser?: Maybe<IUser>;
  invoice?: Maybe<IInvoice>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  newState?: Maybe<Scalars['JSON']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  previousState?: Maybe<Scalars['JSON']['output']>;
}

/** Types of activities/events that can occur on a booking */
export enum BookingActivityType {
  ActualReturnUpdated = 'ACTUAL_RETURN_UPDATED',
  BookingConfirmed = 'BOOKING_CONFIRMED',
  BookingCreated = 'BOOKING_CREATED',
  BookingRefusedBrandClosed = 'BOOKING_REFUSED_BRAND_CLOSED',
  CancellationPenaltyWaived = 'CANCELLATION_PENALTY_WAIVED',
  CancelledByAdmin = 'CANCELLED_BY_ADMIN',
  CancelledByGuest = 'CANCELLED_BY_GUEST',
  CancelledByHost = 'CANCELLED_BY_HOST',
  CarSwapApproved = 'CAR_SWAP_APPROVED',
  CarSwapCompleted = 'CAR_SWAP_COMPLETED',
  CarSwapExpired = 'CAR_SWAP_EXPIRED',
  CarSwapRejected = 'CAR_SWAP_REJECTED',
  CarSwapRequested = 'CAR_SWAP_REQUESTED',
  CouponApplied = 'COUPON_APPLIED',
  DamageClaimApproved = 'DAMAGE_CLAIM_APPROVED',
  DamageClaimRejected = 'DAMAGE_CLAIM_REJECTED',
  DamageClaimResolved = 'DAMAGE_CLAIM_RESOLVED',
  DamageClaimSubmitted = 'DAMAGE_CLAIM_SUBMITTED',
  DepositAuthorized = 'DEPOSIT_AUTHORIZED',
  DepositCaptured = 'DEPOSIT_CAPTURED',
  DepositCharged = 'DEPOSIT_CHARGED',
  DepositCollected = 'DEPOSIT_COLLECTED',
  DepositHoldRequested = 'DEPOSIT_HOLD_REQUESTED',
  DepositPartiallyReleased = 'DEPOSIT_PARTIALLY_RELEASED',
  DepositReleased = 'DEPOSIT_RELEASED',
  DlVerificationRejected = 'DL_VERIFICATION_REJECTED',
  DlVerificationSubmitted = 'DL_VERIFICATION_SUBMITTED',
  DlVerificationVerified = 'DL_VERIFICATION_VERIFIED',
  DriverAdded = 'DRIVER_ADDED',
  DriverRemoved = 'DRIVER_REMOVED',
  ExtraMileageAdjusted = 'EXTRA_MILEAGE_ADJUSTED',
  ExtraMileageCharged = 'EXTRA_MILEAGE_CHARGED',
  GuestCheckinCompleted = 'GUEST_CHECKIN_COMPLETED',
  GuestCheckoutCompleted = 'GUEST_CHECKOUT_COMPLETED',
  HostCheckinCompleted = 'HOST_CHECKIN_COMPLETED',
  HostCheckoutCompleted = 'HOST_CHECKOUT_COMPLETED',
  IncidentChargeCreated = 'INCIDENT_CHARGE_CREATED',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentReceived = 'PAYMENT_RECEIVED',
  ProtectionPlanChanged = 'PROTECTION_PLAN_CHANGED',
  RefundCompleted = 'REFUND_COMPLETED',
  RefundFailed = 'REFUND_FAILED',
  RefundInitiated = 'REFUND_INITIATED',
  StayModified = 'STAY_MODIFIED',
  StayRequestAccepted = 'STAY_REQUEST_ACCEPTED',
  StayRequestDeclined = 'STAY_REQUEST_DECLINED',
  StayRequestExpired = 'STAY_REQUEST_EXPIRED',
  StayRequestSubmitted = 'STAY_REQUEST_SUBMITTED',
  StayRequestWithdrawn = 'STAY_REQUEST_WITHDRAWN',
  TripCompleted = 'TRIP_COMPLETED',
  TripEndPhotoUploaded = 'TRIP_END_PHOTO_UPLOADED',
  TripExtended = 'TRIP_EXTENDED',
  TripShortened = 'TRIP_SHORTENED',
  TripStarted = 'TRIP_STARTED',
  TripStartPhotoUploaded = 'TRIP_START_PHOTO_UPLOADED'
}

export interface IBookingCancellationRules {
  __typename?: 'BookingCancellationRules';
  freeCancellationAdvanceHours: Scalars['Float']['output'];
  gracePeriodHours: Scalars['Float']['output'];
  lateCancellationFee: Scalars['JSON']['output'];
  processingFeePercent: Scalars['Float']['output'];
  shortenRule: Scalars['JSON']['output'];
  stackLateFeeWithProcessingFee: Scalars['Boolean']['output'];
}

export interface IBookingImage {
  __typename?: 'BookingImage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedByName?: Maybe<Scalars['String']['output']>;
  uploadedBy?: Maybe<Scalars['String']['output']>;
  uploadedByName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
}

export enum BookingMode {
  Instant = 'INSTANT',
  Request = 'REQUEST'
}

export interface IBookingPaymentOptions {
  __typename?: 'BookingPaymentOptions';
  cards: Array<ISavedPaymentMethod>;
  consecutiveExtensionDeclines: Scalars['Int']['output'];
  extensionBlocked: Scalars['Boolean']['output'];
  preferredPaymentMethodId?: Maybe<Scalars['String']['output']>;
}

export interface IBookingState {
  __typename?: 'BookingState';
  carId?: Maybe<Scalars['String']['output']>;
  carPricePerTrip?: Maybe<Scalars['Float']['output']>;
  endAt: Scalars['Float']['output'];
  insuranceByTrip?: Maybe<Scalars['Float']['output']>;
  insurancePerDay?: Maybe<Scalars['Float']['output']>;
  pickupLocationId: Scalars['Float']['output'];
  returnLocationId: Scalars['Float']['output'];
  startAt: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
}

export interface IBookingStateInput {
  carId?: InputMaybe<Scalars['String']['input']>;
  carPricePerTrip?: InputMaybe<Scalars['Float']['input']>;
  endAt: Scalars['Float']['input'];
  insuranceByTrip?: InputMaybe<Scalars['Float']['input']>;
  insurancePerDay?: InputMaybe<Scalars['Float']['input']>;
  insurancePerTrip?: InputMaybe<Scalars['Float']['input']>;
  pickupLocationId: Scalars['Float']['input'];
  returnLocationId: Scalars['Float']['input'];
  startAt: Scalars['Float']['input'];
  totalPrice: Scalars['Float']['input'];
}

/** Booking status options */
export enum BookingStatus {
  Booked = 'BOOKED',
  CancelledByAdmin = 'CANCELLED_BY_ADMIN',
  CancelledByGuestAfterTripStart = 'CANCELLED_BY_GUEST_AFTER_TRIP_START',
  CancelledByGuestLessThan_24HoursBeforeTripStart = 'CANCELLED_BY_GUEST_LESS_THAN_24_HOURS_BEFORE_TRIP_START',
  CancelledByGuestMoreThan_24Hours = 'CANCELLED_BY_GUEST_MORE_THAN_24_HOURS',
  CancelledByHost = 'CANCELLED_BY_HOST',
  CardDeclined = 'CARD_DECLINED',
  Completed = 'COMPLETED',
  DeclinedByHost = 'DECLINED_BY_HOST',
  Pending = 'PENDING',
  Requested = 'REQUESTED',
  RequestExpired = 'REQUEST_EXPIRED',
  RequestWithdrawn = 'REQUEST_WITHDRAWN',
  Shortened = 'SHORTENED'
}

export interface IBoundsInput {
  east: Scalars['Float']['input'];
  north: Scalars['Float']['input'];
  south: Scalars['Float']['input'];
  west: Scalars['Float']['input'];
}

export interface IBrand {
  __typename?: 'Brand';
  aliases: Array<Scalars['String']['output']>;
  allowedProductTypes: Array<ProductType>;
  banAllOtherBrands: Scalars['Boolean']['output'];
  banBrandSites: Array<Scalars['String']['output']>;
  banMyselfOnOthers: Array<Scalars['String']['output']>;
  brandSite: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultProductType: ProductType;
  displayName: Scalars['String']['output'];
  exclusiveMarkets: Array<IExclusiveMarket>;
  fromEmail?: Maybe<Scalars['String']['output']>;
  hideFromAllOtherBrands: Scalars['Boolean']['output'];
  /** S3 key for this brand’s homepage banner. Null uses the built-in 2048×746 photo. */
  homeBannerImageKey?: Maybe<Scalars['String']['output']>;
  homePage: IBrandHomePage;
  id: Scalars['ID']['output'];
  referralCommissionRate?: Maybe<Scalars['Float']['output']>;
  showOtherSites: Scalars['Boolean']['output'];
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
}

export interface IBrandAppFeature {
  __typename?: 'BrandAppFeature';
  brandSite: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  feature: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<IBrandRulesActor>;
}

export interface IBrandAppFeatureChange {
  __typename?: 'BrandAppFeatureChange';
  brandSite: Scalars['String']['output'];
  changedAt: Scalars['DateTime']['output'];
  changedBy?: Maybe<IBrandRulesActor>;
  feature: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newValue: Scalars['Boolean']['output'];
  oldValue: Scalars['Boolean']['output'];
}

export interface IBrandAppFeatureRow {
  __typename?: 'BrandAppFeatureRow';
  brandSite: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  features: Array<IBrandAppFeature>;
}

export interface IBrandBannerUploadUrl {
  __typename?: 'BrandBannerUploadUrl';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export enum BrandDefaultEnvironment {
  Production = 'PRODUCTION',
  Staging = 'STAGING'
}

export interface IBrandEnvironmentSettings {
  __typename?: 'BrandEnvironmentSettings';
  brandSite: Scalars['String']['output'];
  defaultEnvironment: BrandDefaultEnvironment;
  testingBanner: Scalars['Boolean']['output'];
}

export interface IBrandHomePage {
  __typename?: 'BrandHomePage';
  /** App home subtitle, at most 60 characters. */
  appSubtitle?: Maybe<Scalars['String']['output']>;
  /** App home title, at most 15 characters. */
  appTitle?: Maybe<Scalars['String']['output']>;
  /** Banner overlay color, #RRGGBB. Null with a null opacity = the standard overlay. */
  overlayColor?: Maybe<Scalars['String']['output']>;
  /** Banner overlay strength, percent 30 to 95. */
  overlayOpacity?: Maybe<Scalars['Int']['output']>;
  /** Website home subtitle, at most 135 characters. */
  webSubtitle?: Maybe<Scalars['String']['output']>;
  /** Website home title, at most 29 characters. */
  webTitle?: Maybe<Scalars['String']['output']>;
}

export interface IBrandHomePageInput {
  appSubtitle?: InputMaybe<Scalars['String']['input']>;
  appTitle?: InputMaybe<Scalars['String']['input']>;
  overlayColor?: InputMaybe<Scalars['String']['input']>;
  overlayOpacity?: InputMaybe<Scalars['Int']['input']>;
  webSubtitle?: InputMaybe<Scalars['String']['input']>;
  webTitle?: InputMaybe<Scalars['String']['input']>;
}

export interface IBrandMembership {
  __typename?: 'BrandMembership';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  brand?: Maybe<IBrand>;
  brandId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hostStatus?: Maybe<HostStatus>;
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  listingsSuspended: Scalars['Boolean']['output'];
  openTripCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<IUser>;
  userId: Scalars['String']['output'];
}

export interface IBrandRules {
  __typename?: 'BrandRules';
  bookingRules: Scalars['JSON']['output'];
  brandId?: Maybe<Scalars['ID']['output']>;
  brandSite: Scalars['String']['output'];
  deliveryHostCount: Scalars['Int']['output'];
  hostCapabilities: IHostCapabilities;
  openDeliveryTripCount: Scalars['Int']['output'];
  refusedCheckoutsSinceClosed: Scalars['Int']['output'];
  source: BrandRulesSource;
  updatedAt?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<IBrandRulesActor>;
  version: Scalars['Int']['output'];
}

export interface IBrandRulesActor {
  __typename?: 'BrandRulesActor';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export enum BrandRulesField {
  BookingRules = 'BOOKING_RULES',
  HostCapabilities = 'HOST_CAPABILITIES'
}

export interface IBrandRulesHistoryEntry {
  __typename?: 'BrandRulesHistoryEntry';
  after: Scalars['JSON']['output'];
  before?: Maybe<Scalars['JSON']['output']>;
  changedAt: Scalars['Float']['output'];
  changedBy?: Maybe<IBrandRulesActor>;
  field: BrandRulesField;
  id: Scalars['ID']['output'];
  requestBrandSite?: Maybe<Scalars['String']['output']>;
  versionAfter: Scalars['Int']['output'];
}

export enum BrandRulesSource {
  Defaults = 'DEFAULTS',
  Row = 'ROW'
}

export interface IBroadcast {
  __typename?: 'Broadcast';
  audience: BroadcastAudience;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: IUser;
  id: Scalars['ID']['output'];
  isSending: Scalars['Boolean']['output'];
  lastSendError?: Maybe<Scalars['String']['output']>;
  /** Users who were sent this broadcast. */
  recipientCount: Scalars['Int']['output'];
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Failed send attempts; the scheduler gives up at 3. */
  sendAttempts: Scalars['Int']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: BroadcastStatus;
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

/** Target audience for the broadcast */
export enum BroadcastAudience {
  AllUsers = 'ALL_USERS',
  GuestsOnly = 'GUESTS_ONLY',
  HostsOnly = 'HOSTS_ONLY'
}

/** Status of the broadcast */
export enum BroadcastStatus {
  Draft = 'DRAFT',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

export interface IBuyerInfo {
  __typename?: 'BuyerInfo';
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
}

export interface IBuyerInfoInput {
  city: Scalars['String']['input'];
  county: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
}

export interface ICalculateTripExtensionInput {
  bookingId: Scalars['String']['input'];
  newEndAt: Scalars['Float']['input'];
}

export interface ICalculatedPriceInfo {
  __typename?: 'CalculatedPriceInfo';
  baseBeforeLastMinSurcharge?: Maybe<Scalars['Float']['output']>;
  carPricePerTrip: Scalars['Float']['output'];
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  discountTier?: Maybe<Scalars['String']['output']>;
  lastMinSurchargeAmount?: Maybe<Scalars['Float']['output']>;
  lastMinSurchargePercentage?: Maybe<Scalars['Float']['output']>;
  pricePerDay: Scalars['Float']['output'];
  rentalType?: Maybe<RentalTypeEnum>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  totalDays: Scalars['Int']['output'];
  totalPrice: Scalars['Float']['output'];
  totalPriceWithDelivery?: Maybe<Scalars['Float']['output']>;
  tripFeeTotal: Scalars['Float']['output'];
  youngsterFeeTotal: Scalars['Float']['output'];
}

export interface ICanReportDamageResponse {
  __typename?: 'CanReportDamageResponse';
  canReport: Scalars['Boolean']['output'];
  deadline?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
}

export interface ICanRespondToClaimResponse {
  __typename?: 'CanRespondToClaimResponse';
  canRespond: Scalars['Boolean']['output'];
  deadline?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
}

export enum CancellationPolicyMode {
  HostSelected = 'HOST_SELECTED',
  PlatformFixed = 'PLATFORM_FIXED'
}

/** Cancellation reason options */
export enum CancellationReason {
  CarUnavailable = 'CAR_UNAVAILABLE',
  DlVerificationFailed = 'DL_VERIFICATION_FAILED',
  Emergency = 'EMERGENCY',
  GuestRequested = 'GUEST_REQUESTED',
  HostCancelled = 'HOST_CANCELLED',
  Other = 'OTHER',
  SafetyRecall = 'SAFETY_RECALL',
  SystemCancelled = 'SYSTEM_CANCELLED',
  Weather = 'WEATHER'
}

export interface ICancelledBookingsFilterInput {
  cancellationReason?: InputMaybe<CancellationReason>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  refundStatus?: InputMaybe<RefundStatus>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface ICar {
  __typename?: 'Car';
  /** Average accuracy rating */
  accuracyAvg?: Maybe<Scalars['Float']['output']>;
  ageLimit?: Maybe<Scalars['Int']['output']>;
  approximateLocation?: Maybe<IApproximateLocation>;
  availabilities?: Maybe<Array<ICarAvailability>>;
  /** Average overall rating (1-5) */
  averageRating?: Maybe<Scalars['Float']['output']>;
  bookableOnThisSite: ICarBookability;
  bookings?: Maybe<Array<IBooking>>;
  calculatedPrice?: Maybe<ICalculatedPriceInfo>;
  category?: Maybe<CategoryEnum>;
  /** Average check-in rating (stays) */
  checkInAvg?: Maybe<Scalars['Float']['output']>;
  checkoutBrandSite?: Maybe<Scalars['String']['output']>;
  cityMpg?: Maybe<Scalars['Int']['output']>;
  /** Average cleanliness rating */
  cleanlinessAvg?: Maybe<Scalars['Float']['output']>;
  /** Average communication rating */
  communicationAvg?: Maybe<Scalars['Float']['output']>;
  /** Average convenience rating */
  convenienceAvg?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentLocation?: Maybe<Scalars['String']['output']>;
  dailyTripFee?: Maybe<Scalars['Float']['output']>;
  dealer?: Maybe<IDealer>;
  dealerId?: Maybe<Scalars['String']['output']>;
  deliveryLocations?: Maybe<Array<ICarDeliveryLocation>>;
  /** Security deposit amount for this car */
  deposit?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<IDiscount>;
  displayName?: Maybe<Scalars['String']['output']>;
  distanceLimit?: Maybe<IDistanceLimit>;
  doors?: Maybe<Scalars['Int']['output']>;
  features?: Maybe<Array<CarFeatures>>;
  freeCancellationAdvanceHours?: Maybe<Scalars['Int']['output']>;
  gas?: Maybe<GasType>;
  gasGrade?: Maybe<GasGrade>;
  gearType?: Maybe<GearType>;
  /** Special instructions for the guest (pick-up, drop-off, etc.) */
  guestInstructions?: Maybe<Scalars['String']['output']>;
  /** Holiday hourly price (when hourly rental is on) */
  holidayHrPrice?: Maybe<Scalars['Float']['output']>;
  holidayPrice?: Maybe<Scalars['Float']['output']>;
  /** Whether hourly rental is enabled for this car */
  hourlyRentalIsOn?: Maybe<Scalars['Boolean']['output']>;
  hwyMpg?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<IImage>>;
  isCreated: Scalars['Boolean']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Whether guests can decline protection for this car */
  isProtectionDeclinable?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  /** License plate number */
  licensePlate?: Maybe<Scalars['String']['output']>;
  /** License plate state code */
  licensePlateState?: Maybe<Scalars['String']['output']>;
  listedSalePrice?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<ILocation>;
  /** Average location rating (stays) */
  locationAvg?: Maybe<Scalars['Float']['output']>;
  locationId: Scalars['Int']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Average maintenance rating */
  maintenanceAvg?: Maybe<Scalars['Float']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  /** Maximum number of rental days allowed for this car */
  maximumRentalDays?: Maybe<Scalars['Int']['output']>;
  mileage?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of rental days required for this car */
  minimumRentalDays?: Maybe<Scalars['Int']['output']>;
  miscellaneousFees?: Maybe<Array<IMiscellaneousFee>>;
  model?: Maybe<Scalars['String']['output']>;
  /** Fixed total price for the 1-month (30-59 day) monthly tier */
  monthlyPrice?: Maybe<Scalars['Float']['output']>;
  /** Fixed total price for the 2-month (60-89 day) monthly tier */
  monthlyPrice2Months?: Maybe<Scalars['Float']['output']>;
  /** Fixed total price for the 3-month (90+ day) monthly tier */
  monthlyPrice3Months?: Maybe<Scalars['Float']['output']>;
  /** Whether monthly rental pricing and mileage are enabled for this car */
  monthlyRentalIsOn?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** mi or km; null is mi (spec 028). */
  odometerUnit?: Maybe<Scalars['String']['output']>;
  oneWeekPrice?: Maybe<Scalars['Float']['output']>;
  originalPrice?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<IUser>;
  ownerId: Scalars['String']['output'];
  priceCalendar?: Maybe<Array<IPriceCalendar>>;
  productTypeDetails?: Maybe<IProductTypeDetails>;
  productTypeDetailsId?: Maybe<Scalars['String']['output']>;
  recallCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  seats?: Maybe<Scalars['Float']['output']>;
  serviceWorker?: Maybe<IServiceWorker>;
  sold?: Maybe<Scalars['Boolean']['output']>;
  soldAt?: Maybe<Scalars['DateTime']['output']>;
  status: CarStatus;
  stayDetails?: Maybe<IStayDetails>;
  threeDaysPrice?: Maybe<Scalars['Float']['output']>;
  threeWeeksPrice?: Maybe<Scalars['Float']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Total number of ratings */
  totalRatings?: Maybe<Scalars['Int']['output']>;
  tripPreferences?: Maybe<ITripPreferences>;
  tripSettings: ICarTripSettings;
  twoWeeksPrice?: Maybe<Scalars['Float']['output']>;
  /** Average value rating (stays) */
  valueAvg?: Maybe<Scalars['Float']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  /** Weekday hourly price (when hourly rental is on) */
  weekdayHrPrice?: Maybe<Scalars['Float']['output']>;
  weekdayPrice?: Maybe<Scalars['Float']['output']>;
  /** Weekend hourly price (when hourly rental is on) */
  weekendHrPrice?: Maybe<Scalars['Float']['output']>;
  weekendPrice?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
}


export interface ICarCheckoutBrandSiteArgs {
  pickupLocationId?: InputMaybe<Scalars['Int']['input']>;
  returnLocationId?: InputMaybe<Scalars['Int']['input']>;
}

export interface ICarAvailability {
  __typename?: 'CarAvailability';
  car: ICar;
  carId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endAt: Scalars['Float']['output'];
  host?: Maybe<IUser>;
  hostId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  startAt: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface ICarBookability {
  __typename?: 'CarBookability';
  bookable: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
}

export interface ICarBookedDates {
  __typename?: 'CarBookedDates';
  bookedTimeSlots: Array<IBookedTimeSlot>;
  tripBufferHours: Scalars['Int']['output'];
}

export interface ICarDeliveryLocation {
  __typename?: 'CarDeliveryLocation';
  car: ICar;
  carId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fee: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  location: ILocation;
  locationId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface ICarDeliveryLocationInput {
  carId: Scalars['String']['input'];
  fee: Scalars['Float']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
}

export interface ICarDisplayPrices {
  __typename?: 'CarDisplayPrices';
  oneWeek?: Maybe<Scalars['Float']['output']>;
  threeDays?: Maybe<Scalars['Float']['output']>;
  threeWeeks?: Maybe<Scalars['Float']['output']>;
  twoWeeks?: Maybe<Scalars['Float']['output']>;
}

/** The features available in a car */
export enum CarFeatures {
  AllWheelDrive = 'ALL_WHEEL_DRIVE',
  AndroidAuto = 'ANDROID_AUTO',
  AppleCarplay = 'APPLE_CARPLAY',
  AuxInput = 'AUX_INPUT',
  BackupCamera = 'BACKUP_CAMERA',
  BikeRack = 'BIKE_RACK',
  BlindSpotWarning = 'BLIND_SPOT_WARNING',
  Bluetooth = 'BLUETOOTH',
  ChildSeat = 'CHILD_SEAT',
  Convertible = 'CONVERTIBLE',
  Gps = 'GPS',
  HeatedSeats = 'HEATED_SEATS',
  KeylessEntry = 'KEYLESS_ENTRY',
  PetFriendly = 'PET_FRIENDLY',
  SkiRack = 'SKI_RACK',
  SnowTires = 'SNOW_TIRES',
  Sunroof = 'SUNROOF',
  TollPass = 'TOLL_PASS',
  UsbCharger = 'USB_CHARGER',
  UsbInput = 'USB_INPUT',
  WheelchairAccessible = 'WHEELCHAIR_ACCESSIBLE'
}

export interface ICarListingStatus {
  __typename?: 'CarListingStatus';
  canHostRelist: Scalars['Boolean']['output'];
  carId: Scalars['ID']['output'];
  hold?: Maybe<IListingHold>;
  isAdminView: Scalars['Boolean']['output'];
  supportEmail?: Maybe<Scalars['String']['output']>;
}

export interface ICarMakeAndModel {
  __typename?: 'CarMakeAndModel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  years?: Maybe<Array<Scalars['Int']['output']>>;
}

export interface ICarPricingInput {
  carId: Scalars['String']['input'];
  driverAge?: InputMaybe<Scalars['Int']['input']>;
  endAt: Scalars['Float']['input'];
  pickupLocationId?: InputMaybe<Scalars['Int']['input']>;
  startAt: Scalars['Float']['input'];
}

export interface ICarRatingSummary {
  __typename?: 'CarRatingSummary';
  accuracyAvg: Scalars['Float']['output'];
  averageRating: Scalars['Float']['output'];
  cleanlinessAvg: Scalars['Float']['output'];
  communicationAvg: Scalars['Float']['output'];
  convenienceAvg: Scalars['Float']['output'];
  maintenanceAvg: Scalars['Float']['output'];
  ratingDistribution: IRatingDistribution;
  totalRatings: Scalars['Int']['output'];
}

export interface ICarRatingsResponse {
  __typename?: 'CarRatingsResponse';
  reviews: Array<ITripRatingReview>;
  summary: ICarRatingSummary;
  totalCount: Scalars['Int']['output'];
}

export interface ICarSale {
  __typename?: 'CarSale';
  agreementDate: Scalars['DateTime']['output'];
  buyer: Array<IBuyerInfo>;
  cancellationDate?: Maybe<Scalars['DateTime']['output']>;
  cancellationFee: Scalars['Float']['output'];
  cancellationPlan: CarSalesCancellationEnum;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  car?: Maybe<ICar>;
  carId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dealer: IDealer;
  dealerId: Scalars['String']['output'];
  docPrepFee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  odometerReading?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<IPaymentDetails>;
  paymentSchedule?: Maybe<IPaymentSchedule>;
  priorCreditToSeller?: Maybe<Scalars['Float']['output']>;
  publicFees?: Maybe<IPublicFees>;
  recordOfSaleNumber?: Maybe<Scalars['String']['output']>;
  salesTaxCharge?: Maybe<Scalars['Float']['output']>;
  salesTaxRate?: Maybe<Scalars['Float']['output']>;
  smogFee?: Maybe<Scalars['Float']['output']>;
  soldOn?: Maybe<Scalars['DateTime']['output']>;
  soldPrice?: Maybe<Scalars['Float']['output']>;
  tradeInVehicles?: Maybe<Array<ITradeInVehicle>>;
  updatedAt: Scalars['DateTime']['output'];
}

export enum CarSalesCancellationEnum {
  BaseCancelPlan = 'BASE_CANCEL_PLAN',
  DeclinedCancelPlan = 'DECLINED_CANCEL_PLAN',
  PremiumCancelPlan = 'PREMIUM_CANCEL_PLAN',
  ProCancelPlan = 'PRO_CANCEL_PLAN'
}

export interface ICarSearchFiltersInput {
  features?: InputMaybe<Array<CarFeatures>>;
  fuelTypes?: InputMaybe<Array<GasType>>;
  isAddressSearch?: InputMaybe<Scalars['Boolean']['input']>;
  makeModels?: InputMaybe<Array<IMakeModelInput>>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  maxYear?: InputMaybe<Scalars['Int']['input']>;
  minMileageLimit?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  minSeats?: InputMaybe<Scalars['Int']['input']>;
  minYear?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SortOption>;
  transmission?: InputMaybe<GearType>;
  unlimitedMileage?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTypes?: InputMaybe<Array<CategoryEnum>>;
}

/** The status of the car */
export enum CarStatus {
  Available = 'AVAILABLE',
  Deactivated = 'DEACTIVATED',
  Pending = 'PENDING',
  Selling = 'SELLING',
  Sold = 'SOLD'
}

export interface ICarSwap {
  __typename?: 'CarSwap';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  approvedByUser?: Maybe<IUser>;
  booking: IBooking;
  bookingId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fromCar?: Maybe<ICar>;
  fromCarId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  rejectedByUser?: Maybe<IUser>;
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Scalars['String']['output'];
  requestedByUser?: Maybe<IUser>;
  responseDeadline?: Maybe<Scalars['DateTime']['output']>;
  status: CarSwapStatus;
  swapStartTime?: Maybe<Scalars['Float']['output']>;
  toCar?: Maybe<ICar>;
  toCarId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface ICarSwapRequestInput {
  bookingId: Scalars['String']['input'];
  newCarId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  swapStartTime?: InputMaybe<Scalars['Float']['input']>;
}

export interface ICarSwapResponseInput {
  bookingId: Scalars['String']['input'];
}

/** Car swap status options */
export enum CarSwapStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  None = 'NONE',
  PendingGuestApproval = 'PENDING_GUEST_APPROVAL',
  Rejected = 'REJECTED'
}

export interface ICarTripSettings {
  __typename?: 'CarTripSettings';
  advanceNoticeHours: Scalars['Float']['output'];
  deposit: Scalars['Float']['output'];
  discount?: Maybe<Scalars['JSON']['output']>;
  displayPrices: ICarDisplayPrices;
  /** mi or km (spec 028): the unit of milesPerDay and overagePerMile. */
  distanceUnit: Scalars['String']['output'];
  guestInstructions?: Maybe<Scalars['String']['output']>;
  hourlyRentalOffered: Scalars['Boolean']['output'];
  maximumRentalDays?: Maybe<Scalars['Int']['output']>;
  milesPerDay: Scalars['Float']['output'];
  minimumAge: Scalars['Int']['output'];
  minimumRentalDays?: Maybe<Scalars['Int']['output']>;
  monthlyRentalOffered: Scalars['Boolean']['output'];
  overagePerMile?: Maybe<Scalars['Float']['output']>;
  protectionDeclinable: Scalars['Boolean']['output'];
  tripBufferHours: Scalars['Float']['output'];
  unlimitedMileage: Scalars['Boolean']['output'];
}

export interface ICarWithPricing {
  __typename?: 'CarWithPricing';
  /** Average accuracy rating */
  accuracyAvg?: Maybe<Scalars['Float']['output']>;
  ageLimit?: Maybe<Scalars['Int']['output']>;
  approximateLocation?: Maybe<IApproximateLocation>;
  availabilities?: Maybe<Array<ICarAvailability>>;
  /** Average overall rating (1-5) */
  averageRating?: Maybe<Scalars['Float']['output']>;
  bookableOnThisSite: ICarBookability;
  bookings?: Maybe<Array<IBooking>>;
  calculatedPrice: ICalculatedPriceInfo;
  category?: Maybe<CategoryEnum>;
  /** Average check-in rating (stays) */
  checkInAvg?: Maybe<Scalars['Float']['output']>;
  checkoutBrandSite?: Maybe<Scalars['String']['output']>;
  cityMpg?: Maybe<Scalars['Int']['output']>;
  /** Average cleanliness rating */
  cleanlinessAvg?: Maybe<Scalars['Float']['output']>;
  /** Average communication rating */
  communicationAvg?: Maybe<Scalars['Float']['output']>;
  /** Average convenience rating */
  convenienceAvg?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentLocation?: Maybe<Scalars['String']['output']>;
  dailyTripFee?: Maybe<Scalars['Float']['output']>;
  dealer?: Maybe<IDealer>;
  dealerId?: Maybe<Scalars['String']['output']>;
  deliveryLocations?: Maybe<Array<ICarDeliveryLocation>>;
  /** Security deposit amount for this car */
  deposit?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<IDiscount>;
  displayName?: Maybe<Scalars['String']['output']>;
  distanceLimit?: Maybe<IDistanceLimit>;
  doors?: Maybe<Scalars['Int']['output']>;
  features?: Maybe<Array<CarFeatures>>;
  freeCancellationAdvanceHours?: Maybe<Scalars['Int']['output']>;
  gas?: Maybe<GasType>;
  gasGrade?: Maybe<GasGrade>;
  gearType?: Maybe<GearType>;
  /** Special instructions for the guest (pick-up, drop-off, etc.) */
  guestInstructions?: Maybe<Scalars['String']['output']>;
  /** Holiday hourly price (when hourly rental is on) */
  holidayHrPrice?: Maybe<Scalars['Float']['output']>;
  holidayPrice?: Maybe<Scalars['Float']['output']>;
  /** Whether hourly rental is enabled for this car */
  hourlyRentalIsOn?: Maybe<Scalars['Boolean']['output']>;
  hwyMpg?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<IImage>>;
  isCreated: Scalars['Boolean']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Whether guests can decline protection for this car */
  isProtectionDeclinable?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  /** License plate number */
  licensePlate?: Maybe<Scalars['String']['output']>;
  /** License plate state code */
  licensePlateState?: Maybe<Scalars['String']['output']>;
  listedSalePrice?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<ILocation>;
  /** Average location rating (stays) */
  locationAvg?: Maybe<Scalars['Float']['output']>;
  locationId: Scalars['Int']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Average maintenance rating */
  maintenanceAvg?: Maybe<Scalars['Float']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  /** Maximum number of rental days allowed for this car */
  maximumRentalDays?: Maybe<Scalars['Int']['output']>;
  mileage?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of rental days required for this car */
  minimumRentalDays?: Maybe<Scalars['Int']['output']>;
  miscellaneousFees?: Maybe<Array<IMiscellaneousFee>>;
  model?: Maybe<Scalars['String']['output']>;
  /** Fixed total price for the 1-month (30-59 day) monthly tier */
  monthlyPrice?: Maybe<Scalars['Float']['output']>;
  /** Fixed total price for the 2-month (60-89 day) monthly tier */
  monthlyPrice2Months?: Maybe<Scalars['Float']['output']>;
  /** Fixed total price for the 3-month (90+ day) monthly tier */
  monthlyPrice3Months?: Maybe<Scalars['Float']['output']>;
  /** Whether monthly rental pricing and mileage are enabled for this car */
  monthlyRentalIsOn?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** mi or km; null is mi (spec 028). */
  odometerUnit?: Maybe<Scalars['String']['output']>;
  oneWeekPrice?: Maybe<Scalars['Float']['output']>;
  originalPrice?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<IUser>;
  ownerId: Scalars['String']['output'];
  priceCalendar?: Maybe<Array<IPriceCalendar>>;
  productTypeDetails?: Maybe<IProductTypeDetails>;
  productTypeDetailsId?: Maybe<Scalars['String']['output']>;
  recallCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  seats?: Maybe<Scalars['Float']['output']>;
  serviceWorker?: Maybe<IServiceWorker>;
  sold?: Maybe<Scalars['Boolean']['output']>;
  soldAt?: Maybe<Scalars['DateTime']['output']>;
  status: CarStatus;
  stayDetails?: Maybe<IStayDetails>;
  threeDaysPrice?: Maybe<Scalars['Float']['output']>;
  threeWeeksPrice?: Maybe<Scalars['Float']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Total number of ratings */
  totalRatings?: Maybe<Scalars['Int']['output']>;
  tripPreferences?: Maybe<ITripPreferences>;
  tripSettings: ICarTripSettings;
  twoWeeksPrice?: Maybe<Scalars['Float']['output']>;
  /** Average value rating (stays) */
  valueAvg?: Maybe<Scalars['Float']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  /** Weekday hourly price (when hourly rental is on) */
  weekdayHrPrice?: Maybe<Scalars['Float']['output']>;
  weekdayPrice?: Maybe<Scalars['Float']['output']>;
  /** Weekend hourly price (when hourly rental is on) */
  weekendHrPrice?: Maybe<Scalars['Float']['output']>;
  weekendPrice?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
}


export interface ICarWithPricingCheckoutBrandSiteArgs {
  pickupLocationId?: InputMaybe<Scalars['Int']['input']>;
  returnLocationId?: InputMaybe<Scalars['Int']['input']>;
}

export interface ICarWithPricingAndDistance {
  __typename?: 'CarWithPricingAndDistance';
  /** Average accuracy rating */
  accuracyAvg?: Maybe<Scalars['Float']['output']>;
  ageLimit?: Maybe<Scalars['Int']['output']>;
  approximateLocation?: Maybe<IApproximateLocation>;
  availabilities?: Maybe<Array<ICarAvailability>>;
  /** Average overall rating (1-5) */
  averageRating?: Maybe<Scalars['Float']['output']>;
  bookableOnThisSite: ICarBookability;
  bookings?: Maybe<Array<IBooking>>;
  calculatedPrice: ICalculatedPriceInfo;
  category?: Maybe<CategoryEnum>;
  /** Average check-in rating (stays) */
  checkInAvg?: Maybe<Scalars['Float']['output']>;
  checkoutBrandSite?: Maybe<Scalars['String']['output']>;
  cityMpg?: Maybe<Scalars['Int']['output']>;
  /** Average cleanliness rating */
  cleanlinessAvg?: Maybe<Scalars['Float']['output']>;
  /** Average communication rating */
  communicationAvg?: Maybe<Scalars['Float']['output']>;
  /** Average convenience rating */
  convenienceAvg?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentLocation?: Maybe<Scalars['String']['output']>;
  dailyTripFee?: Maybe<Scalars['Float']['output']>;
  dealer?: Maybe<IDealer>;
  dealerId?: Maybe<Scalars['String']['output']>;
  deliveryLocations?: Maybe<Array<ICarDeliveryLocation>>;
  /** Security deposit amount for this car */
  deposit?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<IDiscount>;
  displayName?: Maybe<Scalars['String']['output']>;
  distanceLimit?: Maybe<IDistanceLimit>;
  distanceMiles: Scalars['Float']['output'];
  doors?: Maybe<Scalars['Int']['output']>;
  features?: Maybe<Array<CarFeatures>>;
  freeCancellationAdvanceHours?: Maybe<Scalars['Int']['output']>;
  gas?: Maybe<GasType>;
  gasGrade?: Maybe<GasGrade>;
  gearType?: Maybe<GearType>;
  /** Special instructions for the guest (pick-up, drop-off, etc.) */
  guestInstructions?: Maybe<Scalars['String']['output']>;
  /** Holiday hourly price (when hourly rental is on) */
  holidayHrPrice?: Maybe<Scalars['Float']['output']>;
  holidayPrice?: Maybe<Scalars['Float']['output']>;
  /** Whether hourly rental is enabled for this car */
  hourlyRentalIsOn?: Maybe<Scalars['Boolean']['output']>;
  hwyMpg?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<IImage>>;
  isCreated: Scalars['Boolean']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Whether guests can decline protection for this car */
  isProtectionDeclinable?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  /** License plate number */
  licensePlate?: Maybe<Scalars['String']['output']>;
  /** License plate state code */
  licensePlateState?: Maybe<Scalars['String']['output']>;
  listedSalePrice?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<ILocation>;
  /** Average location rating (stays) */
  locationAvg?: Maybe<Scalars['Float']['output']>;
  locationId: Scalars['Int']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Average maintenance rating */
  maintenanceAvg?: Maybe<Scalars['Float']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  /** Maximum number of rental days allowed for this car */
  maximumRentalDays?: Maybe<Scalars['Int']['output']>;
  mileage?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of rental days required for this car */
  minimumRentalDays?: Maybe<Scalars['Int']['output']>;
  miscellaneousFees?: Maybe<Array<IMiscellaneousFee>>;
  model?: Maybe<Scalars['String']['output']>;
  /** Fixed total price for the 1-month (30-59 day) monthly tier */
  monthlyPrice?: Maybe<Scalars['Float']['output']>;
  /** Fixed total price for the 2-month (60-89 day) monthly tier */
  monthlyPrice2Months?: Maybe<Scalars['Float']['output']>;
  /** Fixed total price for the 3-month (90+ day) monthly tier */
  monthlyPrice3Months?: Maybe<Scalars['Float']['output']>;
  /** Whether monthly rental pricing and mileage are enabled for this car */
  monthlyRentalIsOn?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** mi or km; null is mi (spec 028). */
  odometerUnit?: Maybe<Scalars['String']['output']>;
  oneWeekPrice?: Maybe<Scalars['Float']['output']>;
  originalPrice?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<IUser>;
  ownerId: Scalars['String']['output'];
  priceCalendar?: Maybe<Array<IPriceCalendar>>;
  productTypeDetails?: Maybe<IProductTypeDetails>;
  productTypeDetailsId?: Maybe<Scalars['String']['output']>;
  recallCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  seats?: Maybe<Scalars['Float']['output']>;
  serviceWorker?: Maybe<IServiceWorker>;
  sold?: Maybe<Scalars['Boolean']['output']>;
  soldAt?: Maybe<Scalars['DateTime']['output']>;
  status: CarStatus;
  stayDetails?: Maybe<IStayDetails>;
  threeDaysPrice?: Maybe<Scalars['Float']['output']>;
  threeWeeksPrice?: Maybe<Scalars['Float']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Total number of ratings */
  totalRatings?: Maybe<Scalars['Int']['output']>;
  tripPreferences?: Maybe<ITripPreferences>;
  tripSettings: ICarTripSettings;
  twoWeeksPrice?: Maybe<Scalars['Float']['output']>;
  /** Average value rating (stays) */
  valueAvg?: Maybe<Scalars['Float']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  /** Weekday hourly price (when hourly rental is on) */
  weekdayHrPrice?: Maybe<Scalars['Float']['output']>;
  weekdayPrice?: Maybe<Scalars['Float']['output']>;
  /** Weekend hourly price (when hourly rental is on) */
  weekendHrPrice?: Maybe<Scalars['Float']['output']>;
  weekendPrice?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
}


export interface ICarWithPricingAndDistanceCheckoutBrandSiteArgs {
  pickupLocationId?: InputMaybe<Scalars['Int']['input']>;
  returnLocationId?: InputMaybe<Scalars['Int']['input']>;
}

export interface ICardType {
  __typename?: 'CardType';
  brand?: Maybe<Scalars['String']['output']>;
  exp_month?: Maybe<Scalars['Float']['output']>;
  exp_year?: Maybe<Scalars['Float']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
}

export interface ICardholderNameNoticeRow {
  __typename?: 'CardholderNameNoticeRow';
  accountName?: Maybe<Scalars['String']['output']>;
  accountNameSource?: Maybe<Scalars['String']['output']>;
  bookingId: Scalars['String']['output'];
  cardLast4?: Maybe<Scalars['String']['output']>;
  cardholderName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Float']['output'];
  guestEmail?: Maybe<Scalars['String']['output']>;
  guestName?: Maybe<Scalars['String']['output']>;
  hostName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  listingName?: Maybe<Scalars['String']['output']>;
  notifiedAt?: Maybe<Scalars['Float']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  purpose: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  tripEndAt?: Maybe<Scalars['Float']['output']>;
  tripStartAt?: Maybe<Scalars['Float']['output']>;
}

export interface ICashPriceVehicleNAccessories {
  __typename?: 'CashPriceVehicleNAccessories';
  amount?: Maybe<Scalars['Float']['output']>;
  cashPriceAccessories?: Maybe<Scalars['Float']['output']>;
  cashPriceVehicle?: Maybe<Scalars['Float']['output']>;
  other?: Maybe<Array<IOtherItem>>;
}

export interface ICashPriceVehicleNAccessoriesInput {
  amount?: InputMaybe<Scalars['Float']['input']>;
  cashPriceAccessories?: InputMaybe<Scalars['Float']['input']>;
  cashPriceVehicle?: InputMaybe<Scalars['Float']['input']>;
  other?: InputMaybe<Array<IOtherItemInput>>;
}

/** The category/type of the vehicle */
export enum CategoryEnum {
  BoxTruck = 'BOX_TRUCK',
  CargoVan = 'CARGO_VAN',
  Convertible = 'CONVERTIBLE',
  Coupe = 'COUPE',
  Minivan = 'MINIVAN',
  Others = 'OTHERS',
  Sedan = 'SEDAN',
  Subruban = 'SUBRUBAN',
  Suv = 'SUV',
  Truck = 'TRUCK',
  Van = 'VAN',
  Wagon = 'WAGON'
}

export interface IChargeIncidentFeeInput {
  actualReturnAt?: InputMaybe<Scalars['DateTime']['input']>;
  amount: Scalars['Float']['input'];
  bookingId: Scalars['ID']['input'];
  damageClaimId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  incidentType: InvoiceType;
  photoS3Keys: Array<Scalars['String']['input']>;
}

export interface IChargeIncidentFeesInput {
  bookingId: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<IIncidentChargeLineItemInput>;
}

export interface IChargePostTripFeeResult {
  __typename?: 'ChargePostTripFeeResult';
  attemptedPaymentMethodIds?: Maybe<Array<Scalars['String']['output']>>;
  failedPaymentMethods?: Maybe<Array<Scalars['String']['output']>>;
  invoice: IInvoice;
  message?: Maybe<Scalars['String']['output']>;
  paymentLink?: Maybe<Scalars['String']['output']>;
  requiresGuestAction?: Maybe<Scalars['Boolean']['output']>;
  status: ChargeStatus;
  success: Scalars['Boolean']['output'];
}

/** Status of a post-trip charge attempt */
export enum ChargeStatus {
  ChargedSuccessfully = 'CHARGED_SUCCESSFULLY',
  Failed = 'FAILED',
  InvoiceSent = 'INVOICE_SENT'
}

/** Type of charge for custom items */
export enum ChargeType {
  PerDay = 'PER_DAY',
  PerTrip = 'PER_TRIP'
}

export interface IClaimResponse {
  __typename?: 'ClaimResponse';
  createdAt: Scalars['String']['output'];
  responderId: Scalars['String']['output'];
  responseContent: Scalars['String']['output'];
  responsePhotos?: Maybe<Array<Scalars['String']['output']>>;
}

export enum CleaningLevel {
  Deep = 'DEEP',
  Quick = 'QUICK',
  Standard = 'STANDARD'
}

/** Cleanliness issues that guests can report */
export enum CleanlinessDefectEnum {
  ExteriorDirty = 'EXTERIOR_DIRTY',
  InteriorDirty = 'INTERIOR_DIRTY',
  NotDisinfected = 'NOT_DISINFECTED',
  Others = 'OTHERS',
  PetHair = 'PET_HAIR',
  TrashOrClutter = 'TRASH_OR_CLUTTER',
  UnpleasantSmell = 'UNPLEASANT_SMELL',
  UpholsteryStains = 'UPHOLSTERY_STAINS'
}

export interface ICleanlinessRating {
  __typename?: 'CleanlinessRating';
  improve?: Maybe<Array<CleanlinessDefectEnum>>;
  score: Scalars['Int']['output'];
}

export interface ICleanlinessRatingInput {
  improve?: InputMaybe<Array<CleanlinessDefectEnum>>;
  score: Scalars['Int']['input'];
}

export interface ICodeDeliveryDetailsType {
  __typename?: 'CodeDeliveryDetailsType';
  AttributeName?: Maybe<Scalars['String']['output']>;
  DeliveryMedium?: Maybe<Scalars['String']['output']>;
  Destination?: Maybe<Scalars['String']['output']>;
}

/** Communication issues that guests can report */
export enum CommunicationDefectEnum {
  NotResponsive = 'NOT_RESPONSIVE',
  Others = 'OTHERS',
  RudeBehavior = 'RUDE_BEHAVIOR',
  SlowResponse = 'SLOW_RESPONSE',
  UnclearInstructions = 'UNCLEAR_INSTRUCTIONS'
}

export interface ICommunicationRating {
  __typename?: 'CommunicationRating';
  improve?: Maybe<Array<CommunicationDefectEnum>>;
  score: Scalars['Int']['output'];
}

export interface ICommunicationRatingInput {
  improve?: InputMaybe<Array<CommunicationDefectEnum>>;
  score: Scalars['Int']['input'];
}

export interface ICompleteGuestCheckinInput {
  bookingId: Scalars['ID']['input'];
}

export interface ICompleteGuestCheckoutInput {
  bookingId: Scalars['ID']['input'];
}

export interface ICompleteHostCheckinInput {
  bookingId: Scalars['ID']['input'];
  preTripFuelLevel: Scalars['Int']['input'];
  preTripMileage: Scalars['Int']['input'];
}

export interface ICompleteHostCheckoutInput {
  bookingId: Scalars['ID']['input'];
  firstPriorityHostCalcExMileage?: InputMaybe<Scalars['Int']['input']>;
  postTripFuelLevel: Scalars['Int']['input'];
  postTripMileage: Scalars['Int']['input'];
}

export interface IConfirmBookingInput {
  bookingId: Scalars['String']['input'];
  cardLast4Numbers: Scalars['String']['input'];
  defaultPaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
}

export interface IConfirmForgotPasswordInput {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}

export interface IConfirmForgotPasswordResponse {
  __typename?: 'ConfirmForgotPasswordResponse';
  CodeDeliveryDetails?: Maybe<ICodeDeliveryDetailsType>;
}

export interface IConfirmSavedCardResult {
  __typename?: 'ConfirmSavedCardResult';
  card: ISavedPaymentMethod;
  duplicate: Scalars['Boolean']['output'];
}

export interface IConfirmSignUpInput {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
}

export interface IConfirmSignUpResponse {
  __typename?: 'ConfirmSignUpResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface IConfirmStayModificationInput {
  bookingId: Scalars['ID']['input'];
  checkIn: Scalars['String']['input'];
  checkOut: Scalars['String']['input'];
  guests: IGuestCountsInput;
  paymentIntentId: Scalars['String']['input'];
}

export interface IConfirmTripExtensionInput {
  bookingId: Scalars['String']['input'];
  calculatedPriceDifference: Scalars['Float']['input'];
  newEndAt: Scalars['Float']['input'];
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  shortenTripPenalty?: InputMaybe<Scalars['Float']['input']>;
}

export interface IContactDealerInput {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
}

/** Convenience issues that guests can report */
export enum ConvenienceDefectEnum {
  CarLocationIssue = 'CAR_LOCATION_ISSUE',
  DifficultDropoff = 'DIFFICULT_DROPOFF',
  DifficultPickup = 'DIFFICULT_PICKUP',
  KeyLocationIssue = 'KEY_LOCATION_ISSUE',
  Others = 'OTHERS'
}

export interface IConvenienceRating {
  __typename?: 'ConvenienceRating';
  improve?: Maybe<Array<ConvenienceDefectEnum>>;
  score: Scalars['Int']['output'];
}

export interface IConvenienceRatingInput {
  improve?: InputMaybe<Array<ConvenienceDefectEnum>>;
  score: Scalars['Int']['input'];
}

export interface ICoupon {
  __typename?: 'Coupon';
  applyByDateOrTrip: ApplyByDateOrTripEnum;
  applyToCategory?: Maybe<CategoryEnum>;
  applyToGuests?: Maybe<Array<IUser>>;
  applyToOwner?: Maybe<IUser>;
  applyToOwnerId?: Maybe<Scalars['ID']['output']>;
  applyToPriceOf: ApplyToPriceOfEnum;
  applyToProductType?: Maybe<ProductType>;
  /** When set, restricts the coupon to the given booking rentalType. Null applies to both DAILY and MONTHLY. */
  applyToRentalType?: Maybe<RentalTypeEnum>;
  category: CouponCategoryEnum;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endAt?: Maybe<Scalars['Float']['output']>;
  fixAmountValue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  minDays?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  percentageValue?: Maybe<Scalars['Float']['output']>;
  priceAlgorithm: PriceAlgorithmEnum;
  startAt?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
}

/** Coupon category type */
export enum CouponCategoryEnum {
  Everydaymarketing = 'EVERYDAYMARKETING',
  Holiday = 'HOLIDAY',
  HostCreated = 'HOST_CREATED',
  Loyalty = 'LOYALTY',
  Other = 'OTHER'
}

export interface ICouponValidationResponse {
  __typename?: 'CouponValidationResponse';
  couponId?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
}

export interface ICreateBookingInput {
  carId: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  defaultPaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  driverAge: Scalars['Int']['input'];
  endAt: Scalars['Float']['input'];
  hostId: Scalars['String']['input'];
  paymentConfig?: InputMaybe<IPaymentConfigInput>;
  pickupLocationId: Scalars['Int']['input'];
  protectionPlan?: InputMaybe<ProtectionPlanEnum>;
  protectionPlanId?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  returnLocationId: Scalars['Int']['input'];
  startAt: Scalars['Float']['input'];
}

export interface ICreateBrandInput {
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedProductTypes?: InputMaybe<Array<ProductType>>;
  banAllOtherBrands?: InputMaybe<Scalars['Boolean']['input']>;
  banBrandSites?: InputMaybe<Array<Scalars['String']['input']>>;
  banMyselfOnOthers?: InputMaybe<Array<Scalars['String']['input']>>;
  brandSite: Scalars['String']['input'];
  defaultProductType?: InputMaybe<ProductType>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  exclusiveMarkets?: InputMaybe<Array<IExclusiveMarketInput>>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  hideFromAllOtherBrands?: InputMaybe<Scalars['Boolean']['input']>;
  homeBannerImageKey?: InputMaybe<Scalars['String']['input']>;
  homePage?: InputMaybe<IBrandHomePageInput>;
  /** Referral percent this brand pays as the checkout brand. Null uses the platform default. */
  referralCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  showOtherSites?: InputMaybe<Scalars['Boolean']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
}

export interface ICreateBroadcastInput {
  audience?: BroadcastAudience;
  content: Scalars['String']['input'];
  summary: Scalars['String']['input'];
  title: Scalars['String']['input'];
}

export interface ICreateCarAvailabilitiesBulkInput {
  carId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  periods: Array<IAvailabilityPeriodInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
}

export interface ICreateCarAvailabilitiesBulkResponse {
  __typename?: 'CreateCarAvailabilitiesBulkResponse';
  availabilities: Array<ICarAvailability>;
  createdCount: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface ICreateCarAvailabilityInput {
  carId: Scalars['String']['input'];
  endAt: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['Float']['input'];
}

export interface ICreateCarMakeAndModelInput {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
}

export interface ICreateCarSaleInput {
  buyer: Array<IBuyerInfoInput>;
  cancellationPlan?: InputMaybe<CarSalesCancellationEnum>;
  carId?: InputMaybe<Scalars['String']['input']>;
  dealerId: Scalars['String']['input'];
  docPrepFee?: InputMaybe<Scalars['Float']['input']>;
  odometerReading?: InputMaybe<Scalars['String']['input']>;
  paymentDetails?: InputMaybe<IPaymentDetailsInput>;
  paymentSchedule?: InputMaybe<IPaymentScheduleInput>;
  publicFees?: InputMaybe<IPublicFeesInput>;
  recordOfSaleNumber?: InputMaybe<Scalars['String']['input']>;
  salesTaxRate?: InputMaybe<Scalars['Float']['input']>;
  smogFee?: InputMaybe<Scalars['Float']['input']>;
  soldPrice?: InputMaybe<Scalars['Float']['input']>;
  tradeInVehicles?: InputMaybe<Array<ITradeInVehicleInput>>;
}

export interface ICreateChatInput {
  bookingId: Scalars['String']['input'];
  carId?: InputMaybe<Scalars['String']['input']>;
  carImageUrl?: InputMaybe<Scalars['String']['input']>;
  carMake?: InputMaybe<Scalars['String']['input']>;
  carModel?: InputMaybe<Scalars['String']['input']>;
  guestId: Scalars['String']['input'];
  hostId: Scalars['String']['input'];
}

export interface ICreateChatResponse {
  __typename?: 'CreateChatResponse';
  chatId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface ICreateCouponInput {
  applyByDateOrTrip?: InputMaybe<ApplyByDateOrTripEnum>;
  applyToCategory?: InputMaybe<CategoryEnum>;
  applyToGuestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  applyToPriceOf?: InputMaybe<ApplyToPriceOfEnum>;
  applyToProductType?: InputMaybe<ProductType>;
  /** Restrict coupon to DAILY or MONTHLY rentals. Null = both. */
  applyToRentalType?: InputMaybe<RentalTypeEnum>;
  category?: InputMaybe<CouponCategoryEnum>;
  endAt?: InputMaybe<Scalars['Float']['input']>;
  fixAmountValue?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minDays?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  percentageValue?: InputMaybe<Scalars['Float']['input']>;
  priceAlgorithm?: InputMaybe<PriceAlgorithmEnum>;
  startAt?: InputMaybe<Scalars['Float']['input']>;
}

export interface ICreateCrossSiteSsoCodeInput {
  sourceHost?: InputMaybe<Scalars['String']['input']>;
  targetHost: Scalars['String']['input'];
}

export interface ICreateDamageClaimInput {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  afterPhotos?: InputMaybe<Array<Scalars['String']['input']>>;
  anotherPersonInvolved?: InputMaybe<YesNoUnknown>;
  anyoneInjured?: InputMaybe<YesNoUnknown>;
  beforePhotos?: InputMaybe<Array<Scalars['String']['input']>>;
  bookingId: Scalars['String']['input'];
  claimAmount?: InputMaybe<Scalars['Float']['input']>;
  damageDescription?: InputMaybe<Scalars['String']['input']>;
  damageType: DamageType;
  damagedParts?: InputMaybe<Array<DamagedPart>>;
  damagedPartsOtherDescription?: InputMaybe<Scalars['String']['input']>;
  didAirbagsDeploy?: InputMaybe<YesNoUnknown>;
  didVehicleLoseFluids?: InputMaybe<YesNoUnknown>;
  incidentLocation?: InputMaybe<IIncidentLocationInput>;
  incidentOccurredAt?: InputMaybe<Scalars['Float']['input']>;
  isCarDriveable?: InputMaybe<YesNoUnknown>;
  mechanicalIssueOtherDescription?: InputMaybe<Scalars['String']['input']>;
  mechanicalIssues?: InputMaybe<Array<MechanicalIssueType>>;
  physicalDamageSubcategory?: InputMaybe<PhysicalDamageSubcategory>;
  policeReportFiled?: InputMaybe<YesNoUnknown>;
  repairEstimateRange?: InputMaybe<RepairEstimateRange>;
  repairShopInfo?: InputMaybe<IRepairShopInfoInput>;
  waterInsideCar?: InputMaybe<YesNoUnknown>;
  whoWasDriving?: InputMaybe<DriverAtIncident>;
}

export interface ICreateDealerInput {
  certificateExpiresAt: Scalars['DateTime']['input'];
  certificateNumber: Scalars['String']['input'];
  city: Scalars['String']['input'];
  email: Scalars['String']['input'];
  introduction?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
}

export interface ICreateDepositPaymentIntentInput {
  bookingId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
}

export interface ICreateInquiryChatInput {
  checkIn?: InputMaybe<Scalars['String']['input']>;
  checkOut?: InputMaybe<Scalars['String']['input']>;
  guests?: InputMaybe<IGuestCountsInput>;
  listingId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}

export interface ICreateInvoiceInput {
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  breakdown: IInvoiceBreakdownInput;
  couponId?: InputMaybe<Scalars['ID']['input']>;
  damageClaimId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  evidencePhotoS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
  hostDescription?: InputMaybe<Scalars['String']['input']>;
  hostId: Scalars['ID']['input'];
  invoiceSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  newBookingState?: InputMaybe<IBookingStateInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  originalBookingState?: InputMaybe<IBookingStateInput>;
  originalInvoiceId?: InputMaybe<Scalars['String']['input']>;
  paidAt?: InputMaybe<Scalars['DateTime']['input']>;
  paymentAttemptId?: InputMaybe<Scalars['String']['input']>;
  receiptId?: InputMaybe<Scalars['String']['input']>;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  refundStatus?: InputMaybe<RefundStatus>;
  requesterId: Scalars['ID']['input'];
  status: PaymentStatus;
  stripeInvoiceId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  type: InvoiceType;
}

export interface ICreateJobInput {
  accessOverride?: InputMaybe<Scalars['String']['input']>;
  addOns?: InputMaybe<Array<IAddOnChoiceInput>>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  items: Array<IJobItemInput>;
  linkedBookingId?: InputMaybe<Scalars['ID']['input']>;
  platform: Scalars['String']['input'];
  serviceDate: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  windowEnd: Scalars['String']['input'];
  windowStart: Scalars['String']['input'];
  workerCarId: Scalars['ID']['input'];
}

export interface ICreateJobResult {
  __typename?: 'CreateJobResult';
  authorizeNow: Scalars['Boolean']['output'];
  booking: IBooking;
  requiresConfirmation: Scalars['Boolean']['output'];
}

export interface ICreateLocationInput {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
  zipCode: Scalars['String']['input'];
}

export interface ICreateMiscellaneousFeeInput {
  amount?: Scalars['Float']['input'];
  carId: Scalars['String']['input'];
  chargeBy: ChargeType;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
}

export interface ICreateOperatingHoursInput {
  PickupLocationType: PickupLocationType;
  alwaysAvailable?: Scalars['Boolean']['input'];
  fridayAlwaysAvailable?: Scalars['Boolean']['input'];
  fridayAvailable?: Scalars['Boolean']['input'];
  fridayEnd?: Scalars['String']['input'];
  fridayStart?: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
  mondayAlwaysAvailable?: Scalars['Boolean']['input'];
  mondayAvailable?: Scalars['Boolean']['input'];
  mondayEnd?: Scalars['String']['input'];
  mondayStart?: Scalars['String']['input'];
  saturdayAlwaysAvailable?: Scalars['Boolean']['input'];
  saturdayAvailable?: Scalars['Boolean']['input'];
  saturdayEnd?: Scalars['String']['input'];
  saturdayStart?: Scalars['String']['input'];
  sundayAlwaysAvailable?: Scalars['Boolean']['input'];
  sundayAvailable?: Scalars['Boolean']['input'];
  sundayEnd?: Scalars['String']['input'];
  sundayStart?: Scalars['String']['input'];
  thursdayAlwaysAvailable?: Scalars['Boolean']['input'];
  thursdayAvailable?: Scalars['Boolean']['input'];
  thursdayEnd?: Scalars['String']['input'];
  thursdayStart?: Scalars['String']['input'];
  tuesdayAlwaysAvailable?: Scalars['Boolean']['input'];
  tuesdayAvailable?: Scalars['Boolean']['input'];
  tuesdayEnd?: Scalars['String']['input'];
  tuesdayStart?: Scalars['String']['input'];
  wednesdayAlwaysAvailable?: Scalars['Boolean']['input'];
  wednesdayAvailable?: Scalars['Boolean']['input'];
  wednesdayEnd?: Scalars['String']['input'];
  wednesdayStart?: Scalars['String']['input'];
}

export interface ICreatePartialRefundInput {
  amount: Scalars['Float']['input'];
  bookingId: Scalars['String']['input'];
  newEndAt: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}

export interface ICreatePaymentIntentInput {
  amount: Scalars['Float']['input'];
  bookingId: Scalars['String']['input'];
  newEndAt?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentPurpose: PaymentPurpose;
  platform?: InputMaybe<Scalars['String']['input']>;
}

export interface ICreateProductTypeDetailsInput {
  cancellationPolicyMode?: InputMaybe<CancellationPolicyMode>;
  hasAdditionalDrivers?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckInInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckinInspection?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckoutInspection?: InputMaybe<Scalars['Boolean']['input']>;
  hasCleaningFee?: InputMaybe<Scalars['Boolean']['input']>;
  hasDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  hasGuestCounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasHourlyRental?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  hasLastMinuteSurcharge?: InputMaybe<Scalars['Boolean']['input']>;
  hasMileageBilling?: InputMaybe<Scalars['Boolean']['input']>;
  hasMonthlyTiers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOperatingHours?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecurityDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  hasSwap?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripFee?: InputMaybe<Scalars['Boolean']['input']>;
  hasYoungsterFee?: InputMaybe<Scalars['Boolean']['input']>;
  isOn?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriverLicense?: InputMaybe<Scalars['Boolean']['input']>;
  reviewCategorySet?: InputMaybe<ReviewCategorySet>;
  saleAs?: InputMaybe<SaleAs>;
  supportsInstantBook?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRequestToBook?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  timeGranularity?: InputMaybe<TimeGranularity>;
  type: ProductType;
}

export interface ICreateProtectionPlanInput {
  dailyPrice: Scalars['Float']['input'];
  declinedProtectionOutOfPocketAmt?: InputMaybe<DeclinedProtectionOutOfPocketAmt>;
  declinedProtectionOutOfPocketPercent?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isDailyProtectionPlanDeclinable?: InputMaybe<Scalars['Boolean']['input']>;
  isMonthlyProtectionPlanDeclinable?: InputMaybe<Scalars['Boolean']['input']>;
  outOfPocket: Scalars['Float']['input'];
  plan: ProtectionPlanEnum;
  policyDetails?: InputMaybe<Scalars['String']['input']>;
}

export interface ICreatePublicLocationInput {
  address: Scalars['String']['input'];
  /** Three-letter airport code. Required for an airport (D38). */
  airportCode?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  locationType?: InputMaybe<LocationType>;
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
  zipCode: Scalars['String']['input'];
}

export interface ICreateRentalPaymentIntentInput {
  bookingId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
}

export interface ICreateStayBookingInput {
  checkIn: Scalars['String']['input'];
  checkOut: Scalars['String']['input'];
  guests: IGuestCountsInput;
  listingId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}

export interface ICreateStayDraftInput {
  address: IStayAddressInput;
  propertyType: StayPropertyType;
  roomType: StayRoomType;
}

export interface ICreateTripExtensionPaymentInput {
  bookingId: Scalars['ID']['input'];
  newEndAt: Scalars['Float']['input'];
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
}

export interface ICreateTripFeeInput {
  amount?: InputMaybe<Scalars['Float']['input']>;
  chargeBy?: InputMaybe<TripFeeTypeEnums>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  rule?: InputMaybe<TripFeeRuleEnums>;
  uniqName: TripFeeUniqNameEnums;
  userId: Scalars['String']['input'];
}

export interface ICreateUserReportInput {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['String']['input']>;
  evidence: Scalars['String']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  reason: Scalars['String']['input'];
  reportedUserId: Scalars['String']['input'];
}

export interface ICrossSiteSsoCodeResponse {
  __typename?: 'CrossSiteSsoCodeResponse';
  code: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
}

export enum CustomerSessionPurpose {
  Checkout = 'CHECKOUT',
  ExtendTrip = 'EXTEND_TRIP',
  ManageCards = 'MANAGE_CARDS'
}

export interface ICustomerSessionType {
  __typename?: 'CustomerSessionType';
  clientSecret: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  expiresAt: Scalars['Float']['output'];
  publishableKey?: Maybe<Scalars['String']['output']>;
}

/** Side of a driver license image */
export enum DlImageSide {
  Back = 'BACK',
  Front = 'FRONT'
}

/** Driver license verification status options */
export enum DlVerificationStatus {
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  Verified = 'VERIFIED'
}

export interface IDamageClaim {
  __typename?: 'DamageClaim';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  adminNotes?: Maybe<Scalars['String']['output']>;
  afterPhotos?: Maybe<Array<Scalars['String']['output']>>;
  anotherPersonInvolved?: Maybe<YesNoUnknown>;
  anyoneInjured?: Maybe<YesNoUnknown>;
  approvedAmount?: Maybe<Scalars['Float']['output']>;
  beforePhotos?: Maybe<Array<Scalars['String']['output']>>;
  booking: IBooking;
  bookingId: Scalars['String']['output'];
  canRespondToClaimField?: Maybe<ICanRespondToClaimResponse>;
  car: ICar;
  carId: Scalars['String']['output'];
  claimAmount?: Maybe<Scalars['Float']['output']>;
  claimNum: Scalars['String']['output'];
  counterpartyReviewed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  damageDescription?: Maybe<Scalars['String']['output']>;
  damageType: DamageType;
  damagedParts?: Maybe<Array<DamagedPart>>;
  damagedPartsOtherDescription?: Maybe<Scalars['String']['output']>;
  depositPaymentIntentId?: Maybe<Scalars['String']['output']>;
  didAirbagsDeploy?: Maybe<YesNoUnknown>;
  didVehicleLoseFluids?: Maybe<YesNoUnknown>;
  guest: IUser;
  guestId: Scalars['String']['output'];
  guestShouldPay?: Maybe<Scalars['Float']['output']>;
  host: IUser;
  hostClaimAmount?: Maybe<Scalars['Float']['output']>;
  hostId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  incidentLocation?: Maybe<IIncidentLocation>;
  incidentOccurredAt?: Maybe<Scalars['Float']['output']>;
  isCarDriveable?: Maybe<YesNoUnknown>;
  mechanicalIssueOtherDescription?: Maybe<Scalars['String']['output']>;
  mechanicalIssues?: Maybe<Array<MechanicalIssueType>>;
  physicalDamageSubcategory?: Maybe<PhysicalDamageSubcategory>;
  policeReportFiled?: Maybe<YesNoUnknown>;
  protectionPlanSnapshot?: Maybe<IProtectionPlanSnapshot>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  repairEstimateRange?: Maybe<RepairEstimateRange>;
  repairShopInfo?: Maybe<IRepairShopInfo>;
  reporter: IUser;
  reporterId: Scalars['String']['output'];
  responder?: Maybe<IUser>;
  responderId?: Maybe<Scalars['String']['output']>;
  response?: Maybe<IClaimResponse>;
  responseDeadline?: Maybe<Scalars['DateTime']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  reviewer?: Maybe<IUser>;
  shortId?: Maybe<Scalars['String']['output']>;
  status: DamageClaimStatus;
  updatedAt: Scalars['DateTime']['output'];
  waterInsideCar?: Maybe<YesNoUnknown>;
  whoWasDriving?: Maybe<DriverAtIncident>;
}

/** Status of a damage claim */
export enum DamageClaimStatus {
  Approved = 'APPROVED',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Resolved = 'RESOLVED',
  UnderReview = 'UNDER_REVIEW',
  Withdrawn = 'WITHDRAWN'
}

/** Type of damage reported */
export enum DamageType {
  Mechanical = 'MECHANICAL',
  Physical = 'PHYSICAL'
}

/** Parts of the vehicle that can be damaged */
export enum DamagedPart {
  DriverSideBody = 'DRIVER_SIDE_BODY',
  DriverSideFrontTireOrRim = 'DRIVER_SIDE_FRONT_TIRE_OR_RIM',
  DriverSideRearTireOrRim = 'DRIVER_SIDE_REAR_TIRE_OR_RIM',
  DriverSideWindowsOrMirrors = 'DRIVER_SIDE_WINDOWS_OR_MIRRORS',
  FrontBumperOrGrille = 'FRONT_BUMPER_OR_GRILLE',
  FrontHood = 'FRONT_HOOD',
  FrontWindshield = 'FRONT_WINDSHIELD',
  HeadlightsOrTailLights = 'HEADLIGHTS_OR_TAIL_LIGHTS',
  InteriorDamage = 'INTERIOR_DAMAGE',
  MechanicalDamage = 'MECHANICAL_DAMAGE',
  Other = 'OTHER',
  PassengerSideBody = 'PASSENGER_SIDE_BODY',
  PassengerSideFrontTireOrRim = 'PASSENGER_SIDE_FRONT_TIRE_OR_RIM',
  PassengerSideRearTireOrRim = 'PASSENGER_SIDE_REAR_TIRE_OR_RIM',
  PassengerSideWindowsOrMirrors = 'PASSENGER_SIDE_WINDOWS_OR_MIRRORS',
  RearBumper = 'REAR_BUMPER',
  RearWindshield = 'REAR_WINDSHIELD',
  Roof = 'ROOF',
  Trunk = 'TRUNK'
}

export interface IDealer {
  __typename?: 'Dealer';
  carSales?: Maybe<Array<ICarSale>>;
  cars?: Maybe<Array<ICar>>;
  certificateExpiresAt: Scalars['DateTime']['output'];
  certificateNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  introduction?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  sellingCars?: Maybe<Array<ICar>>;
  soldCars?: Maybe<Array<ICar>>;
  state: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  users: Array<IUser>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
}

/** Policy describing guest responsibility when protection is declined */
export enum DeclinedProtectionOutOfPocketAmt {
  UpToTheFullValueOfTheVehicle = 'UP_TO_THE_FULL_VALUE_OF_THE_VEHICLE'
}

export interface IDeleteCarInput {
  id: Scalars['String']['input'];
}

export interface IDeleteLocationResponse {
  __typename?: 'DeleteLocationResponse';
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
}

export interface IDeleteTripPhotoInput {
  bookingId: Scalars['String']['input'];
  imageType: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
}

export interface IDiscount {
  __typename?: 'Discount';
  lastMinBooth: Scalars['Float']['output'];
  nonRefundableDiscount?: Maybe<Scalars['Float']['output']>;
  oneMonth: Scalars['Float']['output'];
  oneWeek: Scalars['Float']['output'];
  threeDays: Scalars['Float']['output'];
  threeMonths: Scalars['Float']['output'];
  threeWeeks: Scalars['Float']['output'];
  twoMonths: Scalars['Float']['output'];
  twoWeeks: Scalars['Float']['output'];
}

export interface IDiscountInput {
  lastMinBooth?: Scalars['Float']['input'];
  oneMonth?: Scalars['Float']['input'];
  oneWeek?: Scalars['Float']['input'];
  threeDays?: Scalars['Float']['input'];
  threeMonths?: Scalars['Float']['input'];
  threeWeeks?: Scalars['Float']['input'];
  twoMonths?: Scalars['Float']['input'];
  twoWeeks?: Scalars['Float']['input'];
}

/** Status of a Stripe dispute for an invoice charge */
export enum DisputeStatus {
  ChargeRefunded = 'CHARGE_REFUNDED',
  Disputed = 'DISPUTED',
  Lost = 'LOST',
  None = 'NONE',
  WarningClosed = 'WARNING_CLOSED',
  WarningNeedsResponse = 'WARNING_NEEDS_RESPONSE',
  WarningUnderReview = 'WARNING_UNDER_REVIEW',
  Won = 'WON'
}

export interface IDistanceLimit {
  __typename?: 'DistanceLimit';
  dailyDistanceLimit: Scalars['Int']['output'];
  /** Per-day allowed mileage for MONTHLY rentals (multiplied by total days for snapshot). */
  monthlyDistanceLimit?: Maybe<Scalars['Int']['output']>;
  /** When true, MONTHLY rentals get unlimited mileage (allowedMileage snapshot = -1). */
  monthlyUnlimitedMileage: Scalars['Boolean']['output'];
  /** mi or km (spec 028). The limits above are in this unit; null is mi. */
  unit?: Maybe<Scalars['String']['output']>;
  unlimitedMileage: Scalars['Boolean']['output'];
}

export interface IDistanceLimitInput {
  dailyDistanceLimit?: Scalars['Int']['input'];
  monthlyDistanceLimit?: InputMaybe<Scalars['Int']['input']>;
  monthlyUnlimitedMileage?: Scalars['Boolean']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unlimitedMileage?: Scalars['Boolean']['input'];
}

/** Who was driving the vehicle when the incident occurred */
export enum DriverAtIncident {
  Guest = 'GUEST',
  NotBeingDriven = 'NOT_BEING_DRIVEN',
  SomeoneElse = 'SOMEONE_ELSE',
  Unknown = 'UNKNOWN'
}

export interface IEphemeralKeyType {
  __typename?: 'EphemeralKeyType';
  apiVersion: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  publishableKey?: Maybe<Scalars['String']['output']>;
  secret: Scalars['String']['output'];
}

export enum ErrorCode {
  AddOnNotOffered = 'ADD_ON_NOT_OFFERED',
  AdvanceNoticeNotMet = 'ADVANCE_NOTICE_NOT_MET',
  AgeLimitBelowBrandMinimum = 'AGE_LIMIT_BELOW_BRAND_MINIMUM',
  AirportNotBookable = 'AIRPORT_NOT_BOOKABLE',
  AppFeatureStale = 'APP_FEATURE_STALE',
  AvailabilityOverlap = 'AVAILABILITY_OVERLAP',
  BrandNotAcceptingBookings = 'BRAND_NOT_ACCEPTING_BOOKINGS',
  BrandRequired = 'BRAND_REQUIRED',
  BrandRulesInvalid = 'BRAND_RULES_INVALID',
  BrandRulesStale = 'BRAND_RULES_STALE',
  CalendarUrlInvalid = 'CALENDAR_URL_INVALID',
  CardholderNameMismatch = 'CARDHOLDER_NAME_MISMATCH',
  CarNotBookable = 'CAR_NOT_BOOKABLE',
  CarRelistRequiresAdmin = 'CAR_RELIST_REQUIRES_ADMIN',
  ChecklistIncomplete = 'CHECKLIST_INCOMPLETE',
  ContentModerationViolation = 'CONTENT_MODERATION_VIOLATION',
  DriverBelowBrandMinimumAge = 'DRIVER_BELOW_BRAND_MINIMUM_AGE',
  DriverLicenseExpired = 'DRIVER_LICENSE_EXPIRED',
  DriverLicenseExpiresBeforeTripEnd = 'DRIVER_LICENSE_EXPIRES_BEFORE_TRIP_END',
  DriverLicenseRejected = 'DRIVER_LICENSE_REJECTED',
  ExtensionBlockedDeclines = 'EXTENSION_BLOCKED_DECLINES',
  Forbidden = 'FORBIDDEN',
  GuestsExceedMax = 'GUESTS_EXCEED_MAX',
  HandoverRequiresBackgroundCheck = 'HANDOVER_REQUIRES_BACKGROUND_CHECK',
  HomePageSettingsInvalid = 'HOME_PAGE_SETTINGS_INVALID',
  HostCapabilityDisabled = 'HOST_CAPABILITY_DISABLED',
  HostCurrencyConflict = 'HOST_CURRENCY_CONFLICT',
  HostListingsPaused = 'HOST_LISTINGS_PAUSED',
  HostNotOnBrand = 'HOST_NOT_ON_BRAND',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  JobAccessNotYet = 'JOB_ACCESS_NOT_YET',
  ListingNotAvailable = 'LISTING_NOT_AVAILABLE',
  LocationNotFound = 'LOCATION_NOT_FOUND',
  LocationOutOfOperatingHours = 'LOCATION_OUT_OF_OPERATING_HOURS',
  NightsOutOfRange = 'NIGHTS_OUT_OF_RANGE',
  NotSupportedForProductType = 'NOT_SUPPORTED_FOR_PRODUCT_TYPE',
  NoTokenProvided = 'NO_TOKEN_PROVIDED',
  OperatingHoursAlreadyExists = 'OPERATING_HOURS_ALREADY_EXISTS',
  OperatingHoursInvalidTime = 'OPERATING_HOURS_INVALID_TIME',
  OperatingHoursNotFound = 'OPERATING_HOURS_NOT_FOUND',
  OperatingHoursNotYetCreated = 'OPERATING_HOURS_NOT_YET_CREATED',
  OutsideServiceArea = 'OUTSIDE_SERVICE_AREA',
  PaymentMethodNotOwned = 'PAYMENT_METHOD_NOT_OWNED',
  PaymentNotVerified = 'PAYMENT_NOT_VERIFIED',
  PaymentRequiresAction = 'PAYMENT_REQUIRES_ACTION',
  PetsNotAllowed = 'PETS_NOT_ALLOWED',
  PolicyAcceptanceIncomplete = 'POLICY_ACCEPTANCE_INCOMPLETE',
  PolicyAcceptanceRequired = 'POLICY_ACCEPTANCE_REQUIRED',
  PolicyAcknowledgmentRequired = 'POLICY_ACKNOWLEDGMENT_REQUIRED',
  PolicyInvalid = 'POLICY_INVALID',
  PolicyVersionOutdated = 'POLICY_VERSION_OUTDATED',
  PolicyVersionStale = 'POLICY_VERSION_STALE',
  ProductTypeNotAllowedOnBrand = 'PRODUCT_TYPE_NOT_ALLOWED_ON_BRAND',
  ProviderNotPublishable = 'PROVIDER_NOT_PUBLISHABLE',
  RecallRelistIncomplete = 'RECALL_RELIST_INCOMPLETE',
  RequestConflict = 'REQUEST_CONFLICT',
  RequestExpired = 'REQUEST_EXPIRED',
  ServiceNotOffered = 'SERVICE_NOT_OFFERED',
  SiteInUse = 'SITE_IN_USE',
  StartAtNot_30MinAhead = 'START_AT_NOT_30MIN_AHEAD',
  StayNotPublishable = 'STAY_NOT_PUBLISHABLE',
  Unauthorized = 'UNAUTHORIZED',
  UnknownBrand = 'UNKNOWN_BRAND',
  UpdateAppToPay = 'UPDATE_APP_TO_PAY',
  UseCreateTripExtensionPayment = 'USE_CREATE_TRIP_EXTENSION_PAYMENT',
  ValidationError = 'VALIDATION_ERROR',
  WindowOutsideHours = 'WINDOW_OUTSIDE_HOURS',
  WindowTooShort = 'WINDOW_TOO_SHORT',
  WorkerNotAssigned = 'WORKER_NOT_ASSIGNED',
  WorkerPaused = 'WORKER_PAUSED',
  WorkerUnavailable = 'WORKER_UNAVAILABLE'
}

export interface IExchangeCrossSiteSsoCodeInput {
  code: Scalars['String']['input'];
  targetHost: Scalars['String']['input'];
}

export interface IExclusiveMarket {
  __typename?: 'ExclusiveMarket';
  label: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  radiusMiles?: Maybe<Scalars['Float']['output']>;
}

export interface IExclusiveMarketInput {
  label: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
}

export interface IExecuteRefundInput {
  amount: Scalars['Float']['input'];
  bookingId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}

/** Recommended extra items that can be added to a rental */
export enum ExtraItem {
  AndroidTypeC = 'ANDROID_TYPE_C',
  ChildSeat = 'CHILD_SEAT',
  Dolly = 'DOLLY',
  IphoneLightning = 'IPHONE_LIGHTNING',
  IphoneTypeC = 'IPHONE_TYPE_C',
  MicroUsb = 'MICRO_USB',
  Other = 'OTHER',
  PhoneHolder = 'PHONE_HOLDER',
  PrepaidEvCharge = 'PREPAID_EV_CHARGE',
  PrepaidGas = 'PREPAID_GAS',
  SnowChain = 'SNOW_CHAIN',
  TripFee = 'TRIP_FEE',
  Wifi = 'WIFI'
}

export interface IFavorite {
  __typename?: 'Favorite';
  car: ICar;
  carId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  user: IUser;
  userId: Scalars['String']['output'];
}

export interface IFindAvailableCarsInput {
  driverAge?: InputMaybe<Scalars['Int']['input']>;
  endAt: Scalars['Float']['input'];
  locationId: Scalars['Int']['input'];
  siteHost?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['Float']['input'];
  type?: InputMaybe<ProductType>;
}

export interface IFindAvailableCarsWithDeliveryInput {
  driverAge?: InputMaybe<Scalars['Int']['input']>;
  endAt: Scalars['Float']['input'];
  filters?: InputMaybe<ICarSearchFiltersInput>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
  siteHost?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['Float']['input'];
  type?: InputMaybe<ProductType>;
}

export interface IForgotPasswordResponse {
  __typename?: 'ForgotPasswordResponse';
  CodeDeliveryDetails?: Maybe<ICodeDeliveryDetailsType>;
}

/** The grade of gas the vehicle uses */
export enum GasGrade {
  Premium = 'PREMIUM',
  Regular = 'REGULAR'
}

/** The type of fuel/power the car uses */
export enum GasType {
  Diesel = 'DIESEL',
  Electric = 'ELECTRIC',
  Gasoline = 'GASOLINE',
  Hybrid = 'HYBRID'
}

/** The type of transmission system */
export enum GearType {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  SemiAutomatic = 'SEMI_AUTOMATIC'
}

export interface IGeneralRating {
  __typename?: 'GeneralRating';
  score: Scalars['Int']['output'];
}

export interface IGeneralRatingInput {
  score: Scalars['Int']['input'];
}

export interface IGeneralVerifyDl {
  __typename?: 'GeneralVerifyDL';
  backDriverLicenseUrl: Scalars['String']['output'];
  /** Back of the licence, a link valid for 15 minutes (owner and admins only). */
  backImageUrl?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  canBeAdditionalDriver: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  frontDriverLicenseUrl: Scalars['String']['output'];
  /** Front of the licence, a link valid for 15 minutes (owner and admins only). */
  frontImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  isVerifiedByAdmin: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  issuingRegion?: Maybe<Scalars['String']['output']>;
  legalFirstName?: Maybe<Scalars['String']['output']>;
  legalLastName?: Maybe<Scalars['String']['output']>;
  legalMiddleName?: Maybe<Scalars['String']['output']>;
  /** The whole licence number, for admins reviewing it; everyone else sees licenceNumberLast4. */
  licenceNumber?: Maybe<Scalars['String']['output']>;
  licenceNumberLast4?: Maybe<Scalars['String']['output']>;
  recheckNote?: Maybe<Scalars['String']['output']>;
  recheckRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedBrandSite?: Maybe<Scalars['String']['output']>;
  submittedVia?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: IUser;
  userId: Scalars['ID']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedByAdmin?: Maybe<IUser>;
  verifiedByAdminId?: Maybe<Scalars['ID']['output']>;
}

export interface IGeoBoundsInput {
  east: Scalars['Float']['input'];
  north: Scalars['Float']['input'];
  south: Scalars['Float']['input'];
  west: Scalars['Float']['input'];
}

export interface IGeoPointRadiusInput {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
}

export interface IGeocodingResult {
  __typename?: 'GeocodingResult';
  city?: Maybe<Scalars['String']['output']>;
  currentLocalTimeISO?: Maybe<Scalars['String']['output']>;
  formattedAddress: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  placeName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
}

export interface IGetCarsByGeoRadiusInput {
  driverAge?: InputMaybe<Scalars['Int']['input']>;
  endAt?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ICarSearchFiltersInput>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
  siteHost?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ProductType>;
}

export interface IGetCarsNearMeInput {
  driverAge?: InputMaybe<Scalars['Int']['input']>;
  endAt?: InputMaybe<Scalars['Float']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  maxRadiusMiles?: InputMaybe<Scalars['Float']['input']>;
  minRadiusMiles?: InputMaybe<Scalars['Float']['input']>;
  siteHost?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<ProductType>;
}

export interface IGetDealerCarsInput {
  dealerId: Scalars['String']['input'];
  type?: InputMaybe<ProductType>;
}

export interface IGetFeaturedCarsInput {
  /** Optional vehicle category. Omit for a mixed featured sample. */
  category?: InputMaybe<CategoryEnum>;
  /** How many cars to return. Default 8. Min 1, max 20. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Branded site host for cross-listing visibility (e.g. autopilotee.com). */
  siteHost?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductType>;
}

export interface IGetMyCarsV2Input {
  /** Page size. Default 20. Min 1, max 50. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Optional location filter. Still scoped to the authenticated owner. */
  locationId?: InputMaybe<Scalars['Int']['input']>;
  /** 1-based page index */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Optional search against make, model, displayName, name, licensePlate, vin (case-insensitive). */
  q?: InputMaybe<Scalars['String']['input']>;
  /** Optional car status filter. Omit = all statuses (incl. deactivated). */
  status?: InputMaybe<CarStatus>;
  /** Optional product type filter (replaces getMyCarsByType for new clients). */
  type?: InputMaybe<ProductType>;
}

export interface IGetMyLocationsV2Input {
  /** Page size. Default 20. Min 1, max 50. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 1-based page index */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Optional search against name, address, city, state, zipCode (case-insensitive). */
  q?: InputMaybe<Scalars['String']['input']>;
}

export interface IGoverningAgreement {
  __typename?: 'GoverningAgreement';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  status: GoverningAgreementStatus;
  version: IPolicyVersion;
}

export enum GoverningAgreementStatus {
  Inferred = 'INFERRED',
  Recorded = 'RECORDED'
}

export interface IGuestCounts {
  __typename?: 'GuestCounts';
  adults: Scalars['Int']['output'];
  children: Scalars['Int']['output'];
  infants: Scalars['Int']['output'];
  pets: Scalars['Int']['output'];
}

export interface IGuestCountsInput {
  adults: Scalars['Int']['input'];
  children?: InputMaybe<Scalars['Int']['input']>;
  infants?: InputMaybe<Scalars['Int']['input']>;
  pets?: InputMaybe<Scalars['Int']['input']>;
}

export interface IGuestRatingData {
  __typename?: 'GuestRatingData';
  accuracy: IAccuracyRating;
  cleanliness: ICleanlinessRating;
  comment?: Maybe<Scalars['String']['output']>;
  communication: ICommunicationRating;
  convenience: IConvenienceRating;
  general: IGeneralRating;
  maintenance: IMaintenanceRating;
}

export interface IGuestRatingInput {
  accuracy: IAccuracyRatingInput;
  cleanliness: ICleanlinessRatingInput;
  comment?: InputMaybe<Scalars['String']['input']>;
  communication: ICommunicationRatingInput;
  convenience: IConvenienceRatingInput;
  general: IGeneralRatingInput;
  maintenance: IMaintenanceRatingInput;
}

export interface IGuestRatingReview {
  __typename?: 'GuestRatingReview';
  carName?: Maybe<Scalars['String']['output']>;
  hostAvatarUrl?: Maybe<Scalars['String']['output']>;
  hostName: Scalars['String']['output'];
  rating: ITripRating;
  tripDate: Scalars['DateTime']['output'];
}

export interface IGuestRatingSummary {
  __typename?: 'GuestRatingSummary';
  averageRating: Scalars['Float']['output'];
  ratingDistribution: IRatingDistribution;
  totalRatings: Scalars['Int']['output'];
}

export interface IGuestRatingsResponse {
  __typename?: 'GuestRatingsResponse';
  reviews: Array<IGuestRatingReview>;
  summary: IGuestRatingSummary;
  totalCount: Scalars['Int']['output'];
}

export interface IHandoverCapExtension {
  __typename?: 'HandoverCapExtension';
  booking: IBooking;
  clientSecret?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
}

export interface IHandoverJobSummary {
  __typename?: 'HandoverJobSummary';
  bookingId: Scalars['ID']['output'];
  brandSite: Scalars['String']['output'];
  jobStatus?: Maybe<JobStatus>;
  serviceDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  windowEndAt: Scalars['Float']['output'];
  windowStartAt: Scalars['Float']['output'];
  workerName?: Maybe<Scalars['String']['output']>;
}

export interface IHoldRecallCampaign {
  __typename?: 'HoldRecallCampaign';
  campaignNumber: Scalars['String']['output'];
  component?: Maybe<Scalars['String']['output']>;
  consequence?: Maybe<Scalars['String']['output']>;
  nhtsaUrl: Scalars['String']['output'];
  overTheAirUpdate: Scalars['Boolean']['output'];
  parkIt: Scalars['Boolean']['output'];
  parkOutSide: Scalars['Boolean']['output'];
  remedy?: Maybe<Scalars['String']['output']>;
  remedyAvailable?: Maybe<Scalars['Boolean']['output']>;
  reportReceivedDate?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
}

export interface IHomeSizeInputType {
  bathrooms: Scalars['Float']['input'];
  bedrooms: Scalars['Int']['input'];
  sameDayTurnover?: InputMaybe<Scalars['Boolean']['input']>;
  sqft?: InputMaybe<Scalars['Int']['input']>;
}

export interface IHostBrand {
  __typename?: 'HostBrand';
  brandSite: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  hostStatus: HostStatus;
  isCurrent: Scalars['Boolean']['output'];
}

export interface IHostCapabilities {
  __typename?: 'HostCapabilities';
  bookingActions: Scalars['Boolean']['output'];
  carAgeLimit: Scalars['Boolean']['output'];
  carDelivery: Scalars['Boolean']['output'];
  carDeposit: Scalars['Boolean']['output'];
  carDiscounts: Scalars['Boolean']['output'];
  carDistanceLimits: Scalars['Boolean']['output'];
  carGuestInstructions: Scalars['Boolean']['output'];
  carHourlyPricing: Scalars['Boolean']['output'];
  carMonthlyPricing: Scalars['Boolean']['output'];
  /** @deprecated 014b: the car settings it grouped */
  carPricing: Scalars['Boolean']['output'];
  carProtectionDecline: Scalars['Boolean']['output'];
  /** @deprecated 014b: the car settings it grouped */
  carRules: Scalars['Boolean']['output'];
  carTripPreferences: Scalars['Boolean']['output'];
  couponsAndDealerTools: Scalars['Boolean']['output'];
  incidentAmounts: Scalars['Boolean']['output'];
  insurance: Scalars['Boolean']['output'];
  licenceReview: Scalars['Boolean']['output'];
  /** @deprecated 014b: tripFees and insurance */
  protectionAndFeesPages: Scalars['Boolean']['output'];
  refundReview: Scalars['Boolean']['output'];
  tripFees: Scalars['Boolean']['output'];
}

export interface IHostCapabilitiesInput {
  bookingActions?: InputMaybe<Scalars['Boolean']['input']>;
  carPricing?: InputMaybe<Scalars['Boolean']['input']>;
  carRules?: InputMaybe<Scalars['Boolean']['input']>;
  couponsAndDealerTools?: InputMaybe<Scalars['Boolean']['input']>;
  incidentAmounts?: InputMaybe<Scalars['Boolean']['input']>;
  insurance?: InputMaybe<Scalars['Boolean']['input']>;
  licenceReview?: InputMaybe<Scalars['Boolean']['input']>;
  protectionAndFeesPages?: InputMaybe<Scalars['Boolean']['input']>;
  refundReview?: InputMaybe<Scalars['Boolean']['input']>;
  tripFees?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface IHostEarningsInput {
  /** Optional subset of the host's vehicle ids. Ids not owned by the host are ignored. Omit/empty = all vehicles. */
  vehicleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Calendar year to report on (e.g. 2026). */
  year: Scalars['Int']['input'];
}

export interface IHostEarningsResponse {
  __typename?: 'HostEarningsResponse';
  earnings: IHostEarningsSummary;
  monthlyEarnings: Array<IHostMonthlyEarnings>;
  vehicleEarnings: Array<IHostVehicleEarnings>;
  vehicleStatusOptions: Array<IVehicleStatusOption>;
}

export interface IHostEarningsSummary {
  __typename?: 'HostEarningsSummary';
  completedEarnings: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  hostIncentives: Scalars['Float']['output'];
  potentialEarnings: Scalars['Float']['output'];
  reimbursements: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  upcomingEarnings: Scalars['Float']['output'];
}

export interface IHostMonthlyEarnings {
  __typename?: 'HostMonthlyEarnings';
  completedEarnings: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  hostIncentives: Scalars['Float']['output'];
  /** 1-12 (January-December). */
  month: Scalars['Int']['output'];
  potentialEarnings: Scalars['Float']['output'];
  reimbursements: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  upcomingEarnings: Scalars['Float']['output'];
}

export interface IHostRatingData {
  __typename?: 'HostRatingData';
  comment?: Maybe<Scalars['String']['output']>;
  general: IGeneralRating;
}

export interface IHostRatingInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  general: IGeneralRatingInput;
}

export interface IHostRatingSummary {
  __typename?: 'HostRatingSummary';
  averageRating: Scalars['Float']['output'];
  ratingDistribution: IRatingDistribution;
  totalRatings: Scalars['Int']['output'];
}

export interface IHostRatingsResponse {
  __typename?: 'HostRatingsResponse';
  reviews: Array<ITripRatingReview>;
  summary: IHostRatingSummary;
  totalCount: Scalars['Int']['output'];
}

/** Host application status */
export enum HostStatus {
  Approved = 'APPROVED',
  NotHost = 'NOT_HOST',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export interface IHostToday {
  __typename?: 'HostToday';
  arrivingToday: Array<IBooking>;
  checkingOut: Array<IBooking>;
  currentlyHosting: Array<IBooking>;
  pendingRequests: Array<IBooking>;
  pendingReviews: Array<IBooking>;
  upcoming: Array<IBooking>;
}

export interface IHostVehicleEarnings {
  __typename?: 'HostVehicleEarnings';
  car: ICar;
  earnings: IHostEarningsSummary;
  status: VehicleEarningsStatus;
}

export interface IHotLocation {
  __typename?: 'HotLocation';
  amount: Scalars['Int']['output'];
  brandSite?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface IHotLocationInput {
  amount: Scalars['Int']['input'];
  city: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  state: Scalars['String']['input'];
}

export interface IHotLocationMonthlySection {
  __typename?: 'HotLocationMonthlySection';
  cars: Array<ICarWithPricingAndDistance>;
  hotLocation: IHotLocation;
}

export interface IHotLocationMonthlySectionsInput {
  driverAge?: InputMaybe<Scalars['Int']['input']>;
  maxRadiusMiles?: InputMaybe<Scalars['Float']['input']>;
  siteHost?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductType>;
}

export interface IHourlyPricingUpdateInput {
  holidayHrPrice?: InputMaybe<Scalars['Float']['input']>;
  hourlyPriceCalendar?: InputMaybe<Array<IPriceCalendarInput>>;
  hourlyRentalIsOn?: InputMaybe<Scalars['Boolean']['input']>;
  weekdayHrPrice?: InputMaybe<Scalars['Float']['input']>;
  weekendHrPrice?: InputMaybe<Scalars['Float']['input']>;
}

export interface IImage {
  __typename?: 'Image';
  imageUrl: Scalars['String']['output'];
}

export interface IImageInput {
  imageUrl: Scalars['String']['input'];
}

export interface IIncidentChargeLineItemInput {
  actualReturnAt?: InputMaybe<Scalars['DateTime']['input']>;
  amount: Scalars['Float']['input'];
  damageClaimId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  incidentType: InvoiceType;
  photoS3Keys: Array<Scalars['String']['input']>;
}

export interface IIncidentInvoiceLineItem {
  __typename?: 'IncidentInvoiceLineItem';
  actualReturnAt?: Maybe<Scalars['DateTime']['output']>;
  amount: Scalars['Float']['output'];
  damageClaimId?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  incidentType: InvoiceType;
  label: Scalars['String']['output'];
  photoS3Keys: Array<Scalars['String']['output']>;
}

export interface IIncidentLocation {
  __typename?: 'IncidentLocation';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
}

export interface IIncidentLocationInput {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
}

export interface IInvoice {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  balance?: Maybe<Scalars['Float']['output']>;
  booking?: Maybe<IBooking>;
  bookingId?: Maybe<Scalars['ID']['output']>;
  breakdown: IInvoiceBreakdown;
  coupon?: Maybe<ICoupon>;
  couponId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  damageClaimId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disputeClosedAt?: Maybe<Scalars['DateTime']['output']>;
  disputeCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  disputeOutcome?: Maybe<Scalars['String']['output']>;
  disputeReason?: Maybe<Scalars['String']['output']>;
  disputeStatus?: Maybe<DisputeStatus>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  evidencePhotoS3Keys?: Maybe<Array<Scalars['String']['output']>>;
  host?: Maybe<IUser>;
  hostApprovedRefund?: Maybe<Scalars['Boolean']['output']>;
  hostDescription?: Maybe<Scalars['String']['output']>;
  hostDisplayName?: Maybe<Scalars['String']['output']>;
  hostId?: Maybe<Scalars['ID']['output']>;
  hostRefundReviewedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  incidentLineItems?: Maybe<Array<IIncidentInvoiceLineItem>>;
  invoiceSentAt?: Maybe<Scalars['DateTime']['output']>;
  newBookingState?: Maybe<IBookingState>;
  note?: Maybe<Scalars['String']['output']>;
  originalBookingState?: Maybe<IBookingState>;
  originalInvoiceId?: Maybe<Scalars['ID']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  receiptId?: Maybe<Scalars['String']['output']>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Float']['output']>;
  refundCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  refundInitiatedAt?: Maybe<Scalars['DateTime']['output']>;
  refundStatus?: Maybe<RefundStatus>;
  requester?: Maybe<IUser>;
  requesterDisplayName?: Maybe<Scalars['String']['output']>;
  requesterId?: Maybe<Scalars['ID']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  status: PaymentStatus;
  stripeDisputeId?: Maybe<Scalars['String']['output']>;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  stripeInvoiceUrl?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  stripeRefundId?: Maybe<Scalars['String']['output']>;
  type: InvoiceType;
  updatedAt: Scalars['DateTime']['output'];
}

export interface IInvoiceBreakdown {
  __typename?: 'InvoiceBreakdown';
  baseRefund?: Maybe<Scalars['Float']['output']>;
  cancellationPenalty?: Maybe<Scalars['Float']['output']>;
  carPricePerTrip?: Maybe<Scalars['Float']['output']>;
  cleaningFee?: Maybe<Scalars['Float']['output']>;
  damageCharges?: Maybe<Scalars['Float']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositRefund?: Maybe<Scalars['Float']['output']>;
  discounts?: Maybe<Scalars['Float']['output']>;
  fuelCharge?: Maybe<Scalars['Float']['output']>;
  insurancePerTrip?: Maybe<Scalars['Float']['output']>;
  insuranceRefund?: Maybe<Scalars['Float']['output']>;
  lateFees?: Maybe<Scalars['Float']['output']>;
  mileageExcess?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  oneWayFee?: Maybe<Scalars['Float']['output']>;
  oneWayFeeRefund?: Maybe<Scalars['Float']['output']>;
  penaltyAmount?: Maybe<Scalars['Float']['output']>;
  promoAmount?: Maybe<Scalars['Float']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  taxRefund?: Maybe<Scalars['Float']['output']>;
  tickets?: Maybe<Scalars['Float']['output']>;
  tolls?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  totalRefund?: Maybe<Scalars['Float']['output']>;
  tripFee?: Maybe<Scalars['Float']['output']>;
  youngsterFee?: Maybe<Scalars['Float']['output']>;
}

export interface IInvoiceBreakdownInput {
  carPricePerTrip?: InputMaybe<Scalars['Float']['input']>;
  insurancePerTrip?: InputMaybe<Scalars['Float']['input']>;
  penaltyAmount?: InputMaybe<Scalars['Float']['input']>;
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  tax?: InputMaybe<Scalars['Float']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
}

export interface IInvoiceFilterInput {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  refundStatus: RefundStatus;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}

/** Types of invoices */
export enum InvoiceType {
  AdditionalDriverFee = 'ADDITIONAL_DRIVER_FEE',
  AdditionalDriverFeeRefund = 'ADDITIONAL_DRIVER_FEE_REFUND',
  CarSwap = 'CAR_SWAP',
  CleaningFee = 'CLEANING_FEE',
  CleaningFeeRefund = 'CLEANING_FEE_REFUND',
  DamageCharge = 'DAMAGE_CHARGE',
  DamageRefund = 'DAMAGE_REFUND',
  Deposit = 'DEPOSIT',
  DepositRefund = 'DEPOSIT_REFUND',
  ExtensionFee = 'EXTENSION_FEE',
  ExtraMileage = 'EXTRA_MILEAGE',
  ExtraMileageRefund = 'EXTRA_MILEAGE_REFUND',
  FuelFeeCharge = 'FUEL_FEE_CHARGE',
  FuelFeeRefund = 'FUEL_FEE_REFUND',
  FullRefund = 'FULL_REFUND',
  LateFee = 'LATE_FEE',
  LateFeeRefund = 'LATE_FEE_REFUND',
  OnewayFee = 'ONEWAY_FEE',
  OnewayFeeRefund = 'ONEWAY_FEE_REFUND',
  OtherFeeCharge = 'OTHER_FEE_CHARGE',
  OtherFeeRefund = 'OTHER_FEE_REFUND',
  PartialRefund = 'PARTIAL_REFUND',
  PartialWithin_24HoursRefund = 'PARTIAL_WITHIN_24_HOURS_REFUND',
  Payment = 'PAYMENT',
  ShortenRefund = 'SHORTEN_REFUND',
  SmokingFee = 'SMOKING_FEE',
  SmokingFeeRefund = 'SMOKING_FEE_REFUND',
  StayGuestChange = 'STAY_GUEST_CHANGE',
  TicketFeeCharge = 'TICKET_FEE_CHARGE',
  TicketFeeRefund = 'TICKET_FEE_REFUND',
  TollFeeCharge = 'TOLL_FEE_CHARGE',
  TollFeeRefund = 'TOLL_FEE_REFUND',
  YoungsterFeeCharge = 'YOUNGSTER_FEE_CHARGE',
  YoungsterFeeRefund = 'YOUNGSTER_FEE_REFUND'
}

export enum IssueKind {
  Damage = 'DAMAGE',
  LeftItem = 'LEFT_ITEM',
  MissingSupplies = 'MISSING_SUPPLIES',
  NotAsDescribed = 'NOT_AS_DESCRIBED',
  NoAccess = 'NO_ACCESS',
  Other = 'OTHER',
  PartyOrMess = 'PARTY_OR_MESS'
}

export interface IJobAccess {
  __typename?: 'JobAccess';
  accessInstructions?: Maybe<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  availableAt: Scalars['DateTime']['output'];
}

export interface IJobAddOn {
  __typename?: 'JobAddOn';
  amount: Scalars['Float']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  photoUrls: Array<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  receiptUrl?: Maybe<Scalars['String']['output']>;
  respondBy: Scalars['DateTime']['output'];
  status: AddOnStatus;
}

export interface IJobCancellationPreview {
  __typename?: 'JobCancellationPreview';
  countsAsLateCancel: Scalars['Boolean']['output'];
  fee: Scalars['Float']['output'];
  message: Scalars['String']['output'];
  refund: Scalars['Float']['output'];
  tier: Scalars['String']['output'];
}

export interface IJobEvent {
  __typename?: 'JobEvent';
  actorRole: Scalars['String']['output'];
  capturedAt?: Maybe<Scalars['DateTime']['output']>;
  checklistItemCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationMismatch?: Maybe<Scalars['Boolean']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  photoUrls: Array<Scalars['String']['output']>;
  receivedAt: Scalars['DateTime']['output'];
  type: JobEventType;
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
}

export enum JobEventType {
  AccessViewed = 'ACCESS_VIEWED',
  AddOnRequested = 'ADD_ON_REQUESTED',
  AddOnResponded = 'ADD_ON_RESPONDED',
  Arrived = 'ARRIVED',
  AutoConfirmed = 'AUTO_CONFIRMED',
  CapExtended = 'CAP_EXTENDED',
  CapReached = 'CAP_REACHED',
  ChecklistItem = 'CHECKLIST_ITEM',
  Completed = 'COMPLETED',
  CustomerConfirmed = 'CUSTOMER_CONFIRMED',
  DisputeOpened = 'DISPUTE_OPENED',
  DisputeResolved = 'DISPUTE_RESOLVED',
  EnRoute = 'EN_ROUTE',
  Issue = 'ISSUE',
  LateCancel = 'LATE_CANCEL',
  NoShow = 'NO_SHOW',
  Photo = 'PHOTO',
  Started = 'STARTED',
  StrikeAppealed = 'STRIKE_APPEALED',
  StrikeResolved = 'STRIKE_RESOLVED'
}

export interface IJobItemInput {
  cleaningLevel?: InputMaybe<CleaningLevel>;
  homeSize?: InputMaybe<IHomeSizeInputType>;
  maxBillableMinutes?: InputMaybe<Scalars['Int']['input']>;
  offeringId: Scalars['ID']['input'];
  vehicleClass?: InputMaybe<VehicleClass>;
}

export enum JobRole {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Provider = 'PROVIDER',
  Worker = 'WORKER'
}

export enum JobStatus {
  Arrived = 'ARRIVED',
  Completed = 'COMPLETED',
  CustomerConfirmed = 'CUSTOMER_CONFIRMED',
  Disputed = 'DISPUTED',
  EnRoute = 'EN_ROUTE',
  InProgress = 'IN_PROGRESS',
  Resolved = 'RESOLVED',
  Scheduled = 'SCHEDULED'
}

export interface IJobTimeline {
  __typename?: 'JobTimeline';
  addOns: Array<IJobAddOn>;
  bookingId: Scalars['ID']['output'];
  checklist: Scalars['JSON']['output'];
  customerNote?: Maybe<Scalars['String']['output']>;
  events: Array<IJobEvent>;
  handoverMinutesSoFar?: Maybe<Scalars['Int']['output']>;
  jobStatus?: Maybe<JobStatus>;
  myRole: JobRole;
}

export interface ILatLng {
  __typename?: 'LatLng';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
}

export interface ILatLngInput {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
}

export enum ListingAddressMode {
  Approximate = 'APPROXIMATE',
  AreaOnly = 'AREA_ONLY',
  Exact = 'EXACT'
}

export interface IListingHold {
  __typename?: 'ListingHold';
  actorName?: Maybe<Scalars['String']['output']>;
  actorType: ListingHoldActorType;
  campaigns: Array<IHoldRecallCampaign>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  pendingManualCheck: Scalars['Boolean']['output'];
  reason: ListingHoldReason;
}

export enum ListingHoldActorType {
  System = 'SYSTEM',
  User = 'USER'
}

/** Why a car is unlisted */
export enum ListingHoldReason {
  Admin = 'ADMIN',
  Host = 'HOST',
  OpenRecall = 'OPEN_RECALL',
  Sold = 'SOLD'
}

export interface ILocation {
  __typename?: 'Location';
  address: Scalars['String']['output'];
  airportCode?: Maybe<Scalars['String']['output']>;
  allowedFromLocations?: Maybe<Array<IAllowedLocation>>;
  allowedToLocations?: Maybe<Array<IAllowedLocation>>;
  cars?: Maybe<Array<ICar>>;
  city: Scalars['String']['output'];
  /** US or CA (spec 028). */
  country: Scalars['String']['output'];
  deliveryLocations?: Maybe<Array<ICarDeliveryLocation>>;
  description?: Maybe<Scalars['String']['output']>;
  enabledOnBrand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  locationType: LocationType;
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  operatingHours?: Maybe<Array<IOperatingHours>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  user: IUser;
  userId: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
}

/** Type of location (standard or airport) */
export enum LocationType {
  Airport = 'AIRPORT',
  Standard = 'STANDARD'
}

/** Maintenance issues that guests can report */
export enum MaintenanceDefectEnum {
  Brakes = 'BRAKES',
  CheckEngineLight = 'CHECK_ENGINE_LIGHT',
  Headlights = 'HEADLIGHTS',
  LowCarBattery = 'LOW_CAR_BATTERY',
  LowOil = 'LOW_OIL',
  LowTirePressure = 'LOW_TIRE_PRESSURE',
  Mirrors = 'MIRRORS',
  Others = 'OTHERS',
  Taillights = 'TAILLIGHTS',
  TireThreads = 'TIRE_THREADS',
  Windshield = 'WINDSHIELD',
  WindshieldWipers = 'WINDSHIELD_WIPERS'
}

export interface IMaintenanceRating {
  __typename?: 'MaintenanceRating';
  improve?: Maybe<Array<MaintenanceDefectEnum>>;
  score: Scalars['Int']['output'];
}

export interface IMaintenanceRatingInput {
  improve?: InputMaybe<Array<MaintenanceDefectEnum>>;
  score: Scalars['Int']['input'];
}

export interface IMakeModelInput {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
}

/** Type of mechanical issue */
export enum MechanicalIssueType {
  BatteryIssue = 'BATTERY_ISSUE',
  BrakesIssue = 'BRAKES_ISSUE',
  BrokeDownNotDriveable = 'BROKE_DOWN_NOT_DRIVEABLE',
  CheckEngineLight = 'CHECK_ENGINE_LIGHT',
  ClutchIssue = 'CLUTCH_ISSUE',
  Other = 'OTHER'
}

export interface IMinimumWageForLocation {
  __typename?: 'MinimumWageForLocation';
  hourlyRate: Scalars['Float']['output'];
  locationId: Scalars['Int']['output'];
  source: Scalars['String']['output'];
}

export interface IMinimumWageRateView {
  __typename?: 'MinimumWageRateView';
  city?: Maybe<Scalars['String']['output']>;
  effectiveFrom: Scalars['String']['output'];
  hourlyRate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  state: Scalars['String']['output'];
}

export interface IMiscellaneousFee {
  __typename?: 'MiscellaneousFee';
  amount: Scalars['Float']['output'];
  car: ICar;
  carId?: Maybe<Scalars['String']['output']>;
  chargeBy: ChargeType;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface IModifyStayInput {
  bookingId: Scalars['ID']['input'];
  checkIn: Scalars['String']['input'];
  checkOut: Scalars['String']['input'];
  guests: IGuestCountsInput;
}

export interface IMutation {
  __typename?: 'Mutation';
  /** An additional driver of the trip, signed in as themselves: accepts the trip's governing agreement version (FR-036). Refusals: POLICY_VERSION_OUTDATED when the id is not the trip's governing version. */
  acceptAdditionalDriverAgreement: Array<IPolicyAcceptanceRecord>;
  /** Guest of a PENDING or CARD_DECLINED booking. Idempotent. Refusals: POLICY_VERSION_OUTDATED (details.current), POLICY_ACCEPTANCE_INCOMPLETE (details.missing). */
  acceptBookingPolicies: Array<IPolicyAcceptanceRecord>;
  acceptBookingRequest: IBooking;
  acceptExtensionPolicies: Array<IPolicyAcceptanceRecord>;
  acceptJob: IBooking;
  acceptPendingPolicies: Array<IPolicyAcceptanceRecord>;
  acceptWorkerInvite: IWorkerAccount;
  addCarToSelling: IDealer;
  addDamageClaimNotes: IDamageClaim;
  addDriverToBooking: IBooking;
  addFavorite: IFavorite;
  addNewCar: ICar;
  adminCancelBookingForPausedHost: IBooking;
  adminCancelBookingForUnlistedCar: IBooking;
  adminEndTripEarlyForRecall: IBooking;
  adminRelistCar: ICar;
  adminUnlistCar: ICar;
  appealWorkerStrike: IJobEvent;
  applyToBeHost: IUser;
  approveCarSwap: IBooking;
  calculateTripExtension: ITripExtensionResponse;
  cancelBooking: IBooking;
  cancelJob: IBooking;
  cancelStayBooking: IBooking;
  chargeExtraMileage: IChargePostTripFeeResult;
  chargeIncidentFee: IChargePostTripFeeResult;
  chargeIncidentFees: IChargePostTripFeeResult;
  checkCarAvailability: IAvailabilityResponse;
  completeGuestCheckin: IBooking;
  completeGuestCheckout: IBooking;
  completeHostCheckin: IBooking;
  completeHostCheckout: IBooking;
  confirmBooking: IBooking;
  confirmForgotPassword: IConfirmForgotPasswordResponse;
  confirmHandoverCapExtension: IBooking;
  confirmJobCompletion: IBooking;
  confirmOutstandingInvoicePayment: IOutstandingInvoicePaymentResult;
  confirmSavedCard: IConfirmSavedCardResult;
  confirmSignUp: IConfirmSignUpResponse;
  confirmStayModification: IStayModificationResult;
  confirmTripExtension: ITripExtensionResponse;
  copyWorkerSettings: IProviderWorker;
  createBookingIntent: IBooking;
  createBrand: IBrand;
  createBroadcast: IBroadcast;
  createCarAvailabilitiesBulk: ICreateCarAvailabilitiesBulkResponse;
  createCarAvailability: ICarAvailability;
  createCarMakeAndModel: ICarMakeAndModel;
  createCarSale: ICarSale;
  createCoupon: ICoupon;
  createCrossSiteSsoCode: ICrossSiteSsoCodeResponse;
  createCustomerSession: ICustomerSessionType;
  createDamageClaim: IDamageClaim;
  createDealer: IDealer;
  createDepositPaymentIntent: IPaymentIntentType;
  createEphemeralKey: IEphemeralKeyType;
  createHotLocation: IHotLocation;
  createInquiryChat: ICreateChatResponse;
  createInvoice: IInvoice;
  createJobIntent: ICreateJobResult;
  createLocation: ILocation;
  createMiscellaneousFee: IMiscellaneousFee;
  createOidcUser: IUser;
  createOperatingHours: IOperatingHours;
  createPaymentIntent: IPaymentIntentType;
  createPresignedUrlForRecallEvidence: IPresignedUpload;
  createProductTypeDetails: IProductTypeDetails;
  createProtectionPlan: IProtectionPlan;
  createPublicLocation: ILocation;
  createRefundForInvoice: IInvoice;
  createRefundInvoice: IInvoice;
  createRentalPaymentIntent: IPaymentIntentType;
  createServiceSite: IServiceSite;
  createSetupIntentForBooking: ISetupIntentType;
  createSetupIntentForSavedCard: ISavedCardSetupType;
  createShortenRefundInvoice: IInvoice;
  createStayBookingIntent: IStayBookingIntent;
  createStayBookingRequest: IStayBookingIntent;
  createStayDraft: ICar;
  createTripExtensionPayment: ITripExtensionPaymentResult;
  createTripFee: ITripFee;
  createUserReport: IUserReport;
  createWorkerDraft: IProviderWorker;
  deactivateServiceSite: IServiceSite;
  declineBookingRequest: IBooking;
  declineJob: IBooking;
  deleteAccount: Scalars['Boolean']['output'];
  deleteBroadcast: Scalars['Boolean']['output'];
  deleteCar: Array<ICar>;
  deleteCarMakeAndModel: Scalars['Boolean']['output'];
  deleteCoupon: Scalars['Boolean']['output'];
  deleteHotLocation: Scalars['Boolean']['output'];
  deleteNotification: Scalars['Boolean']['output'];
  deleteServiceOffering: IProviderWorker;
  deleteStayDraft: Scalars['Boolean']['output'];
  deleteTripPhoto: IBooking;
  discardPolicyDraft: Scalars['Boolean']['output'];
  disputeJob: IBooking;
  exchangeCrossSiteSsoCode: IAuthResponse;
  executeRefund: IRefundResponse;
  extendHandoverCap: IHandoverCapExtension;
  flagGeneralDLForRecheck: IGeneralVerifyDl;
  forceApproveCarSwap: IBooking;
  forceDeclineCarSwap: IBooking;
  getFirebaseCustomToken: Scalars['String']['output'];
  getOrCreateChat: ICreateChatResponse;
  getPaymentMethod: IStripePaymentMethod;
  getPaymentMethodFromSetupIntent: IStripePaymentMethod;
  getPresignedUrl: IPresignedUrlResponse;
  getPresignedUrlForBooking: IPresignedUrlResponse;
  getPresignedUrlForBrandBanner: IBrandBannerUploadUrl;
  getPresignedUrlForDLVerification: IPresignedUrlResponse;
  getPresignedUrlForDamageClaim: IPresignedUrlResponse;
  getPresignedUrlForGeneralDL: IPresignedUrlResponse;
  getPresignedUrlForJobPhoto: IServiceDocumentUpload;
  getPresignedUrlForReport: IPresignedUrlResponse;
  getPresignedUrlForServiceDocument: IServiceDocumentUpload;
  getPresignedUrls: Array<IPresignedUrlResponse>;
  holdSecurityDeposit: IBooking;
  inviteWorker: IWorkerAccount;
  markAllNotificationsAsRead: Scalars['Boolean']['output'];
  markCarAsCreated: ICar;
  markCarAsSold: ICar;
  markChatAsRead: Scalars['Boolean']['output'];
  markNotificationAsRead: Scalars['Boolean']['output'];
  markPayoutBatchPaid: IServicePayoutBatch;
  modifyStayBooking: IStayModificationResult;
  payOutstandingInvoice: IOutstandingInvoicePaymentResult;
  processInvoicePayment: IInvoice;
  /** Refusals: POLICY_ACKNOWLEDGMENT_REQUIRED, POLICY_VERSION_STALE, POLICY_INVALID (details.errors[] { field, problem }). Writes the publisher_ack acceptance and the version in one transaction. */
  publishPolicyVersion: IPolicyVersion;
  publishStay: ICar;
  publishWorker: IProviderWorker;
  reconcileReferralCommission?: Maybe<IReferralCommission>;
  recordJobEvent: IJobTimeline;
  recordRecallCheck: IRecallCheck;
  refreshInvoiceRefundStatus: IInvoice;
  refreshTokens: IAuthResponse;
  rejectCarSwap: IBooking;
  rejectDLAndCancelBooking: IBooking;
  releaseSecurityDeposit: IBooking;
  removeAllCarAvailabilities: IRemoveCarAvailabilitiesResponse;
  removeBookingPenalties: IBooking;
  removeCarAvailabilitiesByDates: IRemoveCarAvailabilitiesResponse;
  removeCarAvailability: Scalars['Boolean']['output'];
  removeCarDeliveryLocation: Scalars['Boolean']['output'];
  removeDealer: Scalars['Boolean']['output'];
  removeDriverFromBooking: IBooking;
  removeFavorite: Scalars['Boolean']['output'];
  removeInvoice: Scalars['Boolean']['output'];
  removeLocation: IDeleteLocationResponse;
  removeMiscellaneousFee: IRemoveMiscellaneousFeeResponse;
  removeOperatingHours: Scalars['Boolean']['output'];
  removePaymentMethod: IRemovePaymentMethodResult;
  removeProtectionPlan: Scalars['Boolean']['output'];
  removeProtectionPlanByUserId: Scalars['Boolean']['output'];
  removeTripFee: Array<ITripFee>;
  removeWorkerAccount: Scalars['Boolean']['output'];
  reorderHotLocations: Array<IHotLocation>;
  requestAddDriverToBooking: IAddDriverToBookingResult;
  requestCarSwap: IBooking;
  requestJobAddOn: IJobAddOn;
  requestJobPhotoArchive: Scalars['String']['output'];
  requestJobRefund: IDamageClaim;
  resendConfirmationCode: IResendConfirmationCodeResponse;
  resolveJobDispute: IBooking;
  resolveWorkerStrike: IJobEvent;
  respondJobAddOn: IJobAddOn;
  respondToDamageClaim: IDamageClaim;
  resumeHostListings: IUser;
  resumeWorker: ICar;
  revealStayInstructions: IStayInstructions;
  reviewGeneralDLVerification: IGeneralVerifyDl;
  reviewHostApplication: IUser;
  revokeHostApproval: IUser;
  savePolicyDraft: IPolicyVersion;
  scheduleBroadcast: IBroadcast;
  sendBroadcast: IBroadcast;
  sendContactFormEmail: ISendEmailResponse;
  sendForgotPasswordEmail: IForgotPasswordResponse;
  sendMessage: ISendMessageResponse;
  sendPhoneOtp: Scalars['Boolean']['output'];
  sendTestEmail: ISendEmailResponse;
  setAirportActive: ILocation;
  setAllowedLocation: IAllowedLocation;
  setBrandAdmin: IBrandMembership;
  setBrandAirportEnabled: ILocation;
  setBrandAppFeature: IBrandAppFeature;
  setCarDeliveryLocation: ICarDeliveryLocation;
  setDefaultPaymentMethod: ISavedPaymentMethod;
  setServiceTaxRule: IServiceTaxRule;
  signIn: IAuthResponse;
  signInWithApple: IAuthResponse;
  signInWithGoogle: IAuthResponse;
  signOutCurrentDevice: Scalars['String']['output'];
  signUp: IUser;
  snoozeStay: ICar;
  submitDLVerification: IBooking;
  submitGeneralDLVerification: IGeneralVerifyDl;
  submitGuestRating: ITripRating;
  submitHostRating: ITripRating;
  submitHostReply: ITripRating;
  submitProviderInsurance: IServiceProvider;
  submitProviderTaxInfo: IProviderTaxInfoSummary;
  submitServiceCustomerRating: ITripRating;
  submitServiceWorkerRating: ITripRating;
  submitStayGuestRating: ITripRating;
  submitStayHostRating: ITripRating;
  submitWorkerBackgroundCheck: IProviderWorker;
  suspendHostListings: IUser;
  syncServiceJobPayment: IBooking;
  syncServiceSiteCalendar: IServiceSite;
  syncStayBookingRequest: IBooking;
  unlistStay: ICar;
  unlistWorker: IProviderWorker;
  unscheduleBroadcast: IBroadcast;
  updateActualReturnDateTime: IBooking;
  updateAirport: ILocation;
  updateBooking: IUpdateBookingResponse;
  updateBookingMinimumRentalDays: IBooking;
  updateBookingProtectionPlan: IBooking;
  updateBrandAliases: IBrand;
  updateBrandProductTypes: IBrand;
  updateBrandRules: IBrandRules;
  updateBrandSettings: IBrand;
  updateBrandStripeSecrets: IBrand;
  updateBroadcast: IBroadcast;
  updateCar: ICar;
  updateCarDiscount: ICar;
  updateCarHourlyPricing: ICar;
  updateCarImages: ICar;
  updateCarMakeAndModel: ICarMakeAndModel;
  updateCarSale: ICarSale;
  updateCarTripPreferences: ICar;
  updateCoupon: ICoupon;
  updateDamageClaimStatus: IDamageClaim;
  updateDealer: IDealer;
  updateDistanceLimit: ICar;
  updateFcmToken: Scalars['Boolean']['output'];
  updateGuestRatingValidity: ITripRating;
  updateHostRatingValidity: ITripRating;
  updateHotLocation: IHotLocation;
  updateHourlyPriceCalendar: ICar;
  updateInvoice: IInvoice;
  updateJobAccess: IBooking;
  updateLocation: ILocation;
  updateMiscellaneousFee: IMiscellaneousFee;
  /** @deprecated Hosts no longer have referral settings; the brand admin sets the rate. */
  updateMyReferralSettings: IUser;
  updateOperatingHours: IOperatingHours;
  updatePlatformReferralRates: IPlatformSetting;
  updatePlatformSiteMarkers: Array<Scalars['String']['output']>;
  updatePriceCalendar: ICar;
  updateProductTypeDetails: IProductTypeDetails;
  updateProtectionPlan: IProtectionPlan;
  updateServiceFeeRates: IServiceFeeRates;
  updateServiceSite: IServiceSite;
  updateStay: ICar;
  updateStayPhotos: ICar;
  updateStayServiceFeeRates: IStayServiceFeeRates;
  updateTripFee: ITripFee;
  updateTripPreferences: ICar;
  updateUser: IUser;
  updateUserReportStatus: IUserReport;
  updateWorker: IProviderWorker;
  updateWorkerEquipmentPhotos: IProviderWorker;
  uploadTripPhoto: IBooking;
  upsertMinimumWageRate: IMinimumWageRateView;
  upsertServiceOffering: IProviderWorker;
  upsertServiceProvider: IServiceProvider;
  verifyBookingPayment: IBooking;
  verifyGuestDL: IBooking;
  verifyPhoneOtp: IUser;
  verifyProviderInsurance: IServiceProvider;
  verifyWorkerBackgroundCheck: IProviderWorker;
  withdrawBookingRequest: IBooking;
  withdrawDamageClaim: IDamageClaim;
  withdrawJob: IBooking;
}


export interface IMutationAcceptAdditionalDriverAgreementArgs {
  bookingId: Scalars['ID']['input'];
  input: IAcceptPoliciesInput;
}


export interface IMutationAcceptBookingPoliciesArgs {
  bookingId: Scalars['ID']['input'];
  input: IAcceptPoliciesInput;
}


export interface IMutationAcceptBookingRequestArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IMutationAcceptExtensionPoliciesArgs {
  bookingId: Scalars['ID']['input'];
  input: IAcceptPoliciesInput;
}


export interface IMutationAcceptJobArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IMutationAcceptPendingPoliciesArgs {
  input: IAcceptPoliciesInput;
}


export interface IMutationAcceptWorkerInviteArgs {
  token: Scalars['String']['input'];
}


export interface IMutationAddCarToSellingArgs {
  addCarToSellingInput: IAddCarToSellingInput;
}


export interface IMutationAddDamageClaimNotesArgs {
  input: IAddAdminNotesInput;
}


export interface IMutationAddDriverToBookingArgs {
  input: IAddDriverInput;
}


export interface IMutationAddFavoriteArgs {
  input: IAddFavoriteInput;
}


export interface IMutationAddNewCarArgs {
  newCarData: INewCarInput;
}


export interface IMutationAdminCancelBookingForPausedHostArgs {
  bookingId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationAdminCancelBookingForUnlistedCarArgs {
  bookingId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationAdminEndTripEarlyForRecallArgs {
  bookingId: Scalars['ID']['input'];
  endAt: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationAdminRelistCarArgs {
  input: IAdminRelistCarInput;
}


export interface IMutationAdminUnlistCarArgs {
  carId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
}


export interface IMutationAppealWorkerStrikeArgs {
  eventId: Scalars['ID']['input'];
  fileKey?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
}


export interface IMutationApplyToBeHostArgs {
  hostAgreement?: InputMaybe<IPolicyAcceptanceInput>;
  siteUrl?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationApproveCarSwapArgs {
  input: ICarSwapResponseInput;
}


export interface IMutationCalculateTripExtensionArgs {
  input: ICalculateTripExtensionInput;
}


export interface IMutationCancelBookingArgs {
  balance: Scalars['Float']['input'];
  bookingId: Scalars['String']['input'];
  bookingStatus: BookingStatus;
  cancellationPenalty: Scalars['Float']['input'];
  cancellationReason: CancellationReason;
  cancelledInitiatedAt: Scalars['DateTime']['input'];
  invoiceId: Scalars['ID']['input'];
  isCancellationPenaltyApplied: Scalars['Boolean']['input'];
}


export interface IMutationCancelJobArgs {
  appealNote?: InputMaybe<Scalars['String']['input']>;
  bookingId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationCancelStayBookingArgs {
  bookingId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationChargeExtraMileageArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IMutationChargeIncidentFeeArgs {
  input: IChargeIncidentFeeInput;
}


export interface IMutationChargeIncidentFeesArgs {
  input: IChargeIncidentFeesInput;
}


export interface IMutationCheckCarAvailabilityArgs {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  carId: Scalars['String']['input'];
  endAt: Scalars['Float']['input'];
  startAt: Scalars['Float']['input'];
}


export interface IMutationCompleteGuestCheckinArgs {
  input: ICompleteGuestCheckinInput;
}


export interface IMutationCompleteGuestCheckoutArgs {
  input: ICompleteGuestCheckoutInput;
}


export interface IMutationCompleteHostCheckinArgs {
  input: ICompleteHostCheckinInput;
}


export interface IMutationCompleteHostCheckoutArgs {
  input: ICompleteHostCheckoutInput;
}


export interface IMutationConfirmBookingArgs {
  confirmBookingInput: IConfirmBookingInput;
}


export interface IMutationConfirmForgotPasswordArgs {
  input: IConfirmForgotPasswordInput;
}


export interface IMutationConfirmHandoverCapExtensionArgs {
  bookingId: Scalars['ID']['input'];
  paymentIntentId: Scalars['ID']['input'];
}


export interface IMutationConfirmJobCompletionArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IMutationConfirmOutstandingInvoicePaymentArgs {
  invoiceId: Scalars['ID']['input'];
  paymentIntentId: Scalars['String']['input'];
}


export interface IMutationConfirmSavedCardArgs {
  setupIntentId: Scalars['String']['input'];
}


export interface IMutationConfirmSignUpArgs {
  input: IConfirmSignUpInput;
}


export interface IMutationConfirmStayModificationArgs {
  input: IConfirmStayModificationInput;
}


export interface IMutationConfirmTripExtensionArgs {
  input: IConfirmTripExtensionInput;
}


export interface IMutationCopyWorkerSettingsArgs {
  fromWorkerCarId: Scalars['ID']['input'];
  toWorkerCarId: Scalars['ID']['input'];
}


export interface IMutationCreateBookingIntentArgs {
  createBookingInput: ICreateBookingInput;
}


export interface IMutationCreateBrandArgs {
  input: ICreateBrandInput;
}


export interface IMutationCreateBroadcastArgs {
  input: ICreateBroadcastInput;
}


export interface IMutationCreateCarAvailabilitiesBulkArgs {
  input: ICreateCarAvailabilitiesBulkInput;
}


export interface IMutationCreateCarAvailabilityArgs {
  input: ICreateCarAvailabilityInput;
}


export interface IMutationCreateCarMakeAndModelArgs {
  input: ICreateCarMakeAndModelInput;
}


export interface IMutationCreateCarSaleArgs {
  createCarSaleInput: ICreateCarSaleInput;
}


export interface IMutationCreateCouponArgs {
  input: ICreateCouponInput;
}


export interface IMutationCreateCrossSiteSsoCodeArgs {
  input: ICreateCrossSiteSsoCodeInput;
}


export interface IMutationCreateCustomerSessionArgs {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  purpose: CustomerSessionPurpose;
}


export interface IMutationCreateDamageClaimArgs {
  input: ICreateDamageClaimInput;
}


export interface IMutationCreateDealerArgs {
  createDealerInput: ICreateDealerInput;
}


export interface IMutationCreateDepositPaymentIntentArgs {
  input: ICreateDepositPaymentIntentInput;
}


export interface IMutationCreateHotLocationArgs {
  input: IHotLocationInput;
}


export interface IMutationCreateInquiryChatArgs {
  input: ICreateInquiryChatInput;
}


export interface IMutationCreateInvoiceArgs {
  createInvoiceInput: ICreateInvoiceInput;
}


export interface IMutationCreateJobIntentArgs {
  input: ICreateJobInput;
}


export interface IMutationCreateLocationArgs {
  createLocationInput: ICreateLocationInput;
}


export interface IMutationCreateMiscellaneousFeeArgs {
  input: ICreateMiscellaneousFeeInput;
}


export interface IMutationCreateOidcUserArgs {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationCreateOperatingHoursArgs {
  createOperatingHoursInput: ICreateOperatingHoursInput;
}


export interface IMutationCreatePaymentIntentArgs {
  input: ICreatePaymentIntentInput;
}


export interface IMutationCreatePresignedUrlForRecallEvidenceArgs {
  carId: Scalars['ID']['input'];
  contentLength: Scalars['Int']['input'];
  fileType: Scalars['String']['input'];
}


export interface IMutationCreateProductTypeDetailsArgs {
  input: ICreateProductTypeDetailsInput;
}


export interface IMutationCreateProtectionPlanArgs {
  input: ICreateProtectionPlanInput;
}


export interface IMutationCreatePublicLocationArgs {
  input: ICreatePublicLocationInput;
}


export interface IMutationCreateRefundForInvoiceArgs {
  invoiceId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationCreateRefundInvoiceArgs {
  bookingId: Scalars['String']['input'];
}


export interface IMutationCreateRentalPaymentIntentArgs {
  input: ICreateRentalPaymentIntentInput;
}


export interface IMutationCreateServiceSiteArgs {
  input: IServiceSiteInput;
}


export interface IMutationCreateSetupIntentForBookingArgs {
  bookingId: Scalars['String']['input'];
  showSavedCards?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface IMutationCreateShortenRefundInvoiceArgs {
  input: ICreatePartialRefundInput;
}


export interface IMutationCreateStayBookingIntentArgs {
  input: ICreateStayBookingInput;
}


export interface IMutationCreateStayBookingRequestArgs {
  input: ICreateStayBookingInput;
}


export interface IMutationCreateStayDraftArgs {
  input: ICreateStayDraftInput;
}


export interface IMutationCreateTripExtensionPaymentArgs {
  input: ICreateTripExtensionPaymentInput;
}


export interface IMutationCreateTripFeeArgs {
  input: ICreateTripFeeInput;
}


export interface IMutationCreateUserReportArgs {
  input: ICreateUserReportInput;
}


export interface IMutationCreateWorkerDraftArgs {
  displayName: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
}


export interface IMutationDeactivateServiceSiteArgs {
  siteId: Scalars['ID']['input'];
}


export interface IMutationDeclineBookingRequestArgs {
  bookingId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationDeclineJobArgs {
  bookingId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationDeleteBroadcastArgs {
  id: Scalars['String']['input'];
}


export interface IMutationDeleteCarArgs {
  deleteCarData: IDeleteCarInput;
}


export interface IMutationDeleteCarMakeAndModelArgs {
  id: Scalars['String']['input'];
}


export interface IMutationDeleteCouponArgs {
  id: Scalars['ID']['input'];
}


export interface IMutationDeleteHotLocationArgs {
  id: Scalars['String']['input'];
}


export interface IMutationDeleteNotificationArgs {
  notificationId: Scalars['String']['input'];
}


export interface IMutationDeleteServiceOfferingArgs {
  offeringId: Scalars['ID']['input'];
}


export interface IMutationDeleteStayDraftArgs {
  id: Scalars['ID']['input'];
}


export interface IMutationDeleteTripPhotoArgs {
  input: IDeleteTripPhotoInput;
}


export interface IMutationDiscardPolicyDraftArgs {
  draftId: Scalars['ID']['input'];
}


export interface IMutationDisputeJobArgs {
  bookingId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  photoKeys?: InputMaybe<Array<Scalars['String']['input']>>;
}


export interface IMutationExchangeCrossSiteSsoCodeArgs {
  input: IExchangeCrossSiteSsoCodeInput;
}


export interface IMutationExecuteRefundArgs {
  input: IExecuteRefundInput;
}


export interface IMutationExtendHandoverCapArgs {
  bookingId: Scalars['ID']['input'];
  maxBillableMinutes: Scalars['Int']['input'];
}


export interface IMutationFlagGeneralDlForRecheckArgs {
  note: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}


export interface IMutationForceApproveCarSwapArgs {
  input: ICarSwapResponseInput;
}


export interface IMutationForceDeclineCarSwapArgs {
  input: ICarSwapResponseInput;
}


export interface IMutationGetOrCreateChatArgs {
  input: ICreateChatInput;
}


export interface IMutationGetPaymentMethodArgs {
  paymentMethodId: Scalars['String']['input'];
}


export interface IMutationGetPaymentMethodFromSetupIntentArgs {
  setupIntentId: Scalars['String']['input'];
}


export interface IMutationGetPresignedUrlArgs {
  carId: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
}


export interface IMutationGetPresignedUrlForBookingArgs {
  bookingId: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  imageType: Scalars['String']['input'];
}


export interface IMutationGetPresignedUrlForBrandBannerArgs {
  contentLength: Scalars['Int']['input'];
  fileType: Scalars['String']['input'];
}


export interface IMutationGetPresignedUrlForDlVerificationArgs {
  bookingId: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  photoType: Scalars['String']['input'];
}


export interface IMutationGetPresignedUrlForDamageClaimArgs {
  claimId: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  photoType: Scalars['String']['input'];
}


export interface IMutationGetPresignedUrlForGeneralDlArgs {
  fileType: Scalars['String']['input'];
  side: DlImageSide;
}


export interface IMutationGetPresignedUrlForJobPhotoArgs {
  bookingId: Scalars['ID']['input'];
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  receipt?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface IMutationGetPresignedUrlForReportArgs {
  fileType: Scalars['String']['input'];
}


export interface IMutationGetPresignedUrlForServiceDocumentArgs {
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
}


export interface IMutationGetPresignedUrlsArgs {
  carId: Scalars['String']['input'];
  count: Scalars['Float']['input'];
  fileType: Scalars['String']['input'];
}


export interface IMutationHoldSecurityDepositArgs {
  bookingId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationInviteWorkerArgs {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  workerCarId: Scalars['ID']['input'];
}


export interface IMutationMarkCarAsCreatedArgs {
  carId: Scalars['String']['input'];
}


export interface IMutationMarkCarAsSoldArgs {
  carId: Scalars['String']['input'];
}


export interface IMutationMarkChatAsReadArgs {
  chatId: Scalars['String']['input'];
}


export interface IMutationMarkNotificationAsReadArgs {
  notificationId: Scalars['String']['input'];
}


export interface IMutationMarkPayoutBatchPaidArgs {
  batchId: Scalars['ID']['input'];
  reference: Scalars['String']['input'];
}


export interface IMutationModifyStayBookingArgs {
  input: IModifyStayInput;
}


export interface IMutationPayOutstandingInvoiceArgs {
  input: IPayOutstandingInvoiceInput;
}


export interface IMutationProcessInvoicePaymentArgs {
  id: Scalars['ID']['input'];
}


export interface IMutationPublishPolicyVersionArgs {
  input: IPublishPolicyVersionInput;
}


export interface IMutationPublishStayArgs {
  id: Scalars['ID']['input'];
}


export interface IMutationPublishWorkerArgs {
  workerCarId: Scalars['ID']['input'];
}


export interface IMutationReconcileReferralCommissionArgs {
  bookingId: Scalars['String']['input'];
}


export interface IMutationRecordJobEventArgs {
  input: IRecordJobEventInput;
}


export interface IMutationRecordRecallCheckArgs {
  input: IRecordRecallCheckInput;
}


export interface IMutationRefreshInvoiceRefundStatusArgs {
  invoiceId: Scalars['ID']['input'];
}


export interface IMutationRefreshTokensArgs {
  refreshToken: Scalars['String']['input'];
}


export interface IMutationRejectCarSwapArgs {
  input: ICarSwapResponseInput;
}


export interface IMutationRejectDlAndCancelBookingArgs {
  input: IRejectDlInput;
}


export interface IMutationReleaseSecurityDepositArgs {
  bookingId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  releaseAmount: Scalars['Float']['input'];
}


export interface IMutationRemoveAllCarAvailabilitiesArgs {
  carId: Scalars['String']['input'];
}


export interface IMutationRemoveBookingPenaltiesArgs {
  input: IRemoveBookingPenaltiesInput;
}


export interface IMutationRemoveCarAvailabilitiesByDatesArgs {
  carId: Scalars['String']['input'];
  ranges: Array<IAvailabilityPeriodInput>;
}


export interface IMutationRemoveCarAvailabilityArgs {
  id: Scalars['String']['input'];
}


export interface IMutationRemoveCarDeliveryLocationArgs {
  input: IRemoveCarDeliveryLocationInput;
}


export interface IMutationRemoveDealerArgs {
  id: Scalars['String']['input'];
}


export interface IMutationRemoveDriverFromBookingArgs {
  input: IAddDriverInput;
}


export interface IMutationRemoveFavoriteArgs {
  input: IRemoveFavoriteInput;
}


export interface IMutationRemoveInvoiceArgs {
  id: Scalars['ID']['input'];
}


export interface IMutationRemoveLocationArgs {
  id: Scalars['Int']['input'];
}


export interface IMutationRemoveMiscellaneousFeeArgs {
  carId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}


export interface IMutationRemoveOperatingHoursArgs {
  id: Scalars['ID']['input'];
}


export interface IMutationRemovePaymentMethodArgs {
  paymentMethodId: Scalars['ID']['input'];
}


export interface IMutationRemoveProtectionPlanArgs {
  id: Scalars['String']['input'];
}


export interface IMutationRemoveProtectionPlanByUserIdArgs {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}


export interface IMutationRemoveTripFeeArgs {
  id: Scalars['String']['input'];
}


export interface IMutationRemoveWorkerAccountArgs {
  workerAccountId: Scalars['ID']['input'];
}


export interface IMutationReorderHotLocationsArgs {
  input: IReorderHotLocationsInput;
}


export interface IMutationRequestAddDriverToBookingArgs {
  input: IAddDriverInput;
}


export interface IMutationRequestCarSwapArgs {
  input: ICarSwapRequestInput;
}


export interface IMutationRequestJobAddOnArgs {
  input: IRequestJobAddOnInput;
}


export interface IMutationRequestJobPhotoArchiveArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IMutationRequestJobRefundArgs {
  amount: Scalars['Float']['input'];
  bookingId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  photoKeys?: InputMaybe<Array<Scalars['String']['input']>>;
}


export interface IMutationResendConfirmationCodeArgs {
  email: Scalars['String']['input'];
}


export interface IMutationResolveJobDisputeArgs {
  bookingId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  refundAmount: Scalars['Float']['input'];
}


export interface IMutationResolveWorkerStrikeArgs {
  eventId: Scalars['ID']['input'];
  upheld: Scalars['Boolean']['input'];
}


export interface IMutationRespondJobAddOnArgs {
  addOnId: Scalars['ID']['input'];
  approve: Scalars['Boolean']['input'];
}


export interface IMutationRespondToDamageClaimArgs {
  input: IRespondToClaimInput;
}


export interface IMutationResumeHostListingsArgs {
  userId: Scalars['String']['input'];
}


export interface IMutationResumeWorkerArgs {
  workerCarId: Scalars['ID']['input'];
}


export interface IMutationRevealStayInstructionsArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IMutationReviewGeneralDlVerificationArgs {
  input: IReviewGeneralDlVerificationInput;
}


export interface IMutationReviewHostApplicationArgs {
  approved: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
}


export interface IMutationRevokeHostApprovalArgs {
  userId: Scalars['String']['input'];
}


export interface IMutationSavePolicyDraftArgs {
  input: ISavePolicyDraftInput;
}


export interface IMutationScheduleBroadcastArgs {
  broadcastId: Scalars['String']['input'];
  scheduledAt: Scalars['DateTime']['input'];
}


export interface IMutationSendBroadcastArgs {
  broadcastId: Scalars['String']['input'];
}


export interface IMutationSendContactFormEmailArgs {
  contactDealerInput: IContactDealerInput;
}


export interface IMutationSendForgotPasswordEmailArgs {
  email: Scalars['String']['input'];
}


export interface IMutationSendMessageArgs {
  input: ISendMessageInput;
}


export interface IMutationSendPhoneOtpArgs {
  phoneNumber: Scalars['String']['input'];
}


export interface IMutationSendTestEmailArgs {
  input: ISendEmailInput;
}


export interface IMutationSetAirportActiveArgs {
  isActive: Scalars['Boolean']['input'];
  locationId: Scalars['Int']['input'];
}


export interface IMutationSetAllowedLocationArgs {
  input: IAllowedLocationInput;
}


export interface IMutationSetBrandAdminArgs {
  input: ISetBrandAdminInput;
}


export interface IMutationSetBrandAirportEnabledArgs {
  enabled: Scalars['Boolean']['input'];
  locationId: Scalars['Int']['input'];
}


export interface IMutationSetBrandAppFeatureArgs {
  input: ISetBrandAppFeatureInput;
}


export interface IMutationSetCarDeliveryLocationArgs {
  input: ICarDeliveryLocationInput;
}


export interface IMutationSetDefaultPaymentMethodArgs {
  paymentMethodId: Scalars['ID']['input'];
}


export interface IMutationSetServiceTaxRuleArgs {
  platformFeeTaxable: Scalars['Boolean']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  serviceType: ServiceType;
  state: Scalars['String']['input'];
  taxable: Scalars['Boolean']['input'];
}


export interface IMutationSignInArgs {
  input: ISignInInput;
}


export interface IMutationSignInWithAppleArgs {
  input: ISignInWithAppleInput;
}


export interface IMutationSignInWithGoogleArgs {
  input: ISignInWithGoogleInput;
}


export interface IMutationSignUpArgs {
  input: ISignUpInput;
}


export interface IMutationSnoozeStayArgs {
  id: Scalars['ID']['input'];
  until: Scalars['DateTime']['input'];
}


export interface IMutationSubmitDlVerificationArgs {
  input: ISubmitDlVerificationInput;
}


export interface IMutationSubmitGeneralDlVerificationArgs {
  input: ISubmitGeneralDlVerificationInput;
}


export interface IMutationSubmitGuestRatingArgs {
  input: ISubmitGuestRatingInput;
}


export interface IMutationSubmitHostRatingArgs {
  input: ISubmitHostRatingInput;
}


export interface IMutationSubmitHostReplyArgs {
  input: ISubmitHostReplyInput;
}


export interface IMutationSubmitProviderInsuranceArgs {
  input: IProviderCredentialInput;
}


export interface IMutationSubmitProviderTaxInfoArgs {
  input: IProviderTaxInfoInput;
}


export interface IMutationSubmitServiceCustomerRatingArgs {
  input: IServiceCustomerRatingInput;
}


export interface IMutationSubmitServiceWorkerRatingArgs {
  input: IServiceWorkerRatingInput;
}


export interface IMutationSubmitStayGuestRatingArgs {
  input: ISubmitStayGuestRatingInput;
}


export interface IMutationSubmitStayHostRatingArgs {
  input: ISubmitStayHostRatingInput;
}


export interface IMutationSubmitWorkerBackgroundCheckArgs {
  input: IBackgroundCheckInput;
  workerCarId: Scalars['ID']['input'];
}


export interface IMutationSuspendHostListingsArgs {
  userId: Scalars['String']['input'];
}


export interface IMutationSyncServiceJobPaymentArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IMutationSyncServiceSiteCalendarArgs {
  siteId: Scalars['ID']['input'];
}


export interface IMutationSyncStayBookingRequestArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IMutationUnlistStayArgs {
  id: Scalars['ID']['input'];
}


export interface IMutationUnlistWorkerArgs {
  workerCarId: Scalars['ID']['input'];
}


export interface IMutationUnscheduleBroadcastArgs {
  broadcastId: Scalars['String']['input'];
}


export interface IMutationUpdateActualReturnDateTimeArgs {
  input: IUpdateActualReturnDateTimeInput;
}


export interface IMutationUpdateAirportArgs {
  input: IUpdateAirportInput;
}


export interface IMutationUpdateBookingArgs {
  updateBookingInput: IUpdateBookingInput;
}


export interface IMutationUpdateBookingMinimumRentalDaysArgs {
  input: IUpdateBookingMinimumRentalDaysInput;
}


export interface IMutationUpdateBookingProtectionPlanArgs {
  input: IUpdateBookingProtectionPlanInput;
}


export interface IMutationUpdateBrandAliasesArgs {
  input: IUpdateBrandAliasesInput;
}


export interface IMutationUpdateBrandProductTypesArgs {
  input: IUpdateBrandProductTypesInput;
}


export interface IMutationUpdateBrandRulesArgs {
  input: IUpdateBrandRulesInput;
}


export interface IMutationUpdateBrandSettingsArgs {
  input: IUpdateBrandSettingsInput;
}


export interface IMutationUpdateBrandStripeSecretsArgs {
  input: IUpdateBrandStripeSecretsInput;
}


export interface IMutationUpdateBroadcastArgs {
  id: Scalars['String']['input'];
  input: IUpdateBroadcastInput;
}


export interface IMutationUpdateCarArgs {
  id: Scalars['String']['input'];
  updateCarInput: IUpdateCarInput;
}


export interface IMutationUpdateCarDiscountArgs {
  carId: Scalars['String']['input'];
  discountData: IDiscountInput;
}


export interface IMutationUpdateCarHourlyPricingArgs {
  carId: Scalars['String']['input'];
  input: IHourlyPricingUpdateInput;
}


export interface IMutationUpdateCarImagesArgs {
  carId: Scalars['String']['input'];
  updateImagesData: IUpdateImagesInput;
}


export interface IMutationUpdateCarMakeAndModelArgs {
  input: IUpdateCarMakeAndModelInput;
}


export interface IMutationUpdateCarSaleArgs {
  updateCarSaleInput: IUpdateCarSaleInput;
}


export interface IMutationUpdateCarTripPreferencesArgs {
  carId: Scalars['String']['input'];
  tripPreferences: ITripPreferencesInput;
}


export interface IMutationUpdateCouponArgs {
  input: IUpdateCouponInput;
}


export interface IMutationUpdateDamageClaimStatusArgs {
  input: IUpdateDamageClaimStatusInput;
}


export interface IMutationUpdateDealerArgs {
  updateDealerInput: IUpdateDealerInput;
}


export interface IMutationUpdateDistanceLimitArgs {
  carId: Scalars['String']['input'];
  distanceLimit: IDistanceLimitInput;
}


export interface IMutationUpdateFcmTokenArgs {
  fcmToken?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationUpdateGuestRatingValidityArgs {
  input: IUpdateGuestRatingValidityInput;
}


export interface IMutationUpdateHostRatingValidityArgs {
  input: IUpdateHostRatingValidityInput;
}


export interface IMutationUpdateHotLocationArgs {
  input: IUpdateHotLocationInput;
}


export interface IMutationUpdateHourlyPriceCalendarArgs {
  carId: Scalars['String']['input'];
  updatePriceCalendarData: Array<IPriceCalendarInput>;
}


export interface IMutationUpdateInvoiceArgs {
  input: IUpdateInvoiceInput;
}


export interface IMutationUpdateJobAccessArgs {
  accessOverride?: InputMaybe<Scalars['String']['input']>;
  bookingId: Scalars['ID']['input'];
}


export interface IMutationUpdateLocationArgs {
  id: Scalars['Int']['input'];
  input: IUpdateLocationInput;
}


export interface IMutationUpdateMiscellaneousFeeArgs {
  input: IUpdateMiscellaneousFeeInput;
}


export interface IMutationUpdateMyReferralSettingsArgs {
  input: IUpdateReferralSettingsInput;
}


export interface IMutationUpdateOperatingHoursArgs {
  updateOperatingHoursInput: IUpdateOperatingHoursInput;
}


export interface IMutationUpdatePlatformReferralRatesArgs {
  input: IUpdatePlatformReferralRatesInput;
}


export interface IMutationUpdatePlatformSiteMarkersArgs {
  input: IUpdatePlatformSiteMarkersInput;
}


export interface IMutationUpdatePriceCalendarArgs {
  carId: Scalars['String']['input'];
  updatePriceCalendarData: Array<IPriceCalendarInput>;
}


export interface IMutationUpdateProductTypeDetailsArgs {
  id: Scalars['String']['input'];
  input: IUpdateProductTypeDetailsInput;
}


export interface IMutationUpdateProtectionPlanArgs {
  input: IUpdateProtectionPlanInput;
}


export interface IMutationUpdateServiceFeeRatesArgs {
  input: IUpdateServiceFeeRatesInput;
}


export interface IMutationUpdateServiceSiteArgs {
  input: IServiceSiteInput;
  siteId: Scalars['ID']['input'];
}


export interface IMutationUpdateStayArgs {
  id: Scalars['ID']['input'];
  input: IUpdateStayInput;
}


export interface IMutationUpdateStayPhotosArgs {
  id: Scalars['ID']['input'];
  imageUrls: Array<Scalars['String']['input']>;
}


export interface IMutationUpdateStayServiceFeeRatesArgs {
  input: IUpdateStayServiceFeeRatesInput;
}


export interface IMutationUpdateTripFeeArgs {
  input: IUpdateTripFeeInput;
}


export interface IMutationUpdateTripPreferencesArgs {
  carId: Scalars['String']['input'];
  tripPreferences: ITripPreferencesInput;
}


export interface IMutationUpdateUserArgs {
  updateUserInput: IUpdateUserInput;
}


export interface IMutationUpdateUserReportStatusArgs {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  status: Scalars['String']['input'];
}


export interface IMutationUpdateWorkerArgs {
  input: IWorkerSettingsInput;
  workerCarId: Scalars['ID']['input'];
}


export interface IMutationUpdateWorkerEquipmentPhotosArgs {
  keys: Array<Scalars['String']['input']>;
  workerCarId: Scalars['ID']['input'];
}


export interface IMutationUploadTripPhotoArgs {
  input: IUploadTripPhotoInput;
}


export interface IMutationUpsertMinimumWageRateArgs {
  city?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom: Scalars['String']['input'];
  hourlyRate: Scalars['Float']['input'];
  source: Scalars['String']['input'];
  state: Scalars['String']['input'];
}


export interface IMutationUpsertServiceOfferingArgs {
  input: IServiceOfferingInput;
  workerCarId: Scalars['ID']['input'];
}


export interface IMutationUpsertServiceProviderArgs {
  input: IServiceProviderInput;
}


export interface IMutationVerifyBookingPaymentArgs {
  bookingId: Scalars['String']['input'];
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationVerifyGuestDlArgs {
  bookingId: Scalars['String']['input'];
  licenceExpirationDate?: InputMaybe<Scalars['String']['input']>;
}


export interface IMutationVerifyPhoneOtpArgs {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}


export interface IMutationVerifyProviderInsuranceArgs {
  approved: Scalars['Boolean']['input'];
  providerId: Scalars['ID']['input'];
}


export interface IMutationVerifyWorkerBackgroundCheckArgs {
  approved: Scalars['Boolean']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerCarId: Scalars['ID']['input'];
}


export interface IMutationWithdrawBookingRequestArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IMutationWithdrawDamageClaimArgs {
  claimId: Scalars['String']['input'];
}


export interface IMutationWithdrawJobArgs {
  bookingId: Scalars['ID']['input'];
}

export interface IMyServicePayouts {
  __typename?: 'MyServicePayouts';
  batches: Array<IServicePayoutBatch>;
  pendingAmount: Scalars['Float']['output'];
  pendingJobCount: Scalars['Int']['output'];
}

export interface IMyWorkerLogin {
  __typename?: 'MyWorkerLogin';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  accountId: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  ownListing: Scalars['Boolean']['output'];
  providerName: Scalars['String']['output'];
  workerCarId: Scalars['ID']['output'];
}

export interface INewCarInput {
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<CategoryEnum>;
  cityMpg?: InputMaybe<Scalars['Int']['input']>;
  currentLocation?: InputMaybe<Scalars['String']['input']>;
  dailyPrice?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<IDiscountInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  distanceLimit?: InputMaybe<IDistanceLimitInput>;
  doors?: InputMaybe<Scalars['Int']['input']>;
  gas?: InputMaybe<GasType>;
  gasGrade?: InputMaybe<GasGrade>;
  gearType?: InputMaybe<GearType>;
  guestInstructions?: InputMaybe<Scalars['String']['input']>;
  holidayHrPrice?: InputMaybe<Scalars['Float']['input']>;
  holidayPrice?: InputMaybe<Scalars['Float']['input']>;
  hourlyRentalIsOn?: InputMaybe<Scalars['Boolean']['input']>;
  hwyMpg?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Array<IImageInput>>;
  isCreated?: Scalars['Boolean']['input'];
  isProtectionDeclinable?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  licensePlateState?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  longitude?: InputMaybe<Scalars['Float']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  monthlyPrice?: InputMaybe<Scalars['Float']['input']>;
  monthlyPrice2Months?: InputMaybe<Scalars['Float']['input']>;
  monthlyPrice3Months?: InputMaybe<Scalars['Float']['input']>;
  monthlyRentalIsOn?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalPrice?: InputMaybe<Scalars['Float']['input']>;
  ownerId: Scalars['String']['input'];
  productTypeDetailsId?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<Scalars['Float']['input']>;
  sold?: InputMaybe<Scalars['Boolean']['input']>;
  soldAt?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  tripPreferences?: InputMaybe<ITripPreferencesInput>;
  vin?: InputMaybe<Scalars['String']['input']>;
  weekdayHrPrice?: InputMaybe<Scalars['Float']['input']>;
  weekdayPrice?: InputMaybe<Scalars['Float']['input']>;
  weekendHrPrice?: InputMaybe<Scalars['Float']['input']>;
  weekendPrice?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
}

export interface INotification {
  __typename?: 'Notification';
  body: Scalars['String']['output'];
  booking?: Maybe<IBooking>;
  bookingId?: Maybe<Scalars['String']['output']>;
  broadcast?: Maybe<IBroadcast>;
  broadcastId?: Maybe<Scalars['String']['output']>;
  chatId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  damageClaimId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  navigationData?: Maybe<Scalars['String']['output']>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: NotificationType;
  user: IUser;
}

/** Type of notification */
export enum NotificationType {
  AdditionalDriverAgreementPending = 'ADDITIONAL_DRIVER_AGREEMENT_PENDING',
  BookingCancelled = 'BOOKING_CANCELLED',
  BookingConfirmed = 'BOOKING_CONFIRMED',
  BookingCreated = 'BOOKING_CREATED',
  BookingExtended = 'BOOKING_EXTENDED',
  BookingModified = 'BOOKING_MODIFIED',
  BookingShortened = 'BOOKING_SHORTENED',
  BrandDeliveryOff = 'BRAND_DELIVERY_OFF',
  BrandDeliveryOn = 'BRAND_DELIVERY_ON',
  Broadcast = 'BROADCAST',
  CalendarCheckoutFound = 'CALENDAR_CHECKOUT_FOUND',
  CalendarSyncFailed = 'CALENDAR_SYNC_FAILED',
  CardholderNameMismatch = 'CARDHOLDER_NAME_MISMATCH',
  CarRelisted = 'CAR_RELISTED',
  CarSwapApproved = 'CAR_SWAP_APPROVED',
  CarSwapRejected = 'CAR_SWAP_REJECTED',
  CarSwapRequested = 'CAR_SWAP_REQUESTED',
  CarUnlisted = 'CAR_UNLISTED',
  ChatMessage = 'CHAT_MESSAGE',
  DamageClaimApproved = 'DAMAGE_CLAIM_APPROVED',
  DamageClaimCreated = 'DAMAGE_CLAIM_CREATED',
  DamageClaimRejected = 'DAMAGE_CLAIM_REJECTED',
  DamageClaimResolved = 'DAMAGE_CLAIM_RESOLVED',
  DamageClaimResponseSubmitted = 'DAMAGE_CLAIM_RESPONSE_SUBMITTED',
  DepositAuthorized = 'DEPOSIT_AUTHORIZED',
  DepositCaptured = 'DEPOSIT_CAPTURED',
  DepositReleased = 'DEPOSIT_RELEASED',
  DlVerificationRejected = 'DL_VERIFICATION_REJECTED',
  DlVerificationReminder = 'DL_VERIFICATION_REMINDER',
  DlVerificationSubmitted = 'DL_VERIFICATION_SUBMITTED',
  DlVerificationVerified = 'DL_VERIFICATION_VERIFIED',
  ExtensionBlocked = 'EXTENSION_BLOCKED',
  JobAccessAvailable = 'JOB_ACCESS_AVAILABLE',
  JobAddOnRequested = 'JOB_ADD_ON_REQUESTED',
  JobArrived = 'JOB_ARRIVED',
  JobAutoConfirmed = 'JOB_AUTO_CONFIRMED',
  JobCancelled = 'JOB_CANCELLED',
  JobCompleted = 'JOB_COMPLETED',
  JobConfirmed = 'JOB_CONFIRMED',
  JobDeclined = 'JOB_DECLINED',
  JobDisputed = 'JOB_DISPUTED',
  JobEnRoute = 'JOB_EN_ROUTE',
  JobExpired = 'JOB_EXPIRED',
  JobHandoverCap = 'JOB_HANDOVER_CAP',
  JobIssueReported = 'JOB_ISSUE_REPORTED',
  JobLinkedTripChanged = 'JOB_LINKED_TRIP_CHANGED',
  JobNoShow = 'JOB_NO_SHOW',
  JobPaymentFailed = 'JOB_PAYMENT_FAILED',
  JobReminder = 'JOB_REMINDER',
  JobRequested = 'JOB_REQUESTED',
  PaymentDeclined = 'PAYMENT_DECLINED',
  ProviderCredentialExpired = 'PROVIDER_CREDENTIAL_EXPIRED',
  RecallTripInProgress = 'RECALL_TRIP_IN_PROGRESS',
  RefundApproved = 'REFUND_APPROVED',
  RefundCompleted = 'REFUND_COMPLETED',
  RefundNeedsReview = 'REFUND_NEEDS_REVIEW',
  StayCheckoutReminder = 'STAY_CHECKOUT_REMINDER',
  StayCheckInInstructions = 'STAY_CHECK_IN_INSTRUCTIONS',
  StayRequestAccepted = 'STAY_REQUEST_ACCEPTED',
  StayRequestDeclined = 'STAY_REQUEST_DECLINED',
  StayRequestExpired = 'STAY_REQUEST_EXPIRED',
  StayRequestExpiring = 'STAY_REQUEST_EXPIRING',
  StayRequestReceived = 'STAY_REQUEST_RECEIVED',
  StayRequestWithdrawn = 'STAY_REQUEST_WITHDRAWN',
  StayReviewReminder = 'STAY_REVIEW_REMINDER',
  TripCancelledRecall = 'TRIP_CANCELLED_RECALL',
  UnlistedCarFutureTrips = 'UNLISTED_CAR_FUTURE_TRIPS',
  WorkerInvited = 'WORKER_INVITED',
  WorkerPaused = 'WORKER_PAUSED'
}

export interface IOperatingHours {
  __typename?: 'OperatingHours';
  PickupLocationType: PickupLocationType;
  alwaysAvailable: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  fridayAlwaysAvailable: Scalars['Boolean']['output'];
  fridayAvailable: Scalars['Boolean']['output'];
  fridayEnd: Scalars['String']['output'];
  fridayStart: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<ILocation>;
  locationId: Scalars['Int']['output'];
  mondayAlwaysAvailable: Scalars['Boolean']['output'];
  mondayAvailable: Scalars['Boolean']['output'];
  mondayEnd: Scalars['String']['output'];
  mondayStart: Scalars['String']['output'];
  saturdayAlwaysAvailable: Scalars['Boolean']['output'];
  saturdayAvailable: Scalars['Boolean']['output'];
  saturdayEnd: Scalars['String']['output'];
  saturdayStart: Scalars['String']['output'];
  sundayAlwaysAvailable: Scalars['Boolean']['output'];
  sundayAvailable: Scalars['Boolean']['output'];
  sundayEnd: Scalars['String']['output'];
  sundayStart: Scalars['String']['output'];
  thursdayAlwaysAvailable: Scalars['Boolean']['output'];
  thursdayAvailable: Scalars['Boolean']['output'];
  thursdayEnd: Scalars['String']['output'];
  thursdayStart: Scalars['String']['output'];
  tuesdayAlwaysAvailable: Scalars['Boolean']['output'];
  tuesdayAvailable: Scalars['Boolean']['output'];
  tuesdayEnd: Scalars['String']['output'];
  tuesdayStart: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wednesdayAlwaysAvailable: Scalars['Boolean']['output'];
  wednesdayAvailable: Scalars['Boolean']['output'];
  wednesdayEnd: Scalars['String']['output'];
  wednesdayStart: Scalars['String']['output'];
}

export interface IOtherItem {
  __typename?: 'OtherItem';
  amount?: Maybe<Scalars['Float']['output']>;
  taxible: Scalars['Boolean']['output'];
}

export interface IOtherItemInput {
  amount: Scalars['Float']['input'];
  taxible?: Scalars['Boolean']['input'];
}

export interface IOtherWithDescription {
  __typename?: 'OtherWithDescription';
  amount: Scalars['Float']['output'];
  for: Scalars['String']['output'];
  paidTo: Scalars['String']['output'];
}

export interface IOtherWithDescriptionInput {
  amount: Scalars['Float']['input'];
  for: Scalars['String']['input'];
  paidTo: Scalars['String']['input'];
}

export interface IOutstandingInvoicePaymentResult {
  __typename?: 'OutstandingInvoicePaymentResult';
  amount: Scalars['Float']['output'];
  attemptId?: Maybe<Scalars['ID']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  declineCode?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  invoice: IInvoice;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  status: PaymentAttemptStatus;
}

export interface IPaginatedBroadcasts {
  __typename?: 'PaginatedBroadcasts';
  hasMore: Scalars['Boolean']['output'];
  items: Array<IBroadcast>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
}

export interface IPaginatedCars {
  __typename?: 'PaginatedCars';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ICar>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  /** ceil(totalCount / limit), or 0 when totalCount is 0 */
  totalPages: Scalars['Int']['output'];
}

export interface IPaginatedInvoices {
  __typename?: 'PaginatedInvoices';
  items: Array<IInvoice>;
  total: Scalars['Float']['output'];
}

export interface IPaginatedLocations {
  __typename?: 'PaginatedLocations';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ILocation>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  /** ceil(totalCount / limit), or 0 when totalCount is 0 */
  totalPages: Scalars['Int']['output'];
}

export interface IPaginatedNotifications {
  __typename?: 'PaginatedNotifications';
  hasMore: Scalars['Boolean']['output'];
  items: Array<INotification>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
}

export interface IPaginatedStayReviews {
  __typename?: 'PaginatedStayReviews';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ITripRatingReview>;
  summary: IStayReviewSummary;
  total: Scalars['Int']['output'];
}

export interface IPaginatedStays {
  __typename?: 'PaginatedStays';
  hasMore: Scalars['Boolean']['output'];
  items: Array<IStaySearchResult>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
}

export interface IPaginatedWorkerResults {
  __typename?: 'PaginatedWorkerResults';
  items: Array<IWorkerSearchResult>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
}

export interface IPaidToItem {
  __typename?: 'PaidToItem';
  amount: Scalars['Float']['output'];
  paidTo: Scalars['String']['output'];
}

export interface IPaidToItemInput {
  amount: Scalars['Float']['input'];
  paidTo: Scalars['String']['input'];
}

export interface IPayOutstandingInvoiceInput {
  invoiceId: Scalars['ID']['input'];
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
}

/** Outcome of one server-initiated charge attempt */
export enum PaymentAttemptStatus {
  Created = 'CREATED',
  Failed = 'FAILED',
  RequiresAction = 'REQUIRES_ACTION',
  Succeeded = 'SUCCEEDED'
}

export interface IPaymentConfigInput {
  allowAutoCharge?: InputMaybe<Scalars['Boolean']['input']>;
  autoChargeDate?: InputMaybe<Scalars['Float']['input']>;
  depositAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms?: InputMaybe<Scalars['Float']['input']>;
  requireDeposit?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface IPaymentDetails {
  __typename?: 'PaymentDetails';
  amountFinanced?: Maybe<Scalars['Float']['output']>;
  amtPaidToInsuranceComp?: Maybe<Scalars['Float']['output']>;
  amtPaidToPublicOfficials?: Maybe<IAmountPaidToPublicOfficials>;
  cashPriceVehicleNAccessories?: Maybe<ICashPriceVehicleNAccessories>;
  debtCancellationAgreement?: Maybe<Scalars['Float']['output']>;
  docFee?: Maybe<Scalars['Float']['output']>;
  evChargingStation?: Maybe<Array<IPaidToItem>>;
  evTransferFee?: Maybe<Array<IPaidToItem>>;
  others?: Maybe<Array<IOtherWithDescription>>;
  priorCreditBySeller?: Maybe<Array<IPaidToItem>>;
  salesTax?: Maybe<Scalars['Float']['output']>;
  salesTaxRate?: Maybe<Scalars['Float']['output']>;
  serviceContacts?: Maybe<Array<IPaidToItem>>;
  smogFee?: Maybe<Scalars['Float']['output']>;
  stateEmissionExemptionFee?: Maybe<Scalars['Float']['output']>;
  stateEmissionsCertFee?: Maybe<Scalars['Float']['output']>;
  surfaceProtectDevices?: Maybe<Array<IPaidToItem>>;
  theftDeterrentDevices?: Maybe<Array<IPaidToItem>>;
  totalCashPrice?: Maybe<Scalars['Float']['output']>;
  totalDownPayment?: Maybe<ITotalDownPayment>;
  usedVehicleContractCancellationOption?: Maybe<Scalars['Float']['output']>;
}

export interface IPaymentDetailsInput {
  amountFinanced?: InputMaybe<Scalars['Float']['input']>;
  amtPaidToInsuranceComp?: InputMaybe<Scalars['Float']['input']>;
  amtPaidToPublicOfficials?: InputMaybe<IAmountPaidToPublicOfficialsInput>;
  cashPriceVehicleNAccessories?: InputMaybe<ICashPriceVehicleNAccessoriesInput>;
  debtCancellationAgreement?: InputMaybe<Scalars['Float']['input']>;
  docFee?: InputMaybe<Scalars['Float']['input']>;
  evChargingStation?: InputMaybe<Array<IPaidToItemInput>>;
  evTransferFee?: InputMaybe<Array<IPaidToItemInput>>;
  others?: InputMaybe<Array<IOtherWithDescriptionInput>>;
  priorCreditBySeller?: InputMaybe<Array<IPaidToItemInput>>;
  salesTax?: InputMaybe<Scalars['Float']['input']>;
  salesTaxRate?: InputMaybe<Scalars['Float']['input']>;
  serviceContacts?: InputMaybe<Array<IPaidToItemInput>>;
  smogFee?: InputMaybe<Scalars['Float']['input']>;
  stateEmissionExemptionFee?: InputMaybe<Scalars['Float']['input']>;
  stateEmissionsCertFee?: InputMaybe<Scalars['Float']['input']>;
  surfaceProtectDevices?: InputMaybe<Array<IPaidToItemInput>>;
  theftDeterrentDevices?: InputMaybe<Array<IPaidToItemInput>>;
  totalCashPrice?: InputMaybe<Scalars['Float']['input']>;
  totalDownPayment?: InputMaybe<ITotalDownPaymentInput>;
  usedVehicleContractCancellationOption?: InputMaybe<Scalars['Float']['input']>;
}

export interface IPaymentIntentType {
  __typename?: 'PaymentIntentType';
  booking?: Maybe<IBooking>;
  clientSecret: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  requiresAction: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
}

/** Payment method options */
export enum PaymentMethod {
  Creditcard = 'CREDITCARD',
  Debitcard = 'DEBITCARD'
}

export enum PaymentPurpose {
  DamageCharge = 'DAMAGE_CHARGE',
  ExtendTrip = 'EXTEND_TRIP',
  ExtraMileageCharge = 'EXTRA_MILEAGE_CHARGE',
  IncidentCharge = 'INCIDENT_CHARGE',
  InsuranceCharge = 'INSURANCE_CHARGE',
  NewBooking = 'NEW_BOOKING',
  OtherMiscCharge = 'OTHER_MISC_CHARGE',
  SecurityDeposit = 'SECURITY_DEPOSIT',
  StayModification = 'STAY_MODIFICATION',
  TicketCharge = 'TICKET_CHARGE',
  TollCharge = 'TOLL_CHARGE',
  TowCharge = 'TOW_CHARGE'
}

export interface IPaymentSchedule {
  __typename?: 'PaymentSchedule';
  amountFinanced: Scalars['Float']['output'];
  annualPercentageRate: Scalars['Float']['output'];
  finalPaymentAmount?: Maybe<Scalars['Float']['output']>;
  finalPaymentDate?: Maybe<Scalars['String']['output']>;
  financeCharge: Scalars['Float']['output'];
  firstPaymentDate?: Maybe<Scalars['String']['output']>;
  hasSecurityInterest: Scalars['Boolean']['output'];
  lateChargeRate: Scalars['Float']['output'];
  monthlyPaymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentType: PaymentType;
  startDate: Scalars['String']['output'];
  totalOfPayments: Scalars['Float']['output'];
  totalSalePrice: Scalars['Float']['output'];
}

export interface IPaymentScheduleInput {
  amountFinanced: Scalars['Float']['input'];
  annualPercentageRate: Scalars['Float']['input'];
  finalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  finalPaymentDate?: InputMaybe<Scalars['String']['input']>;
  financeCharge: Scalars['Float']['input'];
  firstPaymentDate?: InputMaybe<Scalars['String']['input']>;
  hasSecurityInterest?: Scalars['Boolean']['input'];
  lateChargeRate?: Scalars['Float']['input'];
  monthlyPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentType: PaymentType;
  startDate: Scalars['String']['input'];
  totalOfPayments: Scalars['Float']['input'];
  totalSalePrice: Scalars['Float']['input'];
}

/** Status of payment */
export enum PaymentStatus {
  Failed = 'FAILED',
  Initial = 'INITIAL',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Succeeded = 'SUCCEEDED'
}

export interface IPaymentSummary {
  __typename?: 'PaymentSummary';
  netAmount?: Maybe<Scalars['Float']['output']>;
  totalPaid?: Maybe<Scalars['Float']['output']>;
  totalRefunded?: Maybe<Scalars['Float']['output']>;
}

/** The type of payment for the car sale */
export enum PaymentType {
  Cash = 'CASH',
  Finance = 'FINANCE',
  Lease = 'LEASE'
}

export interface IPendingPolicy {
  __typename?: 'PendingPolicy';
  kind: PolicyKind;
  /** The version the user accepted last, if any. */
  previous?: Maybe<IPolicyVersion>;
  version: IPolicyVersion;
}

export interface IPendingServiceCredential {
  __typename?: 'PendingServiceCredential';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  coverageAmount?: Maybe<Scalars['Float']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  fileKey: Scalars['String']['output'];
  issuer: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  providerId: Scalars['ID']['output'];
  providerName: Scalars['String']['output'];
  workerCarId?: Maybe<Scalars['ID']['output']>;
  workerName?: Maybe<Scalars['String']['output']>;
}

/** Subcategory for physical damage */
export enum PhysicalDamageSubcategory {
  Collision = 'COLLISION',
  SomethingElse = 'SOMETHING_ELSE',
  TheftVandalism = 'THEFT_VANDALISM',
  WeatherNaturalDisaster = 'WEATHER_NATURAL_DISASTER'
}

/** Type of delivery service */
export enum PickupLocationType {
  Custom = 'CUSTOM',
  Delivery = 'DELIVERY',
  Home = 'HOME'
}

export interface IPlatformSetting {
  __typename?: 'PlatformSetting';
  defaultReferralCommissionRate: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  minimumReferralCommissionRate: Scalars['Float']['output'];
  serviceCustomerFeeRate: Scalars['Float']['output'];
  serviceFeeWaiverDays: Scalars['Int']['output'];
  serviceProviderFeeRate: Scalars['Float']['output'];
  stayGuestServiceFeeRate: Scalars['Float']['output'];
  stayHostServiceFeeRate: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export enum PolicyAcceptanceContext {
  AdditionalDriver = 'ADDITIONAL_DRIVER',
  Checkout = 'CHECKOUT',
  Extension = 'EXTENSION',
  HostApplication = 'HOST_APPLICATION',
  PublisherAck = 'PUBLISHER_ACK',
  Reacceptance = 'REACCEPTANCE',
  SignUp = 'SIGN_UP'
}

export interface IPolicyAcceptanceFilter {
  before?: InputMaybe<Scalars['ID']['input']>;
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  /** Platform owner only: another brand, or '*'. */
  brandSite?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  kind?: InputMaybe<PolicyKind>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
}

export interface IPolicyAcceptanceInput {
  documentPath: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  policyVersionId?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
}

export interface IPolicyAcceptancePage {
  __typename?: 'PolicyAcceptancePage';
  nextBefore?: Maybe<Scalars['ID']['output']>;
  rows: Array<IPolicyAcceptanceRecord>;
}

export interface IPolicyAcceptanceRecord {
  __typename?: 'PolicyAcceptanceRecord';
  acceptedAt: Scalars['DateTime']['output'];
  bookingId?: Maybe<Scalars['ID']['output']>;
  brandSite: Scalars['String']['output'];
  context: PolicyAcceptanceContext;
  id: Scalars['ID']['output'];
  /** Admins only. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  kind: PolicyKind;
  method: Scalars['String']['output'];
  /** Admins only. */
  platform?: Maybe<Scalars['String']['output']>;
  /** Admins only. */
  userAgent?: Maybe<Scalars['String']['output']>;
  /** Admins only. */
  userEmail?: Maybe<Scalars['String']['output']>;
  /** Admins only. */
  userId?: Maybe<Scalars['ID']['output']>;
  version?: Maybe<IPolicyVersion>;
}

export interface IPolicyDocumentSummary {
  __typename?: 'PolicyDocumentSummary';
  current?: Maybe<IPolicyVersion>;
  kind: PolicyKind;
  /** False when the brand uses the platform default. */
  ownedByBrand: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
}

export interface IPolicyEventEntry {
  __typename?: 'PolicyEventEntry';
  action: Scalars['String']['output'];
  actorId?: Maybe<Scalars['ID']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: PolicyKind;
  requestBrandSite?: Maybe<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  versionId?: Maybe<Scalars['ID']['output']>;
}

export enum PolicyKind {
  /** Account Deletion Policy */
  AccountDeletion = 'ACCOUNT_DELETION',
  /** Cancellation and Refund Policy */
  Cancellation = 'CANCELLATION',
  /** Platform default rental agreement for brands without their own RENTER_AGREEMENT. */
  CarSharingAgreement = 'CAR_SHARING_AGREEMENT',
  /** Host Agreement (services: Provider Agreement) */
  HostAgreement = 'HOST_AGREEMENT',
  /** Privacy Policy */
  Privacy = 'PRIVACY',
  /** Autopilotee's Legal Content Publishing Acknowledgment. Platform scope only; accepted by every publisher on every publish. */
  PublisherDisclaimer = 'PUBLISHER_DISCLAIMER',
  /** A brand's own rental agreement */
  RenterAgreement = 'RENTER_AGREEMENT',
  /** Terms of Service */
  Terms = 'TERMS'
}

export interface IPolicyVersion {
  __typename?: 'PolicyVersion';
  /** True for versions imported from git history: dates are approximate. */
  approximateDates: Scalars['Boolean']['output'];
  /** Admins only (null for everyone else). */
  changeSummary?: Maybe<Scalars['String']['output']>;
  contentMarkdown: Scalars['String']['output'];
  contentSha256: Scalars['String']['output'];
  /** The 'Last updated' date, yyyy-MM-dd. */
  effectiveDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: PolicyKind;
  materialChange: Scalars['Boolean']['output'];
  /** Admins only: the publisher's acceptance of the acknowledgment (null for imported versions). */
  publishAcknowledgment?: Maybe<IPolicyAcceptanceRecord>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Admins only: who published it. */
  publishedBy?: Maybe<IBrandRulesActor>;
  /** Brand site, or '*' for the platform default. */
  scope: Scalars['String']['output'];
  status: PolicyVersionStatus;
  supersededAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  versionNumber?: Maybe<Scalars['Int']['output']>;
}

export enum PolicyVersionStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Superseded = 'SUPERSEDED'
}

export interface IPresignedUpload {
  __typename?: 'PresignedUpload';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface IPresignedUrlResponse {
  __typename?: 'PresignedUrlResponse';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

/** Coupon discount calculation algorithm */
export enum PriceAlgorithmEnum {
  FixAmount = 'FIX_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export interface IPriceCalendar {
  __typename?: 'PriceCalendar';
  date: Scalars['String']['output'];
  hourPrice?: Maybe<Scalars['Float']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  price: Scalars['Float']['output'];
}

export interface IPriceCalendarInput {
  date: Scalars['String']['input'];
  hourPrice?: InputMaybe<Scalars['Float']['input']>;
  isAvailable?: Scalars['Boolean']['input'];
  price: Scalars['Float']['input'];
}

export interface IPriceWageWarning {
  __typename?: 'PriceWageWarning';
  effectiveHourly: Scalars['Float']['output'];
  estimatedMinutes: Scalars['Int']['output'];
  field: Scalars['String']['output'];
  minimumWage: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  wageSource: Scalars['String']['output'];
}

export enum PricingMode {
  ByHomeSize = 'BY_HOME_SIZE',
  ByVehicleClass = 'BY_VEHICLE_CLASS',
  Hourly = 'HOURLY'
}

export interface IProductCapabilities {
  __typename?: 'ProductCapabilities';
  bookingModes: Array<BookingMode>;
  cancellationPolicyMode: CancellationPolicyMode;
  hasAdditionalDrivers: Scalars['Boolean']['output'];
  hasCheckInInstructions: Scalars['Boolean']['output'];
  hasCheckinInspection: Scalars['Boolean']['output'];
  hasCheckoutInspection: Scalars['Boolean']['output'];
  hasCleaningFee: Scalars['Boolean']['output'];
  hasDelivery: Scalars['Boolean']['output'];
  hasGuestCounts: Scalars['Boolean']['output'];
  hasHourlyRental: Scalars['Boolean']['output'];
  hasInsurance: Scalars['Boolean']['output'];
  hasJobTimeline: Scalars['Boolean']['output'];
  hasLastMinuteSurcharge: Scalars['Boolean']['output'];
  hasMileageBilling: Scalars['Boolean']['output'];
  hasMonthlyTiers: Scalars['Boolean']['output'];
  hasOperatingHours: Scalars['Boolean']['output'];
  hasSecurityDeposit: Scalars['Boolean']['output'];
  hasServiceWindow: Scalars['Boolean']['output'];
  hasSwap: Scalars['Boolean']['output'];
  hasTripFee: Scalars['Boolean']['output'];
  hasYoungsterFee: Scalars['Boolean']['output'];
  listingAddressMode: ListingAddressMode;
  requiresDriverLicense: Scalars['Boolean']['output'];
  reviewCategorySet: ReviewCategorySet;
  taxable: Scalars['Boolean']['output'];
  timeGranularity: TimeGranularity;
  type: ProductType;
}

/** Product type categories */
export enum ProductType {
  All = 'ALL',
  Car = 'CAR',
  Catering = 'CATERING',
  Coaching = 'COACHING',
  Furniture = 'FURNITURE',
  HomeImprovement = 'HOME_IMPROVEMENT',
  House = 'HOUSE',
  HouseAndVehicleService = 'HOUSE_AND_VEHICLE_SERVICE',
  HouseRemodeling = 'HOUSE_REMODELING',
  Other = 'OTHER',
  Pickleball = 'PICKLEBALL',
  Room = 'ROOM',
  Snowboarding = 'SNOWBOARDING',
  Sports = 'SPORTS',
  Tennis = 'TENNIS'
}

export interface IProductTypeDetails {
  __typename?: 'ProductTypeDetails';
  cancellationPolicyMode: CancellationPolicyMode;
  cars?: Maybe<Array<ICar>>;
  createdAt: Scalars['DateTime']['output'];
  /** Guests can add drivers */
  hasAdditionalDrivers: Scalars['Boolean']['output'];
  /** Check-in instructions revealed to the guest before arrival */
  hasCheckInInstructions: Scalars['Boolean']['output'];
  /** Start-trip inspection: photos, odometer, fuel */
  hasCheckinInspection: Scalars['Boolean']['output'];
  /** Return inspection: photos, odometer, fuel */
  hasCheckoutInspection: Scalars['Boolean']['output'];
  /** One-time cleaning fee set by the host */
  hasCleaningFee: Scalars['Boolean']['output'];
  /** Delivery and airport locations */
  hasDelivery: Scalars['Boolean']['output'];
  /** Adults, children, infants and pets on the booking */
  hasGuestCounts: Scalars['Boolean']['output'];
  /** Hourly pricing for short bookings */
  hasHourlyRental: Scalars['Boolean']['output'];
  hasInsurance: Scalars['Boolean']['output'];
  /** Job timeline: check-ins, checklist photos, issues */
  hasJobTimeline: Scalars['Boolean']['output'];
  /** Last-minute surcharge */
  hasLastMinuteSurcharge: Scalars['Boolean']['output'];
  /** Mileage allowance and extra-mileage charges */
  hasMileageBilling: Scalars['Boolean']['output'];
  /** Fixed monthly price tiers */
  hasMonthlyTiers: Scalars['Boolean']['output'];
  /** Pickup and return must fall in location operating hours */
  hasOperatingHours: Scalars['Boolean']['output'];
  /** Security deposit hold at checkout */
  hasSecurityDeposit: Scalars['Boolean']['output'];
  /** Booked as a time window on one day instead of a start and an end */
  hasServiceWindow: Scalars['Boolean']['output'];
  /** Host can swap the listing during a booking */
  hasSwap: Scalars['Boolean']['output'];
  hasTripFee: Scalars['Boolean']['output'];
  hasYoungsterFee: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isOn: Scalars['Boolean']['output'];
  listingAddressMode: ListingAddressMode;
  /** Guests verify a driver licence before the trip */
  requiresDriverLicense: Scalars['Boolean']['output'];
  reviewCategorySet: ReviewCategorySet;
  saleAs: SaleAs;
  /** Guests can book instantly */
  supportsInstantBook: Scalars['Boolean']['output'];
  /** Guests can send a booking request the host accepts or declines */
  supportsRequestToBook: Scalars['Boolean']['output'];
  taxable: Scalars['Boolean']['output'];
  timeGranularity: TimeGranularity;
  type: ProductType;
}

export interface IProtectionPlan {
  __typename?: 'ProtectionPlan';
  bookings?: Maybe<Array<IBooking>>;
  createdAt: Scalars['DateTime']['output'];
  dailyPrice: Scalars['Float']['output'];
  declinedProtectionOutOfPocketAmt: DeclinedProtectionOutOfPocketAmt;
  declinedProtectionOutOfPocketPercent: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDailyProtectionPlanDeclinable: Scalars['Boolean']['output'];
  isMonthlyProtectionPlanDeclinable: Scalars['Boolean']['output'];
  outOfPocket: Scalars['Float']['output'];
  plan: ProtectionPlanEnum;
  policyDetails?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<IUser>;
  userId?: Maybe<Scalars['String']['output']>;
}

/** The different types of protection plans available */
export enum ProtectionPlanEnum {
  Declined = 'DECLINED',
  Minimum = 'MINIMUM',
  MonthlyMinimum = 'MONTHLY_MINIMUM',
  MonthlyPremium = 'MONTHLY_PREMIUM',
  MonthlyPro = 'MONTHLY_PRO',
  MonthlyStandard = 'MONTHLY_STANDARD',
  Premium = 'PREMIUM',
  Pro = 'PRO',
  Standard = 'STANDARD'
}

export interface IProtectionPlanSnapshot {
  __typename?: 'ProtectionPlanSnapshot';
  dailyPrice: Scalars['Float']['output'];
  declinedProtectionOutOfPocketAmt?: Maybe<DeclinedProtectionOutOfPocketAmt>;
  declinedProtectionOutOfPocketPercent?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  outOfPocket: Scalars['Float']['output'];
  planId: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  planType: ProtectionPlanEnum;
  policyDetails?: Maybe<Scalars['String']['output']>;
  snapshotAt: Scalars['String']['output'];
}

export interface IProviderCredentialInput {
  carrier: Scalars['String']['input'];
  coverageAmount?: InputMaybe<Scalars['Float']['input']>;
  expiresAt: Scalars['String']['input'];
  fileKey: Scalars['String']['input'];
  policyNumber?: InputMaybe<Scalars['String']['input']>;
}

export enum ProviderKind {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL'
}

export interface IProviderTaxInfoInput {
  address: Scalars['JSON']['input'];
  classification: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  signedName: Scalars['String']['input'];
  tin: Scalars['String']['input'];
  tinType: Scalars['String']['input'];
}

export interface IProviderTaxInfoSummary {
  __typename?: 'ProviderTaxInfoSummary';
  classification: Scalars['String']['output'];
  legalName: Scalars['String']['output'];
  signedAt: Scalars['DateTime']['output'];
  tinLast4: Scalars['String']['output'];
  tinType: Scalars['String']['output'];
}

export interface IProviderToday {
  __typename?: 'ProviderToday';
  awaitingConfirmation: Array<IBooking>;
  inProgress: Array<IBooking>;
  requests: Array<IBooking>;
  today: Array<IBooking>;
  upcoming: Array<IBooking>;
}

export interface IProviderWorker {
  __typename?: 'ProviderWorker';
  car: ICar;
  carId: Scalars['ID']['output'];
  priceWarnings: Array<IPriceWageWarning>;
  publishProblems: Array<IPublishProblem>;
  settings: IServiceWorkerSettings;
  worker: IServiceWorker;
}

export interface IPublicBrandRules {
  __typename?: 'PublicBrandRules';
  ageSetByBrand: Scalars['Boolean']['output'];
  areaUnit: Scalars['String']['output'];
  bookingsClosedMessage?: Maybe<Scalars['String']['output']>;
  bookingsOpen: Scalars['Boolean']['output'];
  brandProtectionPlans: Scalars['Boolean']['output'];
  brandSite: Scalars['String']['output'];
  carCardPrice: Scalars['String']['output'];
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  deliveryOffered: Scalars['Boolean']['output'];
  distanceUnit: Scalars['String']['output'];
  effectiveMinimumAge: Scalars['Int']['output'];
  extensionStepDays?: Maybe<Scalars['Int']['output']>;
  hourlyRentalOffered: Scalars['Boolean']['output'];
  measurementSystem: Scalars['String']['output'];
  minRentalDays?: Maybe<Scalars['Int']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  monthlyRentalOffered: Scalars['Boolean']['output'];
  requireRecallCheck: Scalars['Boolean']['output'];
  roadsideAssistancePhone?: Maybe<Scalars['String']['output']>;
  uniformDailyRate: Scalars['Boolean']['output'];
}

export interface IPublicFees {
  __typename?: 'PublicFees';
  amountFinanced?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  registerTransferTitleFee?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
  tireFee?: Maybe<Scalars['Float']['output']>;
  totalDownPayment?: Maybe<Scalars['Float']['output']>;
  vehicleLicenseFee?: Maybe<Scalars['Float']['output']>;
}

export interface IPublicFeesInput {
  amountFinanced?: InputMaybe<Scalars['Float']['input']>;
  balance?: InputMaybe<Scalars['Float']['input']>;
  registerTransferTitleFee?: InputMaybe<Scalars['Float']['input']>;
  subTotal?: InputMaybe<Scalars['Float']['input']>;
  tireFee?: InputMaybe<Scalars['Float']['input']>;
  totalDownPayment?: InputMaybe<Scalars['Float']['input']>;
  vehicleLicenseFee?: InputMaybe<Scalars['Float']['input']>;
}

export interface IPublishPolicyVersionInput {
  /** The acknowledgment version shown and ticked in the dialog. Missing or not current: POLICY_ACKNOWLEDGMENT_REQUIRED (details.current), nothing written. */
  acknowledgmentVersionId: Scalars['ID']['input'];
  changeSummary: Scalars['String']['input'];
  draftId: Scalars['ID']['input'];
  effectiveDate: Scalars['String']['input'];
  /** The published version the editor loaded, or null for a first publish. Else POLICY_VERSION_STALE. */
  expectedCurrentVersionId?: InputMaybe<Scalars['ID']['input']>;
  materialChange: Scalars['Boolean']['input'];
  platform: Scalars['String']['input'];
}

export interface IPublishProblem {
  __typename?: 'PublishProblem';
  code: Scalars['String']['output'];
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
}

export interface IQuery {
  __typename?: 'Query';
  activeCars: Array<ICar>;
  adminPendingServiceCredentials: Array<IPendingServiceCredential>;
  adminPolicyAcceptances: IPolicyAcceptancePage;
  /** Returns a 15-minute download link. */
  adminPolicyAcceptancesCsv: Scalars['String']['output'];
  adminPolicyDocuments: Array<IAdminPolicyDocument>;
  adminPolicyEvents: Array<IPolicyEventEntry>;
  adminPolicyVersions: Array<IPolicyVersion>;
  adminServiceDisputes: Array<IBooking>;
  adminServicePayoutBatches: Array<IServicePayoutBatch>;
  adminWorkerStrikes: Array<IJobEvent>;
  allBroadcasts: IPaginatedBroadcasts;
  allDamageClaims: Array<IDamageClaim>;
  allUserReports: Array<IUserReport>;
  appFeatureHistory: Array<IBrandAppFeatureChange>;
  appFeatureMatrix: IAppFeatureMatrix;
  availableCars: Array<ICarWithPricing>;
  availableCarsWithDelivery: IAirportSearchResults;
  booking: IBooking;
  bookingPaymentOptions: IBookingPaymentOptions;
  bookings: Array<IBooking>;
  bookingsForMyListings: Array<IBooking>;
  brandHosts: Array<IBrandMembership>;
  brandRules: IBrandRules;
  brandRulesHistory: Array<IBrandRulesHistoryEntry>;
  brands: Array<IBrand>;
  broadcast: IBroadcast;
  broadcastAudienceSize: Scalars['Int']['output'];
  calculateCarPricingResolver: ICarWithPricing;
  calculateCarPricingWithoutTaxResolver: ICarWithPricing;
  calendarWorkerOptions: Array<IWorkerSearchResult>;
  canRateBooking: IRatingEligibility;
  canReportDamage: ICanReportDamageResponse;
  canRespondToClaim: ICanRespondToClaimResponse;
  canStartTrip: Scalars['Boolean']['output'];
  canSubmitDLVerification: Scalars['Boolean']['output'];
  cancelledBookingsAsGuest: Array<IBooking>;
  cancelledBookingsAsHost: Array<IBooking>;
  car?: Maybe<ICar>;
  carAvailabilities: Array<ICarAvailability>;
  carAvailabilitiesByCar: Array<ICarAvailability>;
  carAvailability: ICarAvailability;
  carBookings: Array<IBooking>;
  carListingStatus: ICarListingStatus;
  carRecallChecks: Array<IRecallCheck>;
  carRecallClearances: Array<IRecallClearance>;
  carSale: ICarSale;
  carSales: Array<ICarSale>;
  cardholderNameNotices: Array<ICardholderNameNoticeRow>;
  cars: Array<ICar>;
  carsByLocation: Array<ICar>;
  carsPendingRecallCheck: Array<ICar>;
  carsWithoutRecallMatch: Array<IRecallUnmatchedCar>;
  checkAvailability: Scalars['Boolean']['output'];
  coupon: ICoupon;
  coupons: Array<ICoupon>;
  currentBrand?: Maybe<IBrand>;
  damageClaim: IDamageClaim;
  damageClaimByNumber: IDamageClaim;
  damageClaimsByBooking: Array<IDamageClaim>;
  dealer: IDealer;
  dealerCarSales: Array<ICarSale>;
  dealers: Array<IDealer>;
  findBookedRecordOfTheCar?: Maybe<ICar>;
  /** Geocode an address string to coordinates (latitude, longitude) and formatted address */
  geocodeAddress: IGeocodingResult;
  getAllCarMakesAndModels: Array<ICarMakeAndModel>;
  getAllCarsOnSale: Array<ICar>;
  getAllCarsOnSaleByDealer: Array<ICar>;
  getAllTripFees: Array<ITripFee>;
  getAllowedLocations: Array<IAllowedLocation>;
  /** Get autocomplete predictions for an address input */
  getAutocompletePredictions: Array<IAutocompletePrediction>;
  getBookingActivities: Array<IBookingActivity>;
  getBookingActivity?: Maybe<IBookingActivity>;
  getBookingAsGuest: IBooking;
  getBookingAsHost: IBooking;
  getCarBookedDates: ICarBookedDates;
  getCarDeliveryLocations: Array<ICarDeliveryLocation>;
  getCarMakes: Array<Scalars['String']['output']>;
  getCarModelsByMake: Array<Scalars['String']['output']>;
  getCarRatings: ICarRatingsResponse;
  getCarsByGeoRadius: Array<ICarWithPricing>;
  getCarsNearMe: Array<ICarWithPricingAndDistance>;
  getCurrentUser: IUser;
  getFeaturedCars: Array<ICar>;
  getGuestRatings: IGuestRatingsResponse;
  getHostRatings: IHostRatingsResponse;
  getMonthlyRentalCarsNearMe: Array<ICarWithPricingAndDistance>;
  getMyCars: Array<ICar>;
  getMyCarsByType: Array<ICar>;
  getMyCarsV2: IPaginatedCars;
  getMyDraftCar?: Maybe<ICar>;
  getMyFavorites: Array<ICar>;
  getMyLocationsV2: IPaginatedLocations;
  getRentalAgeOptions: Array<IRentalAgeType>;
  getReturnLocations: Array<IAllowedLocation>;
  getSuggestedItems: Array<ExtraItem>;
  getTripRating?: Maybe<ITripRating>;
  getUnlistedCarsByUserIdForDealer: Array<ICar>;
  getUnreadCounts: IUnreadCountsResponse;
  getYearsForMakeAndModel: Array<Scalars['Int']['output']>;
  hostCapabilities: IHostCapabilities;
  hostEarnings: IHostEarningsResponse;
  hostOpenBookingsOnBrand: Array<IBooking>;
  hostToday: IHostToday;
  hotLocations: Array<IHotLocation>;
  invoice: IInvoice;
  invoices: Array<IInvoice>;
  invoicesByRefundStatus: IPaginatedInvoices;
  invoicesByRefundStatusForHost: IPaginatedInvoices;
  jobAccess: IJobAccess;
  jobCancellationPreview: IJobCancellationPreview;
  jobTimeline: IJobTimeline;
  location: ILocation;
  locations: Array<ILocation>;
  locationsByHostId: Array<ILocation>;
  minimumWageFor: IMinimumWageForLocation;
  minimumWageRates: Array<IMinimumWageRateView>;
  miscellaneousFees?: Maybe<Array<IMiscellaneousFee>>;
  monthlyRentalHotLocationSections: Array<IHotLocationMonthlySection>;
  myAllowedToDriveTrips: Array<IAllowedToDriveTrip>;
  myAppFeatures: IAppFeatures;
  myBookings: Array<IBooking>;
  myBrand: IBrand;
  myBrandRules: IPublicBrandRules;
  myCarAvailabilities: Array<ICarAvailability>;
  myDamageClaims: Array<IDamageClaim>;
  myDealer?: Maybe<IDealer>;
  myEnvironmentSettings: IBrandEnvironmentSettings;
  myGeneralVerifyDL?: Maybe<IGeneralVerifyDl>;
  myHostBrands: Array<IHostBrand>;
  myLocations: Array<ILocation>;
  myNotifications: IPaginatedNotifications;
  myPendingPolicies: Array<IPendingPolicy>;
  myProviderTaxInfo?: Maybe<IProviderTaxInfoSummary>;
  myReports: Array<IUserReport>;
  mySavedPaymentMethods: Array<ISavedPaymentMethod>;
  myServiceJobs: Array<IBooking>;
  myServicePayouts: IMyServicePayouts;
  myServiceProvider?: Maybe<IServiceProvider>;
  myServiceSites: Array<IServiceSite>;
  myStay: ICar;
  myStays: IPaginatedCars;
  myWorker: IProviderWorker;
  myWorkerJobs: Array<IBooking>;
  myWorkerLogins: Array<IMyWorkerLogin>;
  myWorkers: Array<IProviderWorker>;
  notification: INotification;
  operatingHour: IOperatingHours;
  operatingHours: Array<IOperatingHours>;
  operatingHoursByLocation: Array<IOperatingHours>;
  operatingHoursByLocationAndType: IOperatingHours;
  pendingGeneralDLVerifications: Array<IGeneralVerifyDl>;
  pendingHostApplications: Array<IUser>;
  platformSettings: IPlatformSetting;
  platformSiteMarkers: Array<Scalars['String']['output']>;
  policyDocument?: Maybe<IPolicyVersion>;
  policyDocuments: Array<IPolicyDocumentSummary>;
  policyVersion?: Maybe<IPolicyVersion>;
  productCapabilities: IProductCapabilities;
  productTypeDetails: Array<IProductTypeDetails>;
  protectionPlan: IProtectionPlan;
  protectionPlanByType: IProtectionPlan;
  protectionPlans: Array<IProtectionPlan>;
  protectionPlansByUserId: Array<IProtectionPlan>;
  providerJobs: Array<IBooking>;
  providerTaxExport: Scalars['String']['output'];
  providerToday: IProviderToday;
  publicLocations: Array<ILocation>;
  publisherAcknowledgment: IPolicyVersion;
  recallJobStatus: IRecallJobStatus;
  referralCommissions: IReferralCommissionsResponse;
  searchCarMakesAndModels: Array<ICarMakeAndModel>;
  searchCarsInThisAreaWithDates: Array<ICarWithPricingAndDistance>;
  searchGuests: Array<IUser>;
  searchStays: IPaginatedStays;
  searchWorkers: IPaginatedWorkerResults;
  serviceFeeRates: IServiceFeeRates;
  servicePayoutBatchesCsv: Scalars['String']['output'];
  serviceSiteAccessInstructions?: Maybe<Scalars['String']['output']>;
  serviceTaxRules: Array<IServiceTaxRule>;
  serviceWorker?: Maybe<ICar>;
  similarDateCars: Array<ISimilarDateCar>;
  stay: ICar;
  stayCalendar: IStayCalendar;
  stayCancellationPreview: IStayCancellationPreview;
  stayModificationQuote: IStayModificationQuote;
  stayPrivateDetails: IStayPrivateDetails;
  stayPublishChecklist: Array<IStayPublishProblem>;
  stayQuote: IStayPriceQuote;
  stayReviews: IPaginatedStayReviews;
  stayServiceFeeRates: IStayServiceFeeRates;
  timezoneInfo: ITimezoneInfo;
  tripFee: ITripFee;
  tripFees: Array<ITripFee>;
  unlistedCars: IUnlistedCarsPage;
  user: IUser;
  userReport: IUserReport;
  users: Array<IUser>;
  validateCoupon: ICouponValidationResponse;
  validateLocationPair: IAllowedLocation;
  workerAccounts: Array<IWorkerAccount>;
  workerAvailability: Array<IWorkerBusyInterval>;
  workerPriceWarnings: Array<IPriceWageWarning>;
  workerPublishChecklist: Array<IPublishProblem>;
  workerQuote: IServiceQuote;
  workerStrikes: Array<IJobEvent>;
}


export interface IQueryActiveCarsArgs {
  siteHost?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductType>;
}


export interface IQueryAdminPolicyAcceptancesArgs {
  filter: IPolicyAcceptanceFilter;
}


export interface IQueryAdminPolicyAcceptancesCsvArgs {
  filter: IPolicyAcceptanceFilter;
}


export interface IQueryAdminPolicyDocumentsArgs {
  scope?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryAdminPolicyEventsArgs {
  kind: PolicyKind;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryAdminPolicyVersionsArgs {
  kind: PolicyKind;
  scope?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryAdminServiceDisputesArgs {
  status?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryAdminServicePayoutBatchesArgs {
  periodStart?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryAdminWorkerStrikesArgs {
  pendingAppealOnly?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface IQueryAllBroadcastsArgs {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  status?: InputMaybe<BroadcastStatus>;
}


export interface IQueryAllDamageClaimsArgs {
  status?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryAllUserReportsArgs {
  status?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryAppFeatureHistoryArgs {
  before?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}


export interface IQueryAvailableCarsArgs {
  input: IFindAvailableCarsInput;
}


export interface IQueryAvailableCarsWithDeliveryArgs {
  input: IFindAvailableCarsWithDeliveryInput;
}


export interface IQueryBookingArgs {
  id: Scalars['String']['input'];
}


export interface IQueryBookingPaymentOptionsArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IQueryBrandRulesHistoryArgs {
  before?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}


export interface IQueryBroadcastArgs {
  id: Scalars['String']['input'];
}


export interface IQueryBroadcastAudienceSizeArgs {
  audience: BroadcastAudience;
}


export interface IQueryCalculateCarPricingResolverArgs {
  input: ICarPricingInput;
}


export interface IQueryCalculateCarPricingWithoutTaxResolverArgs {
  input: ICarPricingInput;
}


export interface IQueryCalendarWorkerOptionsArgs {
  siteId: Scalars['ID']['input'];
}


export interface IQueryCanRateBookingArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IQueryCanReportDamageArgs {
  bookingId: Scalars['String']['input'];
}


export interface IQueryCanRespondToClaimArgs {
  claimId: Scalars['String']['input'];
}


export interface IQueryCanStartTripArgs {
  bookingId: Scalars['String']['input'];
}


export interface IQueryCanSubmitDlVerificationArgs {
  bookingId: Scalars['String']['input'];
}


export interface IQueryCancelledBookingsAsGuestArgs {
  filter?: InputMaybe<ICancelledBookingsFilterInput>;
}


export interface IQueryCancelledBookingsAsHostArgs {
  filter?: InputMaybe<ICancelledBookingsFilterInput>;
}


export interface IQueryCarArgs {
  id: Scalars['String']['input'];
}


export interface IQueryCarAvailabilitiesByCarArgs {
  carId: Scalars['String']['input'];
}


export interface IQueryCarAvailabilityArgs {
  id: Scalars['String']['input'];
}


export interface IQueryCarBookingsArgs {
  carId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryCarListingStatusArgs {
  carId: Scalars['ID']['input'];
}


export interface IQueryCarRecallChecksArgs {
  carId: Scalars['ID']['input'];
}


export interface IQueryCarRecallClearancesArgs {
  carId: Scalars['ID']['input'];
}


export interface IQueryCarSaleArgs {
  id: Scalars['String']['input'];
}


export interface IQueryCardholderNameNoticesArgs {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}


export interface IQueryCarsArgs {
  type?: InputMaybe<ProductType>;
}


export interface IQueryCarsByLocationArgs {
  locationId: Scalars['Int']['input'];
  type?: InputMaybe<ProductType>;
}


export interface IQueryCarsPendingRecallCheckArgs {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}


export interface IQueryCheckAvailabilityArgs {
  PickupLocationType: PickupLocationType;
  date: Scalars['DateTime']['input'];
  locationId: Scalars['Int']['input'];
}


export interface IQueryCouponArgs {
  id: Scalars['ID']['input'];
}


export interface IQueryCouponsArgs {
  hostId?: InputMaybe<Scalars['ID']['input']>;
}


export interface IQueryDamageClaimArgs {
  id: Scalars['String']['input'];
}


export interface IQueryDamageClaimByNumberArgs {
  claimNum: Scalars['String']['input'];
}


export interface IQueryDamageClaimsByBookingArgs {
  bookingId: Scalars['String']['input'];
}


export interface IQueryDealerArgs {
  id: Scalars['String']['input'];
}


export interface IQueryDealerCarSalesArgs {
  dealerId: Scalars['String']['input'];
}


export interface IQueryFindBookedRecordOfTheCarArgs {
  carId: Scalars['String']['input'];
  excludeBookingId?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryGeocodeAddressArgs {
  address: Scalars['String']['input'];
}


export interface IQueryGetAllCarsOnSaleArgs {
  type?: InputMaybe<ProductType>;
}


export interface IQueryGetAllCarsOnSaleByDealerArgs {
  input: IGetDealerCarsInput;
}


export interface IQueryGetAllowedLocationsArgs {
  locationId: Scalars['Int']['input'];
}


export interface IQueryGetAutocompletePredictionsArgs {
  input: Scalars['String']['input'];
}


export interface IQueryGetBookingActivitiesArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IQueryGetBookingActivityArgs {
  id: Scalars['ID']['input'];
}


export interface IQueryGetBookingAsGuestArgs {
  id: Scalars['String']['input'];
}


export interface IQueryGetBookingAsHostArgs {
  id: Scalars['String']['input'];
}


export interface IQueryGetCarBookedDatesArgs {
  carId: Scalars['String']['input'];
  excludeBookingId?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryGetCarDeliveryLocationsArgs {
  carId: Scalars['String']['input'];
}


export interface IQueryGetCarModelsByMakeArgs {
  make: Scalars['String']['input'];
}


export interface IQueryGetCarRatingsArgs {
  carId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface IQueryGetCarsByGeoRadiusArgs {
  input: IGetCarsByGeoRadiusInput;
}


export interface IQueryGetCarsNearMeArgs {
  input: IGetCarsNearMeInput;
}


export interface IQueryGetFeaturedCarsArgs {
  input?: InputMaybe<IGetFeaturedCarsInput>;
}


export interface IQueryGetGuestRatingsArgs {
  guestId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface IQueryGetHostRatingsArgs {
  hostId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface IQueryGetMonthlyRentalCarsNearMeArgs {
  input: IGetCarsNearMeInput;
}


export interface IQueryGetMyCarsByTypeArgs {
  type?: InputMaybe<ProductType>;
}


export interface IQueryGetMyCarsV2Args {
  input: IGetMyCarsV2Input;
}


export interface IQueryGetMyLocationsV2Args {
  input: IGetMyLocationsV2Input;
}


export interface IQueryGetReturnLocationsArgs {
  pickupLocationId: Scalars['Int']['input'];
}


export interface IQueryGetTripRatingArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IQueryGetUnlistedCarsByUserIdForDealerArgs {
  type?: InputMaybe<ProductType>;
}


export interface IQueryGetUnreadCountsArgs {
  role?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryGetYearsForMakeAndModelArgs {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
}


export interface IQueryHostEarningsArgs {
  input: IHostEarningsInput;
}


export interface IQueryHostOpenBookingsOnBrandArgs {
  userId: Scalars['ID']['input'];
}


export interface IQueryInvoiceArgs {
  id: Scalars['ID']['input'];
}


export interface IQueryInvoicesByRefundStatusArgs {
  filter: IInvoiceFilterInput;
}


export interface IQueryInvoicesByRefundStatusForHostArgs {
  filter: IInvoiceFilterInput;
}


export interface IQueryJobAccessArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IQueryJobCancellationPreviewArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IQueryJobTimelineArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IQueryLocationArgs {
  id: Scalars['Int']['input'];
}


export interface IQueryLocationsByHostIdArgs {
  hostId: Scalars['String']['input'];
}


export interface IQueryMinimumWageForArgs {
  locationId: Scalars['Int']['input'];
}


export interface IQueryMinimumWageRatesArgs {
  state?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryMiscellaneousFeesArgs {
  carId: Scalars['String']['input'];
}


export interface IQueryMonthlyRentalHotLocationSectionsArgs {
  input?: InputMaybe<IHotLocationMonthlySectionsInput>;
}


export interface IQueryMyNotificationsArgs {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryMySavedPaymentMethodsArgs {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface IQueryMyServiceJobsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}


export interface IQueryMyServiceSitesArgs {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface IQueryMyStayArgs {
  id: Scalars['ID']['input'];
}


export interface IQueryMyStaysArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<StayListingStatus>;
}


export interface IQueryMyWorkerArgs {
  workerCarId: Scalars['ID']['input'];
}


export interface IQueryMyWorkerJobsArgs {
  date?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryMyWorkersArgs {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ServiceListingStatus>;
}


export interface IQueryNotificationArgs {
  id: Scalars['String']['input'];
}


export interface IQueryOperatingHourArgs {
  id: Scalars['ID']['input'];
}


export interface IQueryOperatingHoursByLocationArgs {
  locationId: Scalars['Int']['input'];
}


export interface IQueryOperatingHoursByLocationAndTypeArgs {
  PickupLocationType: PickupLocationType;
  locationId: Scalars['Int']['input'];
}


export interface IQueryPolicyDocumentArgs {
  kind: PolicyKind;
}


export interface IQueryPolicyVersionArgs {
  id: Scalars['ID']['input'];
}


export interface IQueryProductCapabilitiesArgs {
  type: ProductType;
}


export interface IQueryProtectionPlanArgs {
  id: Scalars['String']['input'];
}


export interface IQueryProtectionPlanByTypeArgs {
  planType: Scalars['String']['input'];
}


export interface IQueryProtectionPlansByUserIdArgs {
  userId: Scalars['String']['input'];
}


export interface IQueryProviderJobsArgs {
  from: Scalars['String']['input'];
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['String']['input'];
}


export interface IQueryProviderTaxExportArgs {
  year: Scalars['Int']['input'];
}


export interface IQueryProviderTodayArgs {
  date?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryPublicLocationsArgs {
  allAirports?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<LocationType>;
}


export interface IQueryReferralCommissionsArgs {
  input?: InputMaybe<IReferralCommissionsInput>;
}


export interface IQuerySearchCarMakesAndModelsArgs {
  query: Scalars['String']['input'];
}


export interface IQuerySearchCarsInThisAreaWithDatesArgs {
  input: ISearchCarsInThisAreaWithDatesInput;
}


export interface IQuerySearchGuestsArgs {
  firstName: Scalars['String']['input'];
}


export interface IQuerySearchStaysArgs {
  input: ISearchStaysInput;
}


export interface IQuerySearchWorkersArgs {
  input: ISearchWorkersInput;
}


export interface IQueryServicePayoutBatchesCsvArgs {
  periodStart: Scalars['String']['input'];
}


export interface IQueryServiceSiteAccessInstructionsArgs {
  siteId: Scalars['ID']['input'];
}


export interface IQueryServiceWorkerArgs {
  carId: Scalars['ID']['input'];
}


export interface IQuerySimilarDateCarsArgs {
  input: ISimilarDateCarsInput;
}


export interface IQueryStayArgs {
  id: Scalars['ID']['input'];
}


export interface IQueryStayCalendarArgs {
  excludeBookingId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryStayCancellationPreviewArgs {
  bookingId: Scalars['ID']['input'];
}


export interface IQueryStayModificationQuoteArgs {
  input: IModifyStayInput;
}


export interface IQueryStayPrivateDetailsArgs {
  id: Scalars['ID']['input'];
}


export interface IQueryStayPublishChecklistArgs {
  id: Scalars['ID']['input'];
}


export interface IQueryStayQuoteArgs {
  id: Scalars['ID']['input'];
  input: IStayQuoteInput;
}


export interface IQueryStayReviewsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  stayId: Scalars['ID']['input'];
}


export interface IQueryTimezoneInfoArgs {
  zipCode: Scalars['String']['input'];
}


export interface IQueryTripFeeArgs {
  id: Scalars['String']['input'];
}


export interface IQueryTripFeesArgs {
  userId: Scalars['String']['input'];
}


export interface IQueryUnlistedCarsArgs {
  filter?: InputMaybe<IUnlistedCarsFilter>;
}


export interface IQueryUserArgs {
  id: Scalars['String']['input'];
}


export interface IQueryUserReportArgs {
  id: Scalars['String']['input'];
}


export interface IQueryValidateCouponArgs {
  carId?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  endAt?: InputMaybe<Scalars['Float']['input']>;
  guestId?: InputMaybe<Scalars['ID']['input']>;
  startAt?: InputMaybe<Scalars['Float']['input']>;
  totalDays?: InputMaybe<Scalars['Int']['input']>;
}


export interface IQueryValidateLocationPairArgs {
  fromLocationId: Scalars['Int']['input'];
  toLocationId: Scalars['Int']['input'];
}


export interface IQueryWorkerAccountsArgs {
  workerCarId: Scalars['ID']['input'];
}


export interface IQueryWorkerAvailabilityArgs {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
  workerCarId: Scalars['ID']['input'];
}


export interface IQueryWorkerPriceWarningsArgs {
  workerCarId: Scalars['ID']['input'];
}


export interface IQueryWorkerPublishChecklistArgs {
  workerCarId: Scalars['ID']['input'];
}


export interface IQueryWorkerQuoteArgs {
  input: IWorkerQuoteInput;
  workerCarId: Scalars['ID']['input'];
}


export interface IQueryWorkerStrikesArgs {
  workerCarId: Scalars['ID']['input'];
}

export enum RangeStatus {
  BeyondMaxDistance = 'BEYOND_MAX_DISTANCE',
  InRange = 'IN_RANGE',
  OutOfRangeNotServed = 'OUT_OF_RANGE_NOT_SERVED',
  OutOfRangeWithFee = 'OUT_OF_RANGE_WITH_FEE'
}

export interface IRatingDistribution {
  __typename?: 'RatingDistribution';
  fiveStars: Scalars['Int']['output'];
  fourStars: Scalars['Int']['output'];
  oneStar: Scalars['Int']['output'];
  threeStars: Scalars['Int']['output'];
  twoStars: Scalars['Int']['output'];
}

export interface IRatingEligibility {
  __typename?: 'RatingEligibility';
  canGuestRate: Scalars['Boolean']['output'];
  canHostRate: Scalars['Boolean']['output'];
  guestRatingDeadline?: Maybe<Scalars['DateTime']['output']>;
  hostRatingDeadline?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
}

export interface IRecallCheck {
  __typename?: 'RecallCheck';
  /** yyyy-MM-dd */
  checkedOn: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  result: RecallCheckResult;
  source: RecallCheckSource;
}

export enum RecallCheckResult {
  Clear = 'CLEAR',
  OpenRecall = 'OPEN_RECALL'
}

export enum RecallCheckSource {
  AdminManual = 'ADMIN_MANUAL',
  AdminRelist = 'ADMIN_RELIST',
  SystemModelYear = 'SYSTEM_MODEL_YEAR'
}

export interface IRecallClearance {
  __typename?: 'RecallClearance';
  campaignNumber: Scalars['String']['output'];
  clearedAt: Scalars['DateTime']['output'];
  clearedByName?: Maybe<Scalars['String']['output']>;
  /** Signed URLs, valid for 15 minutes */
  evidenceUrls: Array<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
}

export interface IRecallJobStatus {
  __typename?: 'RecallJobStatus';
  lastError?: Maybe<Scalars['String']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
  /** off | dry-run | live */
  mode: Scalars['String']['output'];
  modelYearsFailing: Scalars['Int']['output'];
  modelYearsTracked: Scalars['Int']['output'];
  unmatchedCarCount: Scalars['Int']['output'];
}

export interface IRecallUnmatchedCar {
  __typename?: 'RecallUnmatchedCar';
  car: ICar;
  /** missing_make_model_year | model_not_in_nhtsa | lookup_failed */
  reason: Scalars['String']['output'];
}

export interface IReceipt {
  __typename?: 'Receipt';
  addOnAllowance?: Maybe<Scalars['Float']['output']>;
  addOnsSubtotal?: Maybe<Scalars['Float']['output']>;
  /** Snapshot of the trip's total distance allowance, in the trip's distanceUnit (miles when null; spec 028). -1 means unlimited distance. */
  allowedMileage?: Maybe<Scalars['Int']['output']>;
  /** sqft or sqm; null is sqft (spec 028). */
  areaUnit?: Maybe<Scalars['String']['output']>;
  /** Card hold: the total plus the 25% add-on allowance (D31). */
  authorizedAmount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  cancellationPenalty?: Maybe<Scalars['Float']['output']>;
  carPricePerTrip?: Maybe<Scalars['Float']['output']>;
  cleaningFee?: Maybe<Scalars['Float']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponDiscount?: Maybe<Scalars['Float']['output']>;
  /** USD or CAD; null is USD (trips from before spec 028). */
  currency?: Maybe<Scalars['String']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  discountTier?: Maybe<Scalars['String']['output']>;
  /** mi or km; null is mi (trips from before spec 028). */
  distanceUnit?: Maybe<Scalars['String']['output']>;
  extraGuestFee?: Maybe<Scalars['Float']['output']>;
  /** Distance over the allowance. In the trip's distanceUnit (miles when null; spec 028). */
  extraMilages?: Maybe<Scalars['Float']['output']>;
  extraMilagesCost?: Maybe<Scalars['Float']['output']>;
  /** Amount captured after completion. */
  finalTotal?: Maybe<Scalars['Float']['output']>;
  freeCancellationServiceFee?: Maybe<Scalars['Float']['output']>;
  /** Platform service fee paid by the guest. */
  guestServiceFee?: Maybe<Scalars['Float']['output']>;
  guestServiceFeeRate?: Maybe<Scalars['Float']['output']>;
  /** Billed handover minutes (D8). */
  handoverMinutes?: Maybe<Scalars['Int']['output']>;
  /** Platform service fee taken from the host payout. */
  hostServiceFee?: Maybe<Scalars['Float']['output']>;
  hostServiceFeeRate?: Maybe<Scalars['Float']['output']>;
  insuranceByTrip?: Maybe<Scalars['Float']['output']>;
  insurancePerDay?: Maybe<Scalars['Float']['output']>;
  last4digitOfCard?: Maybe<Scalars['String']['output']>;
  lastMinSurchargeAmount?: Maybe<Scalars['Float']['output']>;
  lastMinSurchargePercentage?: Maybe<Scalars['Float']['output']>;
  monthlyDiscountAmount?: Maybe<Scalars['Float']['output']>;
  /** Monthly trip fee rate applied at booking time. Null for DAILY bookings. */
  monthlyTripFeeRate?: Maybe<Scalars['Float']['output']>;
  /** Monthly youngster fee rate applied at booking time. Null when no youngster fee is owed. */
  monthlyYoungsterFeeRate?: Maybe<Scalars['Float']['output']>;
  /** Sum of the nightly prices before discounts. */
  nightlySubtotal?: Maybe<Scalars['Float']['output']>;
  /** Nights in a stay (spec 016). */
  nights?: Maybe<Scalars['Int']['output']>;
  /** Lodging tax on the stay (not on service fees). */
  occupancyTax?: Maybe<Scalars['Float']['output']>;
  oneWayFee?: Maybe<Scalars['Float']['output']>;
  originalAvgDailyPrice?: Maybe<Scalars['Float']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  /** Price per unit over the allowance, in the trip's currency. In the trip's distanceUnit (miles when null; spec 028). */
  perExtraMileCost?: Maybe<Scalars['Float']['output']>;
  petFee?: Maybe<Scalars['Float']['output']>;
  /** Platform service fee paid by the customer. */
  platformServiceFee?: Maybe<Scalars['Float']['output']>;
  postTripIncidentChargesTotal?: Maybe<Scalars['Float']['output']>;
  pricePerDay?: Maybe<Scalars['Float']['output']>;
  /** Average nightly price before the length-of-stay discount. */
  pricePerNight?: Maybe<Scalars['Float']['output']>;
  providerFeeRate?: Maybe<Scalars['Float']['output']>;
  /** What the Provider is paid for the job. */
  providerPayout?: Maybe<Scalars['Float']['output']>;
  /** Snapshot of the backend rental classification at booking time. */
  rentalType?: Maybe<RentalTypeEnum>;
  securityDeposit?: Maybe<Scalars['Float']['output']>;
  /** Sum of the services on the job. */
  serviceSubtotal?: Maybe<Scalars['Float']['output']>;
  /** Tax at the service site (D24). */
  serviceTax?: Maybe<Scalars['Float']['output']>;
  serviceTaxRate?: Maybe<Scalars['Float']['output']>;
  shortenTripPenalty?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxPerTrip?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  totalDays?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  totalPriceWithFees?: Maybe<Scalars['Float']['output']>;
  totalPriceWithPostTripCharges?: Maybe<Scalars['Float']['output']>;
  /** Per-mile fee outside the service radius. */
  travelFee?: Maybe<Scalars['Float']['output']>;
  travelMilesBeyond?: Maybe<Scalars['Float']['output']>;
  tripFee?: Maybe<Scalars['Float']['output']>;
  tripFeeTotal?: Maybe<Scalars['Float']['output']>;
  weeklyDiscountAmount?: Maybe<Scalars['Float']['output']>;
  youngsterFee?: Maybe<Scalars['Float']['output']>;
  youngsterFeeTotal?: Maybe<Scalars['Float']['output']>;
}

export interface IRecordJobEventInput {
  accuracyMeters?: InputMaybe<Scalars['Int']['input']>;
  bookingId: Scalars['ID']['input'];
  capturedAt: Scalars['DateTime']['input'];
  checklistItemCode?: InputMaybe<Scalars['String']['input']>;
  issueKind?: InputMaybe<IssueKind>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  photoKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  type: JobEventType;
}

export interface IRecordRecallCheckInput {
  attachmentKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  carId: Scalars['ID']['input'];
  /** yyyy-MM-dd, not after today */
  checkedOn: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  result: RecallCheckResult;
}

export interface IReferralCommission {
  __typename?: 'ReferralCommission';
  booking?: Maybe<IBooking>;
  bookingId: Scalars['String']['output'];
  brandSite: Scalars['String']['output'];
  carOwnerHost?: Maybe<IUser>;
  carOwnerHostId: Scalars['String']['output'];
  commissionAmount: Scalars['Float']['output'];
  commissionBasis: Scalars['Float']['output'];
  commissionRate: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Scalars['String']['output'];
  earnedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  referringBrandSite: Scalars['String']['output'];
  status: ReferralCommissionStatus;
  updatedAt: Scalars['DateTime']['output'];
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
}

export enum ReferralCommissionStatus {
  Earned = 'EARNED',
  Pending = 'PENDING',
  Voided = 'VOIDED'
}

export interface IReferralCommissionSummary {
  __typename?: 'ReferralCommissionSummary';
  currencyCode: Scalars['String']['output'];
  earnedAmount: Scalars['Float']['output'];
  pendingAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  voidedAmount: Scalars['Float']['output'];
}

export interface IReferralCommissionsInput {
  brandSite?: InputMaybe<Scalars['String']['input']>;
  carOwnerHostId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ReferralCommissionStatus>;
}

export interface IReferralCommissionsResponse {
  __typename?: 'ReferralCommissionsResponse';
  asCarOwner: IReferralCommissionSummary;
  asReferrer: IReferralCommissionSummary;
  brandSite?: Maybe<Scalars['String']['output']>;
  commissions: Array<IReferralCommission>;
}

export interface IRefundResponse {
  __typename?: 'RefundResponse';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  receiptNumber?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
}

/** Refund status options */
export enum RefundStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  None = 'NONE',
  PendingHostReview = 'PENDING_HOST_REVIEW',
  Processing = 'PROCESSING'
}

export interface IRejectDlInput {
  bookingId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  refundAmount: Scalars['Float']['input'];
}

export interface IRemoveBookingPenaltiesInput {
  bookingId: Scalars['String']['input'];
  removeCancellationPenalty?: InputMaybe<Scalars['Boolean']['input']>;
  removeModificationPenalty?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface IRemoveCarAvailabilitiesResponse {
  __typename?: 'RemoveCarAvailabilitiesResponse';
  message?: Maybe<Scalars['String']['output']>;
  removedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
}

export interface IRemoveCarDeliveryLocationInput {
  carId: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
}

export interface IRemoveFavoriteInput {
  carId: Scalars['String']['input'];
}

export interface IRemoveMiscellaneousFeeResponse {
  __typename?: 'RemoveMiscellaneousFeeResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface IRemovePaymentMethodResult {
  __typename?: 'RemovePaymentMethodResult';
  hidden: Scalars['Boolean']['output'];
  inUseByBookingIds: Array<Scalars['ID']['output']>;
  removed: Scalars['Boolean']['output'];
}

/** The rental age range options */
export enum RentalAgeEnum {
  Between_18And_21 = 'BETWEEN_18_AND_21',
  Between_21And_25 = 'BETWEEN_21_AND_25',
  MoreThan_25 = 'MORE_THAN_25'
}

export interface IRentalAgeType {
  __typename?: 'RentalAgeType';
  ageLimit: Scalars['Int']['output'];
  ageMax: Scalars['Int']['output'];
  ageRange: RentalAgeEnum;
}

export enum RentalAgreementAuthorization {
  AdditionalDriverAcceptance = 'ADDITIONAL_DRIVER_ACCEPTANCE',
  GuestAcceptance = 'GUEST_ACCEPTANCE',
  GuestApproval = 'GUEST_APPROVAL',
  GuestConfirmation = 'GUEST_CONFIRMATION',
  GuestPayment = 'GUEST_PAYMENT',
  Host = 'HOST',
  HostForced = 'HOST_FORCED',
  System = 'SYSTEM'
}

export interface IRentalAgreementRecord {
  __typename?: 'RentalAgreementRecord';
  /** Admins only. */
  actorId?: Maybe<Scalars['ID']['output']>;
  authorization: RentalAgreementAuthorization;
  createdAt: Scalars['DateTime']['output'];
  governingVersion: IPolicyVersion;
  id: Scalars['ID']['output'];
  /** The frozen groups (agreements.md 4.1) as JSON; clients render known groups and ignore others. */
  payload: Scalars['JSON']['output'];
  payloadSha256: Scalars['String']['output'];
  previousSha256?: Maybe<Scalars['String']['output']>;
  reason: RentalAgreementRecordReason;
  sequence: Scalars['Int']['output'];
}

export enum RentalAgreementRecordReason {
  AdditionalDriver = 'ADDITIONAL_DRIVER',
  Checkout = 'CHECKOUT',
  CheckIn = 'CHECK_IN',
  Extension = 'EXTENSION',
  Return = 'RETURN',
  Shortening = 'SHORTENING',
  Swap = 'SWAP'
}

/** Classification of a booking by pricing engine: DAILY uses per-day pricing and duration discounts; MONTHLY uses fixed monthly tier pricing (set on the car) prorated over the trip duration. */
export enum RentalTypeEnum {
  Daily = 'DAILY',
  Monthly = 'MONTHLY'
}

export interface IReorderHotLocationsInput {
  orderedIds: Array<Scalars['ID']['input']>;
}

/** Estimated cost range for repairs */
export enum RepairEstimateRange {
  Below_500 = 'BELOW_500',
  Over_2000 = 'OVER_2000',
  Range_500_1000 = 'RANGE_500_1000',
  Range_1000_2000 = 'RANGE_1000_2000',
  Unknown = 'UNKNOWN'
}

export interface IRepairShopInfo {
  __typename?: 'RepairShopInfo';
  address?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  shopName?: Maybe<Scalars['String']['output']>;
}

export interface IRepairShopInfoInput {
  address?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  shopName?: InputMaybe<Scalars['String']['input']>;
}

/** Status of a user report */
export enum ReportStatus {
  Dismissed = 'DISMISSED',
  Pending = 'PENDING',
  Resolved = 'RESOLVED',
  Reviewed = 'REVIEWED'
}

export interface IRequestJobAddOnInput {
  amount?: InputMaybe<Scalars['Float']['input']>;
  bookingId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  photoKeys: Array<Scalars['String']['input']>;
  quantity?: Scalars['Int']['input'];
  receiptKey?: InputMaybe<Scalars['String']['input']>;
}

export interface IResendConfirmationCodeResponse {
  __typename?: 'ResendConfirmationCodeResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
}

export interface IRespondToClaimInput {
  claimId: Scalars['String']['input'];
  responseContent: Scalars['String']['input'];
  responsePhotos?: InputMaybe<Array<Scalars['String']['input']>>;
}

export enum ReviewCategorySet {
  Car = 'CAR',
  Service = 'SERVICE',
  Stay = 'STAY'
}

export interface IReviewGeneralDlVerificationInput {
  approved: Scalars['Boolean']['input'];
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issuingRegion?: InputMaybe<Scalars['String']['input']>;
  legalFirstName?: InputMaybe<Scalars['String']['input']>;
  legalLastName?: InputMaybe<Scalars['String']['input']>;
  legalMiddleName?: InputMaybe<Scalars['String']['input']>;
  licenceNumber?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
}

/** How the product is sold (service, oneTime, or rental) */
export enum SaleAs {
  OneTime = 'ONE_TIME',
  Rental = 'RENTAL',
  Service = 'SERVICE'
}

export interface ISavePolicyDraftInput {
  changeSummary?: InputMaybe<Scalars['String']['input']>;
  contentMarkdown: Scalars['String']['input'];
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  kind: PolicyKind;
  /** Platform owner only. Defaults to the X-Site-Host brand; '*' for the platform. */
  scope?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface ISavedCardSetupType {
  __typename?: 'SavedCardSetupType';
  clientSecret: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  publishableKey?: Maybe<Scalars['String']['output']>;
  setupIntentId: Scalars['String']['output'];
}

export interface ISavedPaymentMethod {
  __typename?: 'SavedPaymentMethod';
  allowRedisplay: Scalars['String']['output'];
  billingCity?: Maybe<Scalars['String']['output']>;
  billingLine1?: Maybe<Scalars['String']['output']>;
  billingLine2?: Maybe<Scalars['String']['output']>;
  billingPostalCode?: Maybe<Scalars['String']['output']>;
  billingState?: Maybe<Scalars['String']['output']>;
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inUseByBookingIds: Array<Scalars['ID']['output']>;
  isDefault: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
  usedByThisBooking: Scalars['Boolean']['output'];
  wallet?: Maybe<Scalars['String']['output']>;
}

export interface ISearchCarsInThisAreaWithDatesInput {
  driverAge?: InputMaybe<Scalars['Int']['input']>;
  endAt: Scalars['Float']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  maxRadiusMiles: Scalars['Float']['input'];
  minRadiusMiles: Scalars['Float']['input'];
  startAt: Scalars['Float']['input'];
  type?: InputMaybe<ProductType>;
}

export interface ISearchStaysInput {
  bounds?: InputMaybe<IGeoBoundsInput>;
  checkIn?: InputMaybe<Scalars['String']['input']>;
  checkOut?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<IStaySearchFiltersInput>;
  guests?: InputMaybe<IGuestCountsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<StaySortOption>;
  where?: InputMaybe<IGeoPointRadiusInput>;
}

export interface ISearchWorkersInput {
  addOns?: InputMaybe<Array<IAddOnChoiceInput>>;
  bounds?: InputMaybe<IBoundsInput>;
  center?: InputMaybe<ILatLngInput>;
  cleaningLevel?: InputMaybe<CleaningLevel>;
  homeSize?: InputMaybe<IHomeSizeInputType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxBillableMinutes?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  serviceDate: Scalars['String']['input'];
  serviceType: ServiceType;
  siteId?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<WorkerSort>;
  vehicleClass?: InputMaybe<VehicleClass>;
  windowEnd: Scalars['String']['input'];
  windowStart: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
}

/** Security deposit status options */
export enum SecurityDepositStatus {
  Authorized = 'AUTHORIZED',
  Charged = 'CHARGED',
  Held = 'HELD',
  NotRequired = 'NOT_REQUIRED',
  PartiallyReleased = 'PARTIALLY_RELEASED',
  PendingHold = 'PENDING_HOLD',
  Released = 'RELEASED'
}

export interface ISendEmailInput {
  email: Scalars['String']['input'];
}

export interface ISendEmailResponse {
  __typename?: 'SendEmailResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
}

export interface ISendMessageInput {
  chatId: Scalars['String']['input'];
  guestId: Scalars['String']['input'];
  hostId: Scalars['String']['input'];
  senderId: Scalars['String']['input'];
  senderName: Scalars['String']['input'];
  text: Scalars['String']['input'];
}

export interface ISendMessageResponse {
  __typename?: 'SendMessageResponse';
  message?: Maybe<Scalars['String']['output']>;
  messageId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
}

export interface IServiceAddOnPrice {
  __typename?: 'ServiceAddOnPrice';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
  minutes?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
}

export interface IServiceAddOnPriceInput {
  code: Scalars['String']['input'];
  label: Scalars['String']['input'];
  minutes?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  unit: Scalars['String']['input'];
}

export interface IServiceCustomerRatingData {
  __typename?: 'ServiceCustomerRatingData';
  communication: Scalars['Int']['output'];
  overall: Scalars['Int']['output'];
  photoCompleteness: Scalars['Int']['output'];
  punctuality: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  thoroughness: Scalars['Int']['output'];
}

export interface IServiceCustomerRatingInput {
  bookingId: Scalars['ID']['input'];
  communication: Scalars['Int']['input'];
  overall: Scalars['Int']['input'];
  photoCompleteness: Scalars['Int']['input'];
  privateNote?: InputMaybe<Scalars['String']['input']>;
  punctuality: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
  thoroughness: Scalars['Int']['input'];
}

export interface IServiceDocumentUpload {
  __typename?: 'ServiceDocumentUpload';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface IServiceFeeRates {
  __typename?: 'ServiceFeeRates';
  customerFeeRate: Scalars['Float']['output'];
  providerFeeRate: Scalars['Float']['output'];
  waiverDays: Scalars['Int']['output'];
}

export interface IServiceJobInfo {
  __typename?: 'ServiceJobInfo';
  authorizeAfter?: Maybe<Scalars['DateTime']['output']>;
  billedHandoverMinutes?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  customerNote?: Maybe<Scalars['String']['output']>;
  fromCalendar: Scalars['Boolean']['output'];
  items: Scalars['JSON']['output'];
  jobStatus?: Maybe<JobStatus>;
  maxBillableMinutes?: Maybe<Scalars['Int']['output']>;
  refundWindowEndsAt?: Maybe<Scalars['DateTime']['output']>;
  respondBy?: Maybe<Scalars['DateTime']['output']>;
  selectedAddOns?: Maybe<Scalars['JSON']['output']>;
  serviceDate: Scalars['String']['output'];
  site?: Maybe<IServiceSiteSummary>;
  timezone: Scalars['String']['output'];
  windowEndAt: Scalars['Float']['output'];
  windowStartAt: Scalars['Float']['output'];
  workerName?: Maybe<Scalars['String']['output']>;
}

export enum ServiceListingStatus {
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  Listed = 'LISTED',
  Unlisted = 'UNLISTED'
}

export interface IServiceOfferingInput {
  addOns?: InputMaybe<Array<IServiceAddOnPriceInput>>;
  durationRules?: InputMaybe<Scalars['JSON']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  priceTable?: InputMaybe<Scalars['JSON']['input']>;
  serviceType: ServiceType;
}

export interface IServiceOfferingView {
  __typename?: 'ServiceOfferingView';
  addOns: Array<IServiceAddOnPrice>;
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  minimumBillableMinutes: Scalars['Int']['output'];
  priceTable: Scalars['JSON']['output'];
  pricingMode: PricingMode;
  serviceType: ServiceType;
}

export interface IServicePayoutBatch {
  __typename?: 'ServicePayoutBatch';
  amount: Scalars['Float']['output'];
  bookingIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobCount: Scalars['Int']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
  providerId: Scalars['ID']['output'];
  providerName: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
}

export interface IServiceProvider {
  __typename?: 'ServiceProvider';
  averageRating?: Maybe<Scalars['Float']['output']>;
  businessName: Scalars['String']['output'];
  /** Own view only (D10) */
  feeWaivedUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Own view only */
  insuranceExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Own view only: sent, waiting for review */
  insurancePending?: Maybe<Scalars['Boolean']['output']>;
  insuranceVerified: Scalars['Boolean']['output'];
  providerKind: ProviderKind;
  /** Own view only (D28) */
  taxInfoComplete?: Maybe<Scalars['Boolean']['output']>;
  totalRatings: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
}

export interface IServiceProviderInput {
  businessName: Scalars['String']['input'];
  providerKind: ProviderKind;
}

export interface IServiceQuote {
  __typename?: 'ServiceQuote';
  addOnAllowance: Scalars['Float']['output'];
  addOnsSubtotal: Scalars['Float']['output'];
  authorizedAmount: Scalars['Float']['output'];
  estimatedMinutes: Scalars['Int']['output'];
  isEstimate: Scalars['Boolean']['output'];
  lines: Array<IServiceQuoteLineView>;
  platformServiceFee: Scalars['Float']['output'];
  serviceSubtotal: Scalars['Float']['output'];
  serviceTax: Scalars['Float']['output'];
  taxLabel: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  travelDistanceUnit: Scalars['String']['output'];
  travelFee: Scalars['Float']['output'];
}

export interface IServiceQuoteLineView {
  __typename?: 'ServiceQuoteLineView';
  amount: Scalars['Float']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
}

export interface IServiceSite {
  __typename?: 'ServiceSite';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  calendarDefaults?: Maybe<Scalars['JSON']['output']>;
  calendarLastError?: Maybe<Scalars['String']['output']>;
  calendarLastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  city: Scalars['String']['output'];
  externalCalendarUrl?: Maybe<Scalars['String']['output']>;
  hasAccessInstructions: Scalars['Boolean']['output'];
  homeDetails?: Maybe<Scalars['JSON']['output']>;
  homeSupplies?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  kind: ServiceSiteKind;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  nickname: Scalars['String']['output'];
  state: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  vehicleDetails?: Maybe<Scalars['JSON']['output']>;
  zip: Scalars['String']['output'];
}

export interface IServiceSiteInput {
  accessInstructions?: InputMaybe<Scalars['String']['input']>;
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  calendarDefaults?: InputMaybe<Scalars['JSON']['input']>;
  city: Scalars['String']['input'];
  externalCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  homeDetails?: InputMaybe<Scalars['JSON']['input']>;
  homeSupplies?: InputMaybe<Scalars['JSON']['input']>;
  kind: ServiceSiteKind;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  nickname: Scalars['String']['input'];
  state: Scalars['String']['input'];
  vehicleDetails?: InputMaybe<Scalars['JSON']['input']>;
  zip: Scalars['String']['input'];
}

export enum ServiceSiteKind {
  Home = 'HOME',
  Vehicle = 'VEHICLE'
}

export interface IServiceSiteSummary {
  __typename?: 'ServiceSiteSummary';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  distanceMiles?: Maybe<Scalars['Float']['output']>;
  homeDetails?: Maybe<Scalars['JSON']['output']>;
  kind: ServiceSiteKind;
  nickname?: Maybe<Scalars['String']['output']>;
  vehicleDetails?: Maybe<Scalars['JSON']['output']>;
  zip: Scalars['String']['output'];
}

export interface IServiceTaxRule {
  __typename?: 'ServiceTaxRule';
  platformFeeTaxable: Scalars['Boolean']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  serviceType: ServiceType;
  state: Scalars['String']['output'];
  taxable: Scalars['Boolean']['output'];
}

export enum ServiceType {
  HomeTurnover = 'HOME_TURNOVER',
  VehicleCleaning = 'VEHICLE_CLEANING',
  VehicleHandover = 'VEHICLE_HANDOVER'
}

export interface IServiceWorker {
  __typename?: 'ServiceWorker';
  acceptsOutOfRadius: Scalars['Boolean']['output'];
  advanceNoticeHours: Scalars['Int']['output'];
  areaCenter?: Maybe<ILatLng>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  backgroundCheckVerified: Scalars['Boolean']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  bufferHours: Scalars['Int']['output'];
  cancellationRate?: Maybe<Scalars['Float']['output']>;
  carId: Scalars['ID']['output'];
  city: Scalars['String']['output'];
  completedJobCount: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  distanceUnit: Scalars['String']['output'];
  equipmentPhotos: Array<Scalars['String']['output']>;
  instantBook: Scalars['Boolean']['output'];
  languages: Array<Scalars['String']['output']>;
  /** In the worker's distanceUnit (spec 028). */
  maxTravelMiles?: Maybe<Scalars['Int']['output']>;
  offerings: Array<IServiceOfferingView>;
  onTimeRate?: Maybe<Scalars['Float']['output']>;
  paused: Scalars['Boolean']['output'];
  /** Price per unit past the radius. In the worker's distanceUnit (spec 028). */
  perMileBeyondRadius?: Maybe<Scalars['Float']['output']>;
  provider: IServiceProvider;
  /** In the worker's distanceUnit (spec 028). */
  serviceRadiusMiles: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  suppliesProvided: ISuppliesProvided;
  totalRatings: Scalars['Int']['output'];
  yearsExperience?: Maybe<Scalars['Int']['output']>;
  zip: Scalars['String']['output'];
}

export interface IServiceWorkerRatingData {
  __typename?: 'ServiceWorkerRatingData';
  access: Scalars['Int']['output'];
  accuracy: Scalars['Int']['output'];
  communication: Scalars['Int']['output'];
  overall: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
}

export interface IServiceWorkerRatingInput {
  access: Scalars['Int']['input'];
  accuracy: Scalars['Int']['input'];
  bookingId: Scalars['ID']['input'];
  communication: Scalars['Int']['input'];
  overall: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
}

export interface IServiceWorkerSettings {
  __typename?: 'ServiceWorkerSettings';
  backgroundCheck?: Maybe<IBackgroundCheckView>;
  confirmWindowHours: Scalars['Int']['output'];
  listingStatus: ServiceListingStatus;
  pauseReason?: Maybe<Scalars['String']['output']>;
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  serviceZips: Array<Scalars['String']['output']>;
  suppliesSet: Scalars['Boolean']['output'];
  wizardStep?: Maybe<Scalars['String']['output']>;
  workingHours?: Maybe<Scalars['JSON']['output']>;
}

export interface ISetBrandAdminInput {
  brandSite: Scalars['String']['input'];
  isAdmin: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
}

export interface ISetBrandAppFeatureInput {
  brandSite: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  expectedEnabled: Scalars['Boolean']['input'];
  feature: Scalars['String']['input'];
}

export interface ISetupIntentType {
  __typename?: 'SetupIntentType';
  clientSecret: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  customerSessionClientSecret?: Maybe<Scalars['String']['output']>;
  setupIntentId: Scalars['String']['output'];
}

export interface ISignInInput {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface ISignInWithAppleInput {
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identityToken: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  nonce?: InputMaybe<Scalars['String']['input']>;
}

export interface ISignInWithGoogleInput {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idToken: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
}

export interface ISignUpInput {
  acceptedPolicyVersionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  acceptedTerms: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  emailMarketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
}

export interface ISimilarDateCar {
  __typename?: 'SimilarDateCar';
  /** Average accuracy rating */
  accuracyAvg?: Maybe<Scalars['Float']['output']>;
  ageLimit?: Maybe<Scalars['Int']['output']>;
  approximateLocation?: Maybe<IApproximateLocation>;
  availabilities?: Maybe<Array<ICarAvailability>>;
  /** Average overall rating (1-5) */
  averageRating?: Maybe<Scalars['Float']['output']>;
  bookableOnThisSite: ICarBookability;
  bookings?: Maybe<Array<IBooking>>;
  calculatedPrice: ICalculatedPriceInfo;
  category?: Maybe<CategoryEnum>;
  /** Average check-in rating (stays) */
  checkInAvg?: Maybe<Scalars['Float']['output']>;
  checkoutBrandSite?: Maybe<Scalars['String']['output']>;
  cityMpg?: Maybe<Scalars['Int']['output']>;
  /** Average cleanliness rating */
  cleanlinessAvg?: Maybe<Scalars['Float']['output']>;
  /** Average communication rating */
  communicationAvg?: Maybe<Scalars['Float']['output']>;
  /** Average convenience rating */
  convenienceAvg?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentLocation?: Maybe<Scalars['String']['output']>;
  dailyTripFee?: Maybe<Scalars['Float']['output']>;
  dealer?: Maybe<IDealer>;
  dealerId?: Maybe<Scalars['String']['output']>;
  deliveryLocations?: Maybe<Array<ICarDeliveryLocation>>;
  /** Security deposit amount for this car */
  deposit?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<IDiscount>;
  displayName?: Maybe<Scalars['String']['output']>;
  distanceLimit?: Maybe<IDistanceLimit>;
  distanceMiles: Scalars['Float']['output'];
  doors?: Maybe<Scalars['Int']['output']>;
  features?: Maybe<Array<CarFeatures>>;
  freeCancellationAdvanceHours?: Maybe<Scalars['Int']['output']>;
  gas?: Maybe<GasType>;
  gasGrade?: Maybe<GasGrade>;
  gearType?: Maybe<GearType>;
  /** Special instructions for the guest (pick-up, drop-off, etc.) */
  guestInstructions?: Maybe<Scalars['String']['output']>;
  /** Holiday hourly price (when hourly rental is on) */
  holidayHrPrice?: Maybe<Scalars['Float']['output']>;
  holidayPrice?: Maybe<Scalars['Float']['output']>;
  /** Whether hourly rental is enabled for this car */
  hourlyRentalIsOn?: Maybe<Scalars['Boolean']['output']>;
  hwyMpg?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<IImage>>;
  isCreated: Scalars['Boolean']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Whether guests can decline protection for this car */
  isProtectionDeclinable?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  /** License plate number */
  licensePlate?: Maybe<Scalars['String']['output']>;
  /** License plate state code */
  licensePlateState?: Maybe<Scalars['String']['output']>;
  listedSalePrice?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<ILocation>;
  /** Average location rating (stays) */
  locationAvg?: Maybe<Scalars['Float']['output']>;
  locationId: Scalars['Int']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Average maintenance rating */
  maintenanceAvg?: Maybe<Scalars['Float']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  /** Maximum number of rental days allowed for this car */
  maximumRentalDays?: Maybe<Scalars['Int']['output']>;
  mileage?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of rental days required for this car */
  minimumRentalDays?: Maybe<Scalars['Int']['output']>;
  miscellaneousFees?: Maybe<Array<IMiscellaneousFee>>;
  model?: Maybe<Scalars['String']['output']>;
  /** Fixed total price for the 1-month (30-59 day) monthly tier */
  monthlyPrice?: Maybe<Scalars['Float']['output']>;
  /** Fixed total price for the 2-month (60-89 day) monthly tier */
  monthlyPrice2Months?: Maybe<Scalars['Float']['output']>;
  /** Fixed total price for the 3-month (90+ day) monthly tier */
  monthlyPrice3Months?: Maybe<Scalars['Float']['output']>;
  /** Whether monthly rental pricing and mileage are enabled for this car */
  monthlyRentalIsOn?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** mi or km; null is mi (spec 028). */
  odometerUnit?: Maybe<Scalars['String']['output']>;
  oneWeekPrice?: Maybe<Scalars['Float']['output']>;
  originalPrice?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<IUser>;
  ownerId: Scalars['String']['output'];
  priceCalendar?: Maybe<Array<IPriceCalendar>>;
  productTypeDetails?: Maybe<IProductTypeDetails>;
  productTypeDetailsId?: Maybe<Scalars['String']['output']>;
  recallCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  seats?: Maybe<Scalars['Float']['output']>;
  serviceWorker?: Maybe<IServiceWorker>;
  shiftDays: Scalars['Int']['output'];
  similarEndAt: Scalars['Float']['output'];
  similarStartAt: Scalars['Float']['output'];
  sold?: Maybe<Scalars['Boolean']['output']>;
  soldAt?: Maybe<Scalars['DateTime']['output']>;
  status: CarStatus;
  stayDetails?: Maybe<IStayDetails>;
  threeDaysPrice?: Maybe<Scalars['Float']['output']>;
  threeWeeksPrice?: Maybe<Scalars['Float']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Total number of ratings */
  totalRatings?: Maybe<Scalars['Int']['output']>;
  tripPreferences?: Maybe<ITripPreferences>;
  tripSettings: ICarTripSettings;
  twoWeeksPrice?: Maybe<Scalars['Float']['output']>;
  /** Average value rating (stays) */
  valueAvg?: Maybe<Scalars['Float']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  /** Weekday hourly price (when hourly rental is on) */
  weekdayHrPrice?: Maybe<Scalars['Float']['output']>;
  weekdayPrice?: Maybe<Scalars['Float']['output']>;
  /** Weekend hourly price (when hourly rental is on) */
  weekendHrPrice?: Maybe<Scalars['Float']['output']>;
  weekendPrice?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
}


export interface ISimilarDateCarCheckoutBrandSiteArgs {
  pickupLocationId?: InputMaybe<Scalars['Int']['input']>;
  returnLocationId?: InputMaybe<Scalars['Int']['input']>;
}

export interface ISimilarDateCarsInput {
  driverAge?: InputMaybe<Scalars['Int']['input']>;
  endAt: Scalars['Float']['input'];
  filters?: InputMaybe<ICarSearchFiltersInput>;
  flexDays?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
  siteHost?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['Float']['input'];
  type?: InputMaybe<ProductType>;
}

/** Sort options for car search results */
export enum SortOption {
  Distance = 'DISTANCE',
  PriceHighToLow = 'PRICE_HIGH_TO_LOW',
  PriceLowToHigh = 'PRICE_LOW_TO_HIGH',
  Relevant = 'RELEVANT'
}

export interface IStayAddressInput {
  city: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
}

export enum StayAmenity {
  AirConditioning = 'AIR_CONDITIONING',
  BbqGrill = 'BBQ_GRILL',
  BeachAccess = 'BEACH_ACCESS',
  Breakfast = 'BREAKFAST',
  CarbonMonoxideAlarm = 'CARBON_MONOXIDE_ALARM',
  Crib = 'CRIB',
  DedicatedWorkspace = 'DEDICATED_WORKSPACE',
  Dryer = 'DRYER',
  Essentials = 'ESSENTIALS',
  EvCharger = 'EV_CHARGER',
  FireExtinguisher = 'FIRE_EXTINGUISHER',
  FirstAidKit = 'FIRST_AID_KIT',
  FreeParking = 'FREE_PARKING',
  Gym = 'GYM',
  HairDryer = 'HAIR_DRYER',
  Hangers = 'HANGERS',
  Heating = 'HEATING',
  HighChair = 'HIGH_CHAIR',
  HotTub = 'HOT_TUB',
  Iron = 'IRON',
  Kitchen = 'KITCHEN',
  LakeAccess = 'LAKE_ACCESS',
  PaidParking = 'PAID_PARKING',
  Patio = 'PATIO',
  Pool = 'POOL',
  SkiInOut = 'SKI_IN_OUT',
  SmokeAlarm = 'SMOKE_ALARM',
  Tv = 'TV',
  Washer = 'WASHER',
  Wifi = 'WIFI'
}

export interface IStayBookingIntent {
  __typename?: 'StayBookingIntent';
  booking: IBooking;
  isRequest: Scalars['Boolean']['output'];
  quote: IStayPriceQuote;
}

export interface IStayCalendar {
  __typename?: 'StayCalendar';
  blockedNights: Array<Scalars['String']['output']>;
  checkInFrom: Scalars['String']['output'];
  checkOutBy: Scalars['String']['output'];
  from: Scalars['String']['output'];
  maximumNights?: Maybe<Scalars['Int']['output']>;
  minimumNights: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
  to: Scalars['String']['output'];
}

export enum StayCancellationPolicy {
  Firm = 'FIRM',
  Flexible = 'FLEXIBLE',
  Moderate = 'MODERATE',
  NonRefundable = 'NON_REFUNDABLE',
  Strict = 'STRICT'
}

export interface IStayCancellationPreview {
  __typename?: 'StayCancellationPreview';
  cancelledBy: Scalars['String']['output'];
  cleaningFeeRefund: Scalars['Float']['output'];
  fullRefund: Scalars['Boolean']['output'];
  guestServiceFeeRefund: Scalars['Float']['output'];
  hostPenalty?: Maybe<Scalars['Float']['output']>;
  lodgingRefund: Scalars['Float']['output'];
  nonRefundableAmount: Scalars['Float']['output'];
  nonRefundableNights: Scalars['Int']['output'];
  occupancyTaxRefund: Scalars['Float']['output'];
  petFeeRefund: Scalars['Float']['output'];
  policy?: Maybe<StayCancellationPolicy>;
  refundAmount: Scalars['Float']['output'];
  rule: StayRefundRule;
  status: BookingStatus;
  totalPaid: Scalars['Float']['output'];
}

export enum StayCategory {
  AmazingViews = 'AMAZING_VIEWS',
  Beachfront = 'BEACHFRONT',
  Cabins = 'CABINS',
  Camping = 'CAMPING',
  City = 'CITY',
  Countryside = 'COUNTRYSIDE',
  Design = 'DESIGN',
  Farms = 'FARMS',
  Islands = 'ISLANDS',
  Lakefront = 'LAKEFRONT',
  Luxe = 'LUXE',
  Skiing = 'SKIING',
  TinyHomes = 'TINY_HOMES',
  Treehouses = 'TREEHOUSES',
  Trending = 'TRENDING'
}

export enum StayCheckInMethod {
  BuildingStaff = 'BUILDING_STAFF',
  HostGreets = 'HOST_GREETS',
  Keypad = 'KEYPAD',
  Lockbox = 'LOCKBOX',
  SmartLock = 'SMART_LOCK'
}

export interface IStayDetails {
  __typename?: 'StayDetails';
  accessibilityFeatures: Array<Scalars['String']['output']>;
  amenities: Array<StayAmenity>;
  bathrooms: Scalars['Float']['output'];
  bedrooms: Scalars['Int']['output'];
  beds: Scalars['Int']['output'];
  cancellationPolicy: StayCancellationPolicy;
  carId: Scalars['ID']['output'];
  checkInFrom: Scalars['String']['output'];
  checkInMethod?: Maybe<StayCheckInMethod>;
  checkInUntil?: Maybe<Scalars['String']['output']>;
  checkOutBy: Scalars['String']['output'];
  cleaningFee: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  descriptionGuestAccess?: Maybe<Scalars['String']['output']>;
  descriptionNeighborhood?: Maybe<Scalars['String']['output']>;
  descriptionOtherNotes?: Maybe<Scalars['String']['output']>;
  descriptionSpace?: Maybe<Scalars['String']['output']>;
  extraGuestAfter?: Maybe<Scalars['Int']['output']>;
  extraGuestFee: Scalars['Float']['output'];
  houseRules: IStayHouseRules;
  instantBook: Scalars['Boolean']['output'];
  listingStatus: StayListingStatus;
  maxGuests: Scalars['Int']['output'];
  petFee: Scalars['Float']['output'];
  preparationDays: Scalars['Int']['output'];
  propertyType: StayPropertyType;
  requireVerifiedId: Scalars['Boolean']['output'];
  roomType: StayRoomType;
  selfCheckIn: Scalars['Boolean']['output'];
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  stayCategories: Array<StayCategory>;
  updatedAt: Scalars['DateTime']['output'];
  wizardStep?: Maybe<Scalars['String']['output']>;
}

export interface IStayGuestRatingData {
  __typename?: 'StayGuestRatingData';
  accuracy: Scalars['Int']['output'];
  checkIn: Scalars['Int']['output'];
  cleanliness: Scalars['Int']['output'];
  communication: Scalars['Int']['output'];
  location: Scalars['Int']['output'];
  overall: Scalars['Int']['output'];
  publicReview?: Maybe<Scalars['String']['output']>;
  value: Scalars['Int']['output'];
}

export interface IStayGuestRatingInput {
  accuracy: Scalars['Int']['input'];
  checkIn: Scalars['Int']['input'];
  cleanliness: Scalars['Int']['input'];
  communication: Scalars['Int']['input'];
  location: Scalars['Int']['input'];
  overall: Scalars['Int']['input'];
  privateNote?: InputMaybe<Scalars['String']['input']>;
  publicReview?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Int']['input'];
}

export interface IStayHostRatingData {
  __typename?: 'StayHostRatingData';
  cleanliness: Scalars['Int']['output'];
  communication: Scalars['Int']['output'];
  houseRules: Scalars['Int']['output'];
  overall: Scalars['Int']['output'];
  publicReview?: Maybe<Scalars['String']['output']>;
  wouldHostAgain: Scalars['Boolean']['output'];
}

export interface IStayHostRatingInput {
  cleanliness: Scalars['Int']['input'];
  communication: Scalars['Int']['input'];
  houseRules: Scalars['Int']['input'];
  overall: Scalars['Int']['input'];
  privateNote?: InputMaybe<Scalars['String']['input']>;
  publicReview?: InputMaybe<Scalars['String']['input']>;
  wouldHostAgain: Scalars['Boolean']['input'];
}

export interface IStayHouseRules {
  __typename?: 'StayHouseRules';
  additionalRules?: Maybe<Scalars['String']['output']>;
  childrenAllowed: Scalars['Boolean']['output'];
  eventsAllowed: Scalars['Boolean']['output'];
  infantsAllowed: Scalars['Boolean']['output'];
  maxPets?: Maybe<Scalars['Int']['output']>;
  petsAllowed: Scalars['Boolean']['output'];
  quietHoursFrom?: Maybe<Scalars['String']['output']>;
  quietHoursTo?: Maybe<Scalars['String']['output']>;
  smokingAllowed: Scalars['Boolean']['output'];
}

export interface IStayHouseRulesInput {
  additionalRules?: InputMaybe<Scalars['String']['input']>;
  childrenAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  eventsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  infantsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  maxPets?: InputMaybe<Scalars['Int']['input']>;
  petsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  quietHoursFrom?: InputMaybe<Scalars['String']['input']>;
  quietHoursTo?: InputMaybe<Scalars['String']['input']>;
  smokingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface IStayInstructions {
  __typename?: 'StayInstructions';
  address: Scalars['String']['output'];
  checkInFrom: Scalars['String']['output'];
  checkInInstructions?: Maybe<Scalars['String']['output']>;
  checkInMethod?: Maybe<StayCheckInMethod>;
  checkInUntil?: Maybe<Scalars['String']['output']>;
  checkOutBy: Scalars['String']['output'];
  selfCheckIn: Scalars['Boolean']['output'];
  wifiName?: Maybe<Scalars['String']['output']>;
  wifiPassword?: Maybe<Scalars['String']['output']>;
}

export enum StayListingStatus {
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  Listed = 'LISTED',
  Snoozed = 'SNOOZED',
  Unlisted = 'UNLISTED'
}

export interface IStayModificationQuote {
  __typename?: 'StayModificationQuote';
  chargeAmount: Scalars['Float']['output'];
  checkIn: Scalars['String']['output'];
  checkOut: Scalars['String']['output'];
  difference: Scalars['Float']['output'];
  keptAmount: Scalars['Float']['output'];
  newTotal: Scalars['Float']['output'];
  oldTotal: Scalars['Float']['output'];
  quote: IStayPriceQuote;
  refundAmount: Scalars['Float']['output'];
}

export interface IStayModificationResult {
  __typename?: 'StayModificationResult';
  booking?: Maybe<IBooking>;
  chargeAmount: Scalars['Float']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  refundAmount: Scalars['Float']['output'];
  status: StayModificationStatus;
}

export enum StayModificationStatus {
  Failed = 'FAILED',
  RequiresAction = 'REQUIRES_ACTION',
  Succeeded = 'SUCCEEDED'
}

export interface IStayPriceQuote {
  __typename?: 'StayPriceQuote';
  cleaningFee: Scalars['Float']['output'];
  extraGuestFee: Scalars['Float']['output'];
  guestServiceFee: Scalars['Float']['output'];
  guestServiceFeeRate: Scalars['Float']['output'];
  monthlyDiscountAmount: Scalars['Float']['output'];
  nightlySubtotal: Scalars['Float']['output'];
  nights: Scalars['Int']['output'];
  occupancyTax: Scalars['Float']['output'];
  petFee: Scalars['Float']['output'];
  pricePerNight: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  weeklyDiscountAmount: Scalars['Float']['output'];
}

export interface IStayPrivateDetails {
  __typename?: 'StayPrivateDetails';
  checkInInstructions?: Maybe<Scalars['String']['output']>;
  wifiName?: Maybe<Scalars['String']['output']>;
  wifiPassword?: Maybe<Scalars['String']['output']>;
}

export enum StayPropertyType {
  Apartment = 'APARTMENT',
  Cabin = 'CABIN',
  Condo = 'CONDO',
  Guesthouse = 'GUESTHOUSE',
  Hotel = 'HOTEL',
  House = 'HOUSE',
  Other = 'OTHER',
  TinyHome = 'TINY_HOME',
  Townhouse = 'TOWNHOUSE',
  Villa = 'VILLA'
}

export interface IStayPublishProblem {
  __typename?: 'StayPublishProblem';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

export interface IStayQuoteInput {
  checkIn: Scalars['String']['input'];
  checkOut: Scalars['String']['input'];
  guests?: InputMaybe<IGuestCountsInput>;
}

export enum StayRefundRule {
  FullRefund = 'FULL_REFUND',
  GracePeriod = 'GRACE_PERIOD',
  HalfRefund = 'HALF_REFUND',
  HostCancelled = 'HOST_CANCELLED',
  NightsKept = 'NIGHTS_KEPT',
  NoRefund = 'NO_REFUND',
  StayOver = 'STAY_OVER'
}

export interface IStayReviewSummary {
  __typename?: 'StayReviewSummary';
  accuracyAvg?: Maybe<Scalars['Float']['output']>;
  averageRating: Scalars['Float']['output'];
  checkInAvg?: Maybe<Scalars['Float']['output']>;
  cleanlinessAvg?: Maybe<Scalars['Float']['output']>;
  communicationAvg?: Maybe<Scalars['Float']['output']>;
  locationAvg?: Maybe<Scalars['Float']['output']>;
  totalRatings: Scalars['Int']['output'];
  valueAvg?: Maybe<Scalars['Float']['output']>;
}

export enum StayRoomType {
  EntirePlace = 'ENTIRE_PLACE',
  PrivateRoom = 'PRIVATE_ROOM',
  SharedRoom = 'SHARED_ROOM'
}

export interface IStaySearchFiltersInput {
  amenities?: InputMaybe<Array<StayAmenity>>;
  category?: InputMaybe<StayCategory>;
  freeCancellation?: InputMaybe<Scalars['Boolean']['input']>;
  instantBook?: InputMaybe<Scalars['Boolean']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minBathrooms?: InputMaybe<Scalars['Float']['input']>;
  minBedrooms?: InputMaybe<Scalars['Int']['input']>;
  minBeds?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  propertyTypes?: InputMaybe<Array<StayPropertyType>>;
  roomTypes?: InputMaybe<Array<StayRoomType>>;
  selfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface IStaySearchResult {
  __typename?: 'StaySearchResult';
  distanceMiles?: Maybe<Scalars['Float']['output']>;
  listing: ICar;
  quote?: Maybe<IStayPriceQuote>;
}

export interface IStayServiceFeeRates {
  __typename?: 'StayServiceFeeRates';
  guestServiceFeeRate: Scalars['Float']['output'];
  hostServiceFeeRate: Scalars['Float']['output'];
}

export enum StaySortOption {
  PriceHighToLow = 'PRICE_HIGH_TO_LOW',
  PriceLowToHigh = 'PRICE_LOW_TO_HIGH',
  Rating = 'RATING',
  Recommended = 'RECOMMENDED'
}

export interface IStripePaymentMethod {
  __typename?: 'StripePaymentMethod';
  card?: Maybe<ICardType>;
  id: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
}

export interface ISubmitDlVerificationInput {
  bookingId: Scalars['ID']['input'];
  dlPhotoKey: Scalars['String']['input'];
  selfiePhotoKey: Scalars['String']['input'];
}

export interface ISubmitGeneralDlVerificationInput {
  backDriverLicenseUrl: Scalars['String']['input'];
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  frontDriverLicenseUrl: Scalars['String']['input'];
  legalFirstName?: InputMaybe<Scalars['String']['input']>;
  legalLastName?: InputMaybe<Scalars['String']['input']>;
  legalMiddleName?: InputMaybe<Scalars['String']['input']>;
}

export interface ISubmitGuestRatingInput {
  bookingId: Scalars['String']['input'];
  rating: IGuestRatingInput;
}

export interface ISubmitHostRatingInput {
  bookingId: Scalars['String']['input'];
  rating: IHostRatingInput;
}

export interface ISubmitHostReplyInput {
  bookingId: Scalars['String']['input'];
  reply: Scalars['String']['input'];
}

export interface ISubmitStayGuestRatingInput {
  bookingId: Scalars['String']['input'];
  rating: IStayGuestRatingInput;
}

export interface ISubmitStayHostRatingInput {
  bookingId: Scalars['String']['input'];
  rating: IStayHostRatingInput;
}

export interface ISuppliesProvided {
  __typename?: 'SuppliesProvided';
  cleaningProducts: Scalars['Boolean']['output'];
  guestConsumables: Scalars['Boolean']['output'];
  linens: Scalars['Boolean']['output'];
  tools: Scalars['Boolean']['output'];
  vacuum: Scalars['Boolean']['output'];
}

export interface ISuppliesProvidedInput {
  cleaningProducts: Scalars['Boolean']['input'];
  guestConsumables: Scalars['Boolean']['input'];
  linens: Scalars['Boolean']['input'];
  tools: Scalars['Boolean']['input'];
  vacuum: Scalars['Boolean']['input'];
}

export enum TimeGranularity {
  Day = 'DAY',
  HalfHour = 'HALF_HOUR'
}

export interface ITimezoneInfo {
  __typename?: 'TimezoneInfo';
  currentLocalTimeISO: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
}

export interface ITotalDownPayment {
  __typename?: 'TotalDownPayment';
  cashEquivalent?: Maybe<Scalars['Float']['output']>;
  deferredDownPayableToSeller?: Maybe<Scalars['Float']['output']>;
  manufactureRebate?: Maybe<Scalars['Float']['output']>;
  others?: Maybe<Array<IOtherWithDescription>>;
  totalDownPayment?: Maybe<Scalars['Float']['output']>;
  totalLessPriorCreditOrLeaseBalance?: Maybe<Scalars['Float']['output']>;
  totalNetTradeInBal?: Maybe<Scalars['Float']['output']>;
  totalTradeInVal?: Maybe<Scalars['Float']['output']>;
  vehicleOneBal?: Maybe<Scalars['Float']['output']>;
  vehicleOneCredit?: Maybe<Scalars['Float']['output']>;
  vehicleOneVal?: Maybe<Scalars['Float']['output']>;
  vehicleTwoBal?: Maybe<Scalars['Float']['output']>;
  vehicleTwoCredit?: Maybe<Scalars['Float']['output']>;
  vehicleTwoVal?: Maybe<Scalars['Float']['output']>;
}

export interface ITotalDownPaymentInput {
  cashEquivalent?: InputMaybe<Scalars['Float']['input']>;
  deferredDownPayableToSeller?: InputMaybe<Scalars['Float']['input']>;
  manufactureRebate?: InputMaybe<Scalars['Float']['input']>;
  others?: InputMaybe<Array<IOtherWithDescriptionInput>>;
  totalDownPayment?: InputMaybe<Scalars['Float']['input']>;
  totalLessPriorCreditOrLeaseBalance?: InputMaybe<Scalars['Float']['input']>;
  totalNetTradeInBal?: InputMaybe<Scalars['Float']['input']>;
  totalTradeInVal?: InputMaybe<Scalars['Float']['input']>;
  vehicleOneBal?: InputMaybe<Scalars['Float']['input']>;
  vehicleOneCredit?: InputMaybe<Scalars['Float']['input']>;
  vehicleOneVal?: InputMaybe<Scalars['Float']['input']>;
  vehicleTwoBal?: InputMaybe<Scalars['Float']['input']>;
  vehicleTwoCredit?: InputMaybe<Scalars['Float']['input']>;
  vehicleTwoVal?: InputMaybe<Scalars['Float']['input']>;
}

export interface ITradeInVehicle {
  __typename?: 'TradeInVehicle';
  agreedVal: Scalars['Float']['output'];
  agreedValMinorsbuyerRetain: Scalars['Float']['output'];
  buyerRetainedEquity: Scalars['Float']['output'];
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  netTradeIn: Scalars['Float']['output'];
  odo: Scalars['String']['output'];
  priorCreditOrLeaseBal: Scalars['Float']['output'];
  vin: Scalars['String']['output'];
  year: Scalars['String']['output'];
}

export interface ITradeInVehicleInput {
  agreedVal: Scalars['Float']['input'];
  agreedValMinorsbuyerRetain: Scalars['Float']['input'];
  buyerRetainedEquity: Scalars['Float']['input'];
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
  netTradeIn: Scalars['Float']['input'];
  odo: Scalars['String']['input'];
  priorCreditOrLeaseBal: Scalars['Float']['input'];
  vin: Scalars['String']['input'];
  year: Scalars['String']['input'];
}

export interface ITripExtensionPaymentResult {
  __typename?: 'TripExtensionPaymentResult';
  amount: Scalars['Float']['output'];
  attemptId?: Maybe<Scalars['ID']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  declineCode?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  extensionBlocked: Scalars['Boolean']['output'];
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  status: PaymentAttemptStatus;
}

export interface ITripExtensionResponse {
  __typename?: 'TripExtensionResponse';
  booking: IBooking;
  freeCancellationServiceFee?: Maybe<Scalars['Float']['output']>;
  priceDifference: Scalars['Float']['output'];
  shortenTripPenalty?: Maybe<Scalars['Float']['output']>;
  totalPrice: Scalars['Float']['output'];
}

export interface ITripFee {
  __typename?: 'TripFee';
  amount?: Maybe<Scalars['Float']['output']>;
  chargeBy?: Maybe<TripFeeTypeEnums>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rule?: Maybe<TripFeeRuleEnums>;
  uniqName: TripFeeUniqNameEnums;
  updatedAt: Scalars['DateTime']['output'];
  user: IUser;
  userId: Scalars['String']['output'];
}

export enum TripFeeRuleEnums {
  AdvanceRules = 'ADVANCE_RULES',
  Charge = 'CHARGE',
  Refund = 'REFUND'
}

export enum TripFeeTypeEnums {
  DailyRate = 'DAILY_RATE',
  OneTime = 'ONE_TIME',
  Percentage = 'PERCENTAGE'
}

export enum TripFeeUniqNameEnums {
  CancellationMaxPenalty = 'CANCELLATION_MAX_PENALTY',
  FreeCancellationAdvance = 'FREE_CANCELLATION_ADVANCE',
  FreeCancellationGracePeriod = 'FREE_CANCELLATION_GRACE_PERIOD',
  FreeCancellationServiceFee = 'FREE_CANCELLATION_SERVICE_FEE',
  MonthlyTripfee = 'MONTHLY_TRIPFEE',
  MonthlyYoungsterfee18 = 'MONTHLY_YOUNGSTERFEE18',
  MonthlyYoungsterfee21 = 'MONTHLY_YOUNGSTERFEE21',
  ShortenBookingMaxPenalty = 'SHORTEN_BOOKING_MAX_PENALTY',
  Tripfee = 'TRIPFEE',
  Youngsterfee18 = 'YOUNGSTERFEE18',
  Youngsterfee21 = 'YOUNGSTERFEE21'
}

export interface ITripPreferences {
  __typename?: 'TripPreferences';
  advanceNoticeHours: Scalars['Int']['output'];
  longestTripDays: Scalars['Int']['output'];
  shortestTripDays: Scalars['Int']['output'];
  tripBufferHours: Scalars['Int']['output'];
}

export interface ITripPreferencesInput {
  advanceNoticeHours?: Scalars['Int']['input'];
  longestTripDays?: Scalars['Int']['input'];
  shortestTripDays?: Scalars['Int']['input'];
  tripBufferHours?: Scalars['Int']['input'];
}

export interface ITripRating {
  __typename?: 'TripRating';
  booking: IBooking;
  bookingId: Scalars['String']['output'];
  car: ICar;
  carId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  guest: IUser;
  guestId: Scalars['String']['output'];
  guestRatedAt?: Maybe<Scalars['DateTime']['output']>;
  guestRating?: Maybe<IGuestRatingData>;
  host: IUser;
  hostId: Scalars['String']['output'];
  hostRatedAt?: Maybe<Scalars['DateTime']['output']>;
  hostRating?: Maybe<IHostRatingData>;
  hostRepliedAt?: Maybe<Scalars['DateTime']['output']>;
  hostReply?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether guest rating is valid and counted in averages */
  isGuestRatingValid: Scalars['Boolean']['output'];
  /** Whether host rating is valid and counted in averages */
  isHostRatingValid: Scalars['Boolean']['output'];
  serviceCustomerRating?: Maybe<IServiceCustomerRatingData>;
  serviceWorkerRating?: Maybe<IServiceWorkerRatingData>;
  stayGuestRating?: Maybe<IStayGuestRatingData>;
  stayHostRating?: Maybe<IStayHostRatingData>;
  updatedAt: Scalars['DateTime']['output'];
}

export interface ITripRatingReview {
  __typename?: 'TripRatingReview';
  carName?: Maybe<Scalars['String']['output']>;
  guestAvatarUrl?: Maybe<Scalars['String']['output']>;
  guestName: Scalars['String']['output'];
  rating: ITripRating;
  tripDate: Scalars['DateTime']['output'];
}

export interface IUnlistedCarRow {
  __typename?: 'UnlistedCarRow';
  car: ICar;
  futureTripCount: Scalars['Int']['output'];
  hold: IListingHold;
  hostEmail?: Maybe<Scalars['String']['output']>;
  hostName?: Maybe<Scalars['String']['output']>;
  /** SOLD or ADMIN hold with future trips not yet swapped or cancelled */
  needsAction: Scalars['Boolean']['output'];
}

export interface IUnlistedCarsFilter {
  limit?: InputMaybe<Scalars['Int']['input']>;
  needsActionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<ListingHoldReason>;
  /** VIN, make, model or host email */
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface IUnlistedCarsPage {
  __typename?: 'UnlistedCarsPage';
  items: Array<IUnlistedCarRow>;
  total: Scalars['Int']['output'];
}

export interface IUnreadCountsResponse {
  __typename?: 'UnreadCountsResponse';
  notificationsCount: Scalars['Int']['output'];
}

export interface IUpdateActualReturnDateTimeInput {
  actualReturnAt: Scalars['DateTime']['input'];
  bookingId: Scalars['ID']['input'];
}

export interface IUpdateAirportInput {
  address?: InputMaybe<Scalars['String']['input']>;
  /** Three-letter airport code, unique. */
  airportCode?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}

export interface IUpdateBookingInput {
  bookingId: Scalars['String']['input'];
  defaultPaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  endAt: Scalars['Float']['input'];
  paymentConfig?: InputMaybe<IPaymentConfigInput>;
  protectionPlanId?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['Float']['input'];
}

export interface IUpdateBookingMinimumRentalDaysInput {
  bookingId: Scalars['String']['input'];
  newMinimumRentalDays: Scalars['Int']['input'];
}

export interface IUpdateBookingProtectionPlanInput {
  bookingId: Scalars['String']['input'];
  protectionPlan?: InputMaybe<ProtectionPlanEnum>;
  protectionPlanId?: InputMaybe<Scalars['String']['input']>;
}

export interface IUpdateBookingResponse {
  __typename?: 'UpdateBookingResponse';
  booking: IBooking;
  priceDifference: Scalars['Float']['output'];
  protectionPlan?: Maybe<IProtectionPlan>;
}

export interface IUpdateBrandAliasesInput {
  aliases: Array<Scalars['String']['input']>;
  brandSite: Scalars['String']['input'];
}

export interface IUpdateBrandProductTypesInput {
  /** Empty keeps the pre-spec-016 rule: every type except house. */
  allowedProductTypes?: InputMaybe<Array<ProductType>>;
  brandSite: Scalars['String']['input'];
  defaultProductType?: InputMaybe<ProductType>;
}

export interface IUpdateBrandRulesInput {
  bookingRules?: InputMaybe<Scalars['JSON']['input']>;
  hostCapabilities?: InputMaybe<IHostCapabilitiesInput>;
  version: Scalars['Int']['input'];
}

export interface IUpdateBrandSettingsInput {
  banAllOtherBrands?: InputMaybe<Scalars['Boolean']['input']>;
  banBrandSites?: InputMaybe<Array<Scalars['String']['input']>>;
  banMyselfOnOthers?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  exclusiveMarkets?: InputMaybe<Array<IExclusiveMarketInput>>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  hideFromAllOtherBrands?: InputMaybe<Scalars['Boolean']['input']>;
  homeBannerImageKey?: InputMaybe<Scalars['String']['input']>;
  homePage?: InputMaybe<IBrandHomePageInput>;
  /** Referral percent this brand pays as the checkout brand. Null uses the platform default. */
  referralCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  showOtherSites?: InputMaybe<Scalars['Boolean']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
}

export interface IUpdateBrandStripeSecretsInput {
  brandSite: Scalars['String']['input'];
  stripePublishableKey?: InputMaybe<Scalars['String']['input']>;
  stripeSecretKey?: InputMaybe<Scalars['String']['input']>;
  stripeWebhookSecret?: InputMaybe<Scalars['String']['input']>;
}

export interface IUpdateBroadcastInput {
  audience?: InputMaybe<BroadcastAudience>;
  content?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface IUpdateCarInput {
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<CategoryEnum>;
  cityMpg?: InputMaybe<Scalars['Int']['input']>;
  currentLocation?: InputMaybe<Scalars['String']['input']>;
  dailyPrice?: InputMaybe<Scalars['Float']['input']>;
  deposit?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<IDiscountInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  distanceLimit?: InputMaybe<IDistanceLimitInput>;
  doors?: InputMaybe<Scalars['Int']['input']>;
  features?: InputMaybe<Array<CarFeatures>>;
  gas?: InputMaybe<GasType>;
  gasGrade?: InputMaybe<GasGrade>;
  gearType?: InputMaybe<GearType>;
  guestInstructions?: InputMaybe<Scalars['String']['input']>;
  holidayHrPrice?: InputMaybe<Scalars['Float']['input']>;
  holidayPrice?: InputMaybe<Scalars['Float']['input']>;
  hourlyPriceCalendar?: InputMaybe<Array<IPriceCalendarInput>>;
  hourlyRentalIsOn?: InputMaybe<Scalars['Boolean']['input']>;
  hwyMpg?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Array<IImageInput>>;
  isCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isProtectionDeclinable?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  licensePlateState?: InputMaybe<Scalars['String']['input']>;
  listedSalePrice?: InputMaybe<Scalars['Float']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  maximumRentalDays?: InputMaybe<Scalars['Int']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  minimumRentalDays?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  monthlyPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Fixed total price for the 2-month monthly tier */
  monthlyPrice2Months?: InputMaybe<Scalars['Float']['input']>;
  /** Fixed total price for the 3-month monthly tier */
  monthlyPrice3Months?: InputMaybe<Scalars['Float']['input']>;
  monthlyRentalIsOn?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalPrice?: InputMaybe<Scalars['Float']['input']>;
  priceCalendar?: InputMaybe<Array<IPriceCalendarInput>>;
  productTypeDetailsId?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<Scalars['Float']['input']>;
  sold?: InputMaybe<Scalars['Boolean']['input']>;
  soldAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CarStatus>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  tripPreferences?: InputMaybe<ITripPreferencesInput>;
  vin?: InputMaybe<Scalars['String']['input']>;
  weekdayHrPrice?: InputMaybe<Scalars['Float']['input']>;
  weekdayPrice?: InputMaybe<Scalars['Float']['input']>;
  weekendHrPrice?: InputMaybe<Scalars['Float']['input']>;
  weekendPrice?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
}

export interface IUpdateCarMakeAndModelInput {
  id: Scalars['ID']['input'];
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
}

export interface IUpdateCarSaleInput {
  buyer?: InputMaybe<Array<IBuyerInfoInput>>;
  cancellationPlan?: InputMaybe<CarSalesCancellationEnum>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  carId?: InputMaybe<Scalars['String']['input']>;
  docPrepFee?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  odometerReading?: InputMaybe<Scalars['String']['input']>;
  paymentDetails?: InputMaybe<IPaymentDetailsInput>;
  paymentSchedule?: InputMaybe<IPaymentScheduleInput>;
  publicFees?: InputMaybe<IPublicFeesInput>;
  recordOfSaleNumber?: InputMaybe<Scalars['String']['input']>;
  salesTaxRate?: InputMaybe<Scalars['Float']['input']>;
  smogFee?: InputMaybe<Scalars['Float']['input']>;
  soldPrice?: InputMaybe<Scalars['Float']['input']>;
  tradeInVehicles?: InputMaybe<Array<ITradeInVehicleInput>>;
}

export interface IUpdateCouponInput {
  applyByDateOrTrip?: InputMaybe<ApplyByDateOrTripEnum>;
  applyToCategory?: InputMaybe<CategoryEnum>;
  applyToGuestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  applyToPriceOf?: InputMaybe<ApplyToPriceOfEnum>;
  applyToProductType?: InputMaybe<ProductType>;
  applyToRentalType?: InputMaybe<RentalTypeEnum>;
  category?: InputMaybe<CouponCategoryEnum>;
  code?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['Float']['input']>;
  fixAmountValue?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minDays?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentageValue?: InputMaybe<Scalars['Float']['input']>;
  priceAlgorithm?: InputMaybe<PriceAlgorithmEnum>;
  startAt?: InputMaybe<Scalars['Float']['input']>;
}

export interface IUpdateDamageClaimStatusInput {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  approvedAmount?: InputMaybe<Scalars['Float']['input']>;
  claimId: Scalars['String']['input'];
  guestShouldPay?: InputMaybe<Scalars['Float']['input']>;
  hostClaimAmount?: InputMaybe<Scalars['Float']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status: DamageClaimStatus;
}

export interface IUpdateDealerInput {
  certificateExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  certificateNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  introduction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}

export interface IUpdateGuestRatingValidityInput {
  isValid: Scalars['Boolean']['input'];
  ratingId: Scalars['String']['input'];
}

export interface IUpdateHostRatingValidityInput {
  isValid: Scalars['Boolean']['input'];
  ratingId: Scalars['String']['input'];
}

export interface IUpdateHotLocationInput {
  amount?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
}

export interface IUpdateImagesInput {
  imageUrls: Array<Scalars['String']['input']>;
}

export interface IUpdateInvoiceInput {
  amount?: InputMaybe<Scalars['Float']['input']>;
  balance?: InputMaybe<Scalars['Float']['input']>;
  damageClaimId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  evidencePhotoS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
  hostApprovedRefund?: InputMaybe<Scalars['Boolean']['input']>;
  hostDescription?: InputMaybe<Scalars['String']['input']>;
  hostId?: InputMaybe<Scalars['ID']['input']>;
  hostRefundReviewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  invoiceSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paidAt?: InputMaybe<Scalars['DateTime']['input']>;
  receiptId?: InputMaybe<Scalars['String']['input']>;
  refundAmount?: InputMaybe<Scalars['Float']['input']>;
  refundCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  refundInitiatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  refundStatus?: InputMaybe<RefundStatus>;
  requesterId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<PaymentStatus>;
  stripeInvoiceId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  stripeRefundId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InvoiceType>;
}

export interface IUpdateLocationInput {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}

export interface IUpdateMiscellaneousFeeInput {
  amount?: Scalars['Float']['input'];
  carId: Scalars['String']['input'];
  chargeBy: ChargeType;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
}

export interface IUpdateOperatingHoursInput {
  PickupLocationType?: InputMaybe<PickupLocationType>;
  alwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  fridayAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  fridayAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  fridayEnd?: InputMaybe<Scalars['String']['input']>;
  fridayStart?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  mondayAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  mondayAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  mondayEnd?: InputMaybe<Scalars['String']['input']>;
  mondayStart?: InputMaybe<Scalars['String']['input']>;
  saturdayAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  saturdayAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  saturdayEnd?: InputMaybe<Scalars['String']['input']>;
  saturdayStart?: InputMaybe<Scalars['String']['input']>;
  sundayAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  sundayAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  sundayEnd?: InputMaybe<Scalars['String']['input']>;
  sundayStart?: InputMaybe<Scalars['String']['input']>;
  thursdayAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  thursdayAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  thursdayEnd?: InputMaybe<Scalars['String']['input']>;
  thursdayStart?: InputMaybe<Scalars['String']['input']>;
  tuesdayAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  tuesdayAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  tuesdayEnd?: InputMaybe<Scalars['String']['input']>;
  tuesdayStart?: InputMaybe<Scalars['String']['input']>;
  wednesdayAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  wednesdayAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  wednesdayEnd?: InputMaybe<Scalars['String']['input']>;
  wednesdayStart?: InputMaybe<Scalars['String']['input']>;
}

export interface IUpdatePlatformReferralRatesInput {
  defaultReferralCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  minimumReferralCommissionRate?: InputMaybe<Scalars['Float']['input']>;
}

export interface IUpdatePlatformSiteMarkersInput {
  hosts: Array<Scalars['String']['input']>;
}

export interface IUpdateProductTypeDetailsInput {
  cancellationPolicyMode?: InputMaybe<CancellationPolicyMode>;
  hasAdditionalDrivers?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckInInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckinInspection?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckoutInspection?: InputMaybe<Scalars['Boolean']['input']>;
  hasCleaningFee?: InputMaybe<Scalars['Boolean']['input']>;
  hasDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  hasGuestCounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasHourlyRental?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  hasLastMinuteSurcharge?: InputMaybe<Scalars['Boolean']['input']>;
  hasMileageBilling?: InputMaybe<Scalars['Boolean']['input']>;
  hasMonthlyTiers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOperatingHours?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecurityDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  hasSwap?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripFee?: InputMaybe<Scalars['Boolean']['input']>;
  hasYoungsterFee?: InputMaybe<Scalars['Boolean']['input']>;
  isOn?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriverLicense?: InputMaybe<Scalars['Boolean']['input']>;
  reviewCategorySet?: InputMaybe<ReviewCategorySet>;
  saleAs?: InputMaybe<SaleAs>;
  supportsInstantBook?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRequestToBook?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  timeGranularity?: InputMaybe<TimeGranularity>;
}

export interface IUpdateProtectionPlanInput {
  dailyPrice?: InputMaybe<Scalars['Float']['input']>;
  declinedProtectionOutOfPocketAmt?: InputMaybe<DeclinedProtectionOutOfPocketAmt>;
  declinedProtectionOutOfPocketPercent?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDailyProtectionPlanDeclinable?: InputMaybe<Scalars['Boolean']['input']>;
  isMonthlyProtectionPlanDeclinable?: InputMaybe<Scalars['Boolean']['input']>;
  outOfPocket?: InputMaybe<Scalars['Float']['input']>;
  plan: ProtectionPlanEnum;
  policyDetails?: InputMaybe<Scalars['String']['input']>;
}

export interface IUpdateReferralSettingsInput {
  crossListingNearbyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenReferralHostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  myWebUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  referralCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  shouldNotRedirectList?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface IUpdateServiceFeeRatesInput {
  customerFeeRate?: InputMaybe<Scalars['Float']['input']>;
  providerFeeRate?: InputMaybe<Scalars['Float']['input']>;
  waiverDays?: InputMaybe<Scalars['Int']['input']>;
}

export interface IUpdateStayInput {
  accessibilityFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<IStayAddressInput>;
  advanceNoticeHours?: InputMaybe<Scalars['Int']['input']>;
  amenities?: InputMaybe<Array<StayAmenity>>;
  bathrooms?: InputMaybe<Scalars['Float']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  beds?: InputMaybe<Scalars['Int']['input']>;
  cancellationPolicy?: InputMaybe<StayCancellationPolicy>;
  checkInFrom?: InputMaybe<Scalars['String']['input']>;
  checkInInstructions?: InputMaybe<Scalars['String']['input']>;
  checkInMethod?: InputMaybe<StayCheckInMethod>;
  checkInUntil?: InputMaybe<Scalars['String']['input']>;
  checkOutBy?: InputMaybe<Scalars['String']['input']>;
  cleaningFee?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionGuestAccess?: InputMaybe<Scalars['String']['input']>;
  descriptionNeighborhood?: InputMaybe<Scalars['String']['input']>;
  descriptionOtherNotes?: InputMaybe<Scalars['String']['input']>;
  descriptionSpace?: InputMaybe<Scalars['String']['input']>;
  extraGuestAfter?: InputMaybe<Scalars['Int']['input']>;
  extraGuestFee?: InputMaybe<Scalars['Float']['input']>;
  holidayPrice?: InputMaybe<Scalars['Float']['input']>;
  houseRules?: InputMaybe<IStayHouseRulesInput>;
  instantBook?: InputMaybe<Scalars['Boolean']['input']>;
  maxGuests?: InputMaybe<Scalars['Int']['input']>;
  maximumNights?: InputMaybe<Scalars['Int']['input']>;
  minimumNights?: InputMaybe<Scalars['Int']['input']>;
  monthlyDiscountPercent?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonRefundableDiscountPercent?: InputMaybe<Scalars['Float']['input']>;
  petFee?: InputMaybe<Scalars['Float']['input']>;
  preparationDays?: InputMaybe<Scalars['Int']['input']>;
  propertyType?: InputMaybe<StayPropertyType>;
  requireVerifiedId?: InputMaybe<Scalars['Boolean']['input']>;
  roomType?: InputMaybe<StayRoomType>;
  selfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  stayCategories?: InputMaybe<Array<StayCategory>>;
  weekdayPrice?: InputMaybe<Scalars['Float']['input']>;
  weekendPrice?: InputMaybe<Scalars['Float']['input']>;
  weeklyDiscountPercent?: InputMaybe<Scalars['Float']['input']>;
  wifiName?: InputMaybe<Scalars['String']['input']>;
  wifiPassword?: InputMaybe<Scalars['String']['input']>;
  wizardStep?: InputMaybe<Scalars['String']['input']>;
}

export interface IUpdateStayServiceFeeRatesInput {
  stayGuestServiceFeeRate?: InputMaybe<Scalars['Float']['input']>;
  stayHostServiceFeeRate?: InputMaybe<Scalars['Float']['input']>;
}

export interface IUpdateTripFeeInput {
  amount?: InputMaybe<Scalars['Float']['input']>;
  chargeBy?: InputMaybe<TripFeeTypeEnums>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  rule?: InputMaybe<TripFeeRuleEnums>;
  uniqName: TripFeeUniqNameEnums;
  userId: Scalars['String']['input'];
}

export interface IUpdateUserInput {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isDealer?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  myWebUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  referralCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  shouldNotRedirectList?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface IUploadTripPhotoInput {
  bookingId: Scalars['String']['input'];
  imageType: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  photoTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface IUser {
  __typename?: 'User';
  acceptedTermsAt?: Maybe<Scalars['DateTime']['output']>;
  bookingmes?: Maybe<Array<IBooking>>;
  cars: Array<ICar>;
  cognitoId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated The host-website visibility rule is removed. */
  crossListingNearbyEnabled: Scalars['Boolean']['output'];
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dealer?: Maybe<IDealer>;
  dealers?: Maybe<Array<IDealer>>;
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailMarketingOptIn: Scalars['Boolean']['output'];
  fcmToken?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  generalVerifyDL?: Maybe<IGeneralVerifyDl>;
  /** Average rating as a guest (from host reviews) */
  guestAverageRating?: Maybe<Scalars['Float']['output']>;
  /** Total ratings received as a guest */
  guestTotalRatings?: Maybe<Scalars['Int']['output']>;
  /** @deprecated The host-website visibility rule is removed. */
  hiddenReferralHostIds?: Maybe<Array<Scalars['String']['output']>>;
  hostApplicationSiteUrl?: Maybe<Scalars['String']['output']>;
  /** Average rating as a host (from guest reviews) */
  hostAverageRating?: Maybe<Scalars['Float']['output']>;
  hostListingsSuspended: Scalars['Boolean']['output'];
  hostStatus: HostStatus;
  /** Total ratings received as a host */
  hostTotalRatings?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invoicesAsHost?: Maybe<Array<IInvoice>>;
  invoicesAsRequester?: Maybe<Array<IInvoice>>;
  isAdmin: Scalars['Boolean']['output'];
  isDealer?: Maybe<Scalars['Boolean']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isHost: Scalars['Boolean']['output'];
  isPhoneVerified: Scalars['Boolean']['output'];
  isPlatformOwner: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<ILocation>>;
  /** @deprecated Hosts no longer register websites; redirects follow Car.checkoutBrandSite. */
  myWebUrls?: Maybe<Array<Scalars['String']['output']>>;
  mybookings?: Maybe<Array<IBooking>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  protectionPlans?: Maybe<Array<IProtectionPlan>>;
  providers?: Maybe<Array<IUserProvider>>;
  /** @deprecated The referral percent is set by the checkout brand, not the host. */
  referralCommissionRate?: Maybe<Scalars['Float']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Hosts no longer register websites; redirects follow Car.checkoutBrandSite. */
  shouldNotRedirectList?: Maybe<Array<Scalars['String']['output']>>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  tripFees?: Maybe<Array<ITripFee>>;
  updatedAt: Scalars['DateTime']['output'];
}

export interface IUserProvider {
  __typename?: 'UserProvider';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  linkedAt: Scalars['DateTime']['output'];
  provider: Scalars['String']['output'];
  providerEmail?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: IUser;
  userId: Scalars['String']['output'];
}

export interface IUserReport {
  __typename?: 'UserReport';
  adminNotes?: Maybe<Scalars['String']['output']>;
  booking?: Maybe<IBooking>;
  chatId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  evidence: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  reason: Scalars['String']['output'];
  reportedUser: IUser;
  reporter: IUser;
  status: ReportStatus;
  updatedAt: Scalars['DateTime']['output'];
}

export enum VehicleClass {
  Car = 'CAR',
  Large = 'LARGE',
  Luxury = 'LUXURY',
  SuvTruck = 'SUV_TRUCK'
}

export enum VehicleEarningsStatus {
  Deleted = 'DELETED',
  Listed = 'LISTED',
  Unlisted = 'UNLISTED'
}

export interface IVehicleStatusOption {
  __typename?: 'VehicleStatusOption';
  label: Scalars['String']['output'];
  value: VehicleEarningsStatus;
}

export interface IWorkerAccount {
  __typename?: 'WorkerAccount';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inviteEmail?: Maybe<Scalars['String']['output']>;
  inviteExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  invitePhone?: Maybe<Scalars['String']['output']>;
  inviteUrl?: Maybe<Scalars['String']['output']>;
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  status: WorkerInviteStatus;
  userName?: Maybe<Scalars['String']['output']>;
  workerCarId: Scalars['ID']['output'];
}

export interface IWorkerBusyInterval {
  __typename?: 'WorkerBusyInterval';
  endAt: Scalars['Float']['output'];
  kind: Scalars['String']['output'];
  startAt: Scalars['Float']['output'];
}

export enum WorkerInviteStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Removed = 'REMOVED'
}

export interface IWorkerQuoteInput {
  addOns?: InputMaybe<Array<IAddOnChoiceInput>>;
  items: Array<IJobItemInput>;
  serviceDate: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['ID']['input']>;
  windowEnd: Scalars['String']['input'];
  windowStart: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
}

export interface IWorkerSearchResult {
  __typename?: 'WorkerSearchResult';
  bookable: Scalars['Boolean']['output'];
  car: ICar;
  distanceMiles: Scalars['Float']['output'];
  notBookableReason?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<IServiceQuote>;
  rangeStatus: RangeStatus;
  suppliesWarnings: Array<Scalars['String']['output']>;
  travelFee?: Maybe<Scalars['Float']['output']>;
  worker: IServiceWorker;
}

export interface IWorkerSettingsInput {
  acceptsOutOfRadius?: InputMaybe<Scalars['Boolean']['input']>;
  advanceNoticeHours?: InputMaybe<Scalars['Int']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  bufferHours?: InputMaybe<Scalars['Int']['input']>;
  confirmWindowHours?: InputMaybe<Scalars['Int']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  distanceUnit?: InputMaybe<Scalars['String']['input']>;
  instantBook?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  maxTravelMiles?: InputMaybe<Scalars['Int']['input']>;
  perMileBeyondRadius?: InputMaybe<Scalars['Float']['input']>;
  serviceRadiusMiles?: InputMaybe<Scalars['Int']['input']>;
  serviceZips?: InputMaybe<Array<Scalars['String']['input']>>;
  suppliesProvided?: InputMaybe<ISuppliesProvidedInput>;
  wizardStep?: InputMaybe<Scalars['String']['input']>;
  workingHours?: InputMaybe<Scalars['JSON']['input']>;
  yearsExperience?: InputMaybe<Scalars['Int']['input']>;
}

export enum WorkerSort {
  Distance = 'DISTANCE',
  Price = 'PRICE',
  Rating = 'RATING',
  Recommended = 'RECOMMENDED'
}

/** Yes, No, or Unknown response */
export enum YesNoUnknown {
  No = 'NO',
  Unknown = 'UNKNOWN',
  Yes = 'YES'
}
